// src/components/I18nProvider.tsx
import { I18nextProvider } from "react-i18next";

// src/i18n/index.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// src/i18n/locales/en.json
var en_default = {
  glob_navigation: {
    home: "Home",
    pricing: "Pricing",
    docs: "Docs",
    news: "News",
    more: "More",
    login: "Login",
    signup: "Sign Up",
    forms: "Forms",
    integrations: "Integrations",
    messages: "Messages",
    profile: "Profile",
    support: "Support",
    logout: "Logout",
    terms: "Terms",
    billing: "Billing",
    usageAndCredits: "Usage & Credits",
    subscriptions: "Subscriptions",
    referrals: "Referrals",
    apiKeys: "API Keys",
    chat: "Chat"
  },
  auth: {
    login: "Login",
    signup: "Signup",
    logout: "Logout",
    step1: "Step 1",
    step2: "Step 2",
    authenticate: "Authenticate",
    enterKey: "Identifier",
    newHere: "New here? ",
    howToSignup: "How-To Sign-Up",
    alreadyAccount: "If you don't already have an account, one will be created for you, the first time you login. ",
    emailSection: "Email Link",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Nostr Browser Plugin",
    signupDescription: "Get a link sent to your email, to login. ",
    googleDescription: "Login with your Google account. ",
    githubDescription: "Login with your GitHub account. ",
    microsoftDescription: "Login with your Microsoft account. ",
    nostrDescription: "Signup using a supported ",
    browserPlugin: "browser plugin",
    signupLoginEmail: "Login with Email.",
    signupLoginGoogle: "Login with Google",
    signupLoginGithub: "Login with GitHub",
    signupLoginMicrosoft: "Login with Microsoft",
    signupLoginNostr: "Login with Nostr"
  },
  login: {
    publicKeyRequired: "Public key is required",
    invalidEmail: "Invalid email",
    getPublicKey: "Get public key from extention",
    emailTab: "Email",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "Login with Email.",
    googleDescription: "Login with Google",
    nostrPluginDescription: "Login with Nos2x or similiar.",
    nostrKeyDescription: "Login with your private key.",
    nostrOtherDescription: "Provide signature via other means.",
    loadedPublicKey: "Loaded public key",
    noKeyLoaded: "No key loaded...",
    enterPublicKey: "Enter your public key",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "Email address",
    emailPlaceholder: "your-email@provider.com",
    enterCode: "Enter the code from the email",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "Enter your private key",
    challengeResponseLabel: "Enter your challenge response",
    emailInstructions: "Click the link in the Email, or copy the code and paste it here.",
    nostrInstructions: "Your Nostr extention should prompt you to sign an authentication event to contiue.",
    challenge: "Challenge: ",
    loginWithExtension: "Login with extention",
    redirectingGoogle: "Redirecting to Google...",
    redirectingGithub: "Redirecting to GitHub...",
    redirectingMicrosoft: "Redirecting to Microsoft...",
    githubNoChallenge: "Failed to get GitHub challenge",
    microsoftNoChallenge: "Failed to get Microsoft challenge",
    checkYourEmail: "Check your email for the login link",
    emailSent: "We've sent a login link to your email",
    clickLinkToLogin: "Click the link in the email to complete login",
    wrongEmail: "Wrong email? Try again",
    errorNotPrimaryEmail: "This email is not your primary account email.",
    errorDifferentAuthMethod: "This email is registered with a different authentication method",
    errorGoogleEmailNotVerified: "Google email not verified",
    errorInvalidAuthMethodGoogle: "This account uses Google login",
    errorInvalidAuthMethodGithub: "This account uses GitHub login",
    errorInvalidAuthMethodMicrosoft: "This account uses Microsoft login",
    errorInvalidAuthMethodNostr: "This account uses Nostr login",
    errorInvalidNostrSignature: "Invalid Nostr signature",
    errorNostrKeyMismatch: "Nostr key mismatch",
    errorOAuthFailed: "OAuth authentication failed",
    errorTokenExchange: "Failed to complete login. Please try again.",
    errorCodeExpired: "Login session expired. Please try logging in again.",
    invalidLoginResponse: "Invalid login response. Please try logging in again.",
    errorRateLimited: "Too many login attempts. Please wait {{seconds}} seconds and try again.",
    processing: "Processing login...",
    somethingWrong: "Something went wrong",
    invalidMagicLink: "Invalid magic link",
    noIdProvided: "No session ID provided",
    noChallengeProvided: "No challenge provided",
    back: "back",
    backToLogin: "Back to Login",
    cancel: "Cancel",
    submit: "Submit",
    loggingIn: "Logging in...",
    twoFactorAuth: "Two-Factor Authentication",
    twoFactorRequired: "Verification Required",
    enterTwoFactorCode: "Enter the 6-digit code from your authenticator app, or a recovery code.",
    verify: "Verify",
    useRecoveryCode: "You can also use a recovery code",
    invalid2FACode: "Invalid verification code. Please try again.",
    tooMany2FAAttempts: "Too many failed attempts. Please start over.",
    invalid2FASession: "Invalid or expired 2FA session."
  },
  glob_buttons: {
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    create: "Create",
    update: "Update",
    updateUnsaved: "Update (Unsaved changes)",
    delete: "Delete",
    calculate: "Calculate",
    login: "Login",
    back: "back"
  },
  support: {
    title: "Support",
    getHelp: "Get Help with {{serviceName}}",
    description: "Have a question or need assistance? We're here to help! Fill out the form below and we'll get back to you as soon as possible.",
    thankYou: "Thank You!",
    successMessage: "Your support request has been submitted successfully. We'll get back to you as soon as possible.",
    submitAnother: "Submit Another Request",
    successAlert: "Success!",
    successAlertMessage: "Your support request has been submitted successfully!",
    nameLabel: "Name (Optional)",
    namePlaceholder: "Your full name",
    emailLabel: "Email",
    emailPlaceholder: "your.email@example.com",
    loggedInEmail: "Using your logged-in email",
    subjectLabel: "Subject",
    subjectPlaceholder: "Select the type of your request",
    messageLabel: "Message",
    messagePlaceholder: "Please provide details about your question or issue...",
    formInfo: "This form will include your login method (",
    formInfoEnd: ") and user identifier to help us assist you better.",
    submitting: "Submitting...",
    submitButton: "Submit Support Request",
    types: {
      general: "General Question",
      technical: "Technical Question",
      feature: "Feature Request",
      bug: "Report a Bug"
    }
  },
  colorScheme: {
    lightMode: "Light mode (click for dark)",
    darkMode: "Dark mode (click for auto)",
    autoMode: "Auto mode (click for light)",
    toggle: "Toggle color scheme"
  },
  forms: {
    titleDescription: "Visible to recipients of autoresponder."
  },
  privacy: {
    title: "Privacy",
    backHome: "back home",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} GDPR compliant. Servers are located in Germany. "
  },
  terms: {
    title: "Terms of Service"
  },
  news: {
    title: "From our Blog",
    loading: "Loading ...",
    rssDescription: "You can subscribe to this Atom feed here "
  },
  profile: {
    balance: "Balance",
    addMoney: "Add Money",
    noBalanceFound: "No balance found.",
    depositSuccess: "Deposit success",
    depositSuccessMessage: "Your deposit was successful. Card payments should be applied within seconds.",
    wirePaymentInfo: "Want to pay by wire or Bitcoin? (\u20AC100+): ",
    personalInformation: "Personal Information",
    personalInfoMessage: "We don't really know all that much about you.",
    personalInfoContact: "Send an email to ",
    personalInfoGreeting: " to say hi.",
    emails: "Emails",
    loginInformation: "Login Information",
    currentlyLoggedIn: "You are currently logged in with ",
    saveKeysAlert: "Save these keys in your password manager or somewhere safe. We cannot recover them. You can use them to access the service from other devices, and login to our other services.",
    downloadKeys: "Download keys",
    publicKey: "Public Key",
    publicKeyDescription: "Your public key is what identifies you; We store it on our server.",
    privateKey: "Private Key",
    privateKeyDescription: "Your private key is what you use to login and never leaves your computer.",
    security: "Security",
    dataPrivacy: "Data & Privacy",
    dataPrivacyDescription: "Export your data or delete your account.",
    manageMyData: "Manage my data"
  },
  dataPrivacy: {
    title: "Data & Privacy",
    exportTitle: "Export your data",
    exportDescription: "Download a copy of all your personal data in JSON format.",
    exportButton: "Download my data",
    exporting: "Preparing export...",
    deleteTitle: "Delete account",
    deleteWarning: "This will permanently delete your account, all your forms, messages, files, and billing history. This action cannot be undone.",
    deleteConfirmation: "Type DELETE to confirm",
    deleteButton: "Delete my account",
    typeDelete: "Type DELETE to confirm",
    exportError: "Failed to export data. Please try again.",
    deleteError: "Failed to delete account. Please try again."
  },
  common: {
    copy: "Copy",
    copied: "Copied!",
    done: "Done",
    cancel: "Cancel"
  },
  twoFactor: {
    loading: "Loading 2FA status...",
    enabled: "Enabled",
    disabled: "Disabled",
    description: "Add an extra layer of security to your account by requiring a verification code in addition to your password.",
    enable: "Enable Two-Factor Authentication",
    setupTitle: "Set Up Authenticator",
    scanQRCode: "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)",
    cantScanQR: "Can't scan the QR code? Enter this secret manually:",
    next: "Next",
    verifySetup: "Verify Setup",
    enterCodeFromApp: "Enter the 6-digit code from your authenticator app to complete setup.",
    recoveryCodes: "Recovery Codes",
    saveRecoveryCodes: "Save these recovery codes in a safe place. You can use them to access your account if you lose your authenticator device. Each code can only be used once.",
    copyAllCodes: "Copy All Codes",
    recoveryCodesRemaining: "Recovery codes remaining",
    regenerateRecoveryCodes: "Regenerate Recovery Codes",
    regenerateWarning: "This will invalidate all existing recovery codes and generate new ones.",
    enterCodeToRegenerate: "Enter a code from your authenticator app to regenerate recovery codes.",
    regenerate: "Regenerate",
    disable2FA: "Disable Two-Factor Authentication",
    disableWarning: "Disabling 2FA will make your account less secure. You will only need your password to log in.",
    enterCodeToDisable: "Enter a code from your authenticator app or a recovery code to disable 2FA.",
    disable: "Disable"
  },
  emails: {
    accountEmail: "Account Email",
    accountEmailDescription: "This is your account email used for login and notifications, including low balance alerts.",
    makePrimary: "Make Primary",
    resendVerification: "Resend verification",
    verificationSent: "Verification email sent. Check your inbox.",
    accountEmailUpdated: "Account email updated successfully."
  },
  countries: {
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua and Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "\xC5land Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia and Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint Barth\xE9lemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivia",
    BQ: "Caribbean Netherlands",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos Islands",
    CD: "Democratic Republic of the Congo",
    CF: "Central African Republic",
    CG: "Republic of the Congo",
    CH: "Switzerland",
    CI: "C\xF4te d'Ivoire",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    CW: "Cura\xE7ao",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    FM: "Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia and the South Sandwich Islands",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HM: "Heard Island and McDonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "Saint Kitts and Nevis",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "Saint Martin",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "North Macedonia",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolia",
    MO: "Macao",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "Saint Pierre and Miquelon",
    PN: "Pitcairn",
    PR: "Puerto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "R\xE9union",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "Saint Helena",
    SI: "Slovenia",
    SJ: "Svalbard and Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "Sao Tome and Principe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syria",
    SZ: "Eswatini",
    TC: "Turks and Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Turkey",
    TT: "Trinidad and Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "United States Minor Outlying Islands",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Vatican City",
    VC: "Saint Vincent and the Grenadines",
    VE: "Venezuela",
    VG: "British Virgin Islands",
    VI: "U.S. Virgin Islands",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis and Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe"
  },
  glob_footer: {
    product: "Product",
    account: "Account"
  },
  glob_billing: {
    recentAccountMovements: "Recent Account Movements",
    loadingAccountMovements: "Loading account movements...",
    noAccountMovements: "No account movements found.",
    date: "Date",
    amount: "Amount",
    type: "Type",
    features: "Features",
    credit: "Credit",
    debit: "Debit",
    billingOverview: "Billing Overview",
    payAsYouGoCredits: "Pay-as-you-go Credits",
    noBalanceFound: "No balance found",
    addCredits: "Add Credits",
    hybridBillingModel: "Hybrid Billing Model",
    hybridBillingDescription: "When subscription allowances are exhausted, usage automatically falls back to pay-as-you-go credits. You'll never lose service - just additional usage beyond your plan limits.",
    yourReferralCode: "Your Referral Code",
    shareDirectLink: "Or share this direct signup link:",
    referralDescription: "When someone signs up with your referral link and makes their first subscription payment or deposit, you earn 10% of that amount, and they receive a 10% bonus.",
    copy: "Copy",
    copied: "Copied",
    copyLink: "Copy Link",
    linkCopied: "Link Copied",
    referralStatistics: "Referral Statistics",
    totalReferrals: "Total Referrals",
    totalEarnings: "Total Earnings",
    pendingEarnings: "Pending Earnings",
    recentReferrals: "Recent Referrals",
    firstPayment: "First Payment",
    bonus: "Bonus",
    status: "Status",
    processed: "Processed",
    pending: "Pending",
    bonusPaid: "Bonus Paid",
    awaitingBonus: "Awaiting Bonus",
    pendingPayment: "Pending Payment",
    noReferrals: "No referrals yet. Share your referral code to start earning commissions!",
    loadingReferralHistory: "Loading referral history...",
    loadingReferralInfo: "Loading referral information...",
    noActiveSubscription: "No Active Subscription",
    noActiveSubscriptionDescription: "You don't have an active subscription. You're using our pay-as-you-go billing model.",
    currentSubscription: "Current Subscription",
    plan: "Plan",
    periodStarted: "Period Started",
    nextBilling: "Next Billing",
    nextCycle: "Next Cycle",
    free: "Free",
    unlimited: "Unlimited",
    manageViaStripe: "Manage via Stripe",
    cancel: "Cancel"
  }
};

// src/i18n/locales/de.json
var de_default = {
  glob_navigation: {
    home: "Startseite",
    pricing: "Preise",
    docs: "Dokumentation",
    news: "Neuigkeiten",
    more: "Mehr",
    login: "Anmelden",
    signup: "Registrieren",
    forms: "Formulare",
    integrations: "Integrationen",
    messages: "Nachrichten",
    profile: "Profil",
    support: "Support",
    logout: "Abmelden",
    terms: "Nutzungsbedingungen",
    billing: "Abrechnung",
    usageAndCredits: "Nutzung & Guthaben",
    subscriptions: "Abonnements",
    referrals: "Empfehlungen",
    apiKeys: "API-Schl\xFCssel",
    chat: "Chat"
  },
  auth: {
    login: "Anmelden",
    signup: "Registrieren",
    logout: "Abmelden",
    step1: "Schritt 1",
    step2: "Schritt 2",
    authenticate: "Authentifizieren",
    enterKey: "Kennung",
    newHere: "Neu hier? ",
    howToSignup: "Registrierungs-Anleitung",
    alreadyAccount: "Falls Sie noch kein Konto haben, wird bei Ihrer ersten Anmeldung automatisch eines erstellt. ",
    emailSection: "E-Mail-Link",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Nostr Browser-Plugin",
    signupDescription: "Lassen Sie sich einen Anmelde-Link per E-Mail senden. ",
    googleDescription: "Melden Sie sich mit Ihrem Google-Konto an. ",
    githubDescription: "Melden Sie sich mit Ihrem GitHub-Konto an. ",
    microsoftDescription: "Melden Sie sich mit Ihrem Microsoft-Konto an. ",
    nostrDescription: "Registrieren Sie sich mit einem unterst\xFCtzten ",
    browserPlugin: "Browser-Plugin",
    signupLoginEmail: "Mit E-Mail anmelden.",
    signupLoginGoogle: "Mit Google anmelden",
    signupLoginGithub: "Mit GitHub anmelden",
    signupLoginMicrosoft: "Mit Microsoft anmelden",
    signupLoginNostr: "Mit Nostr anmelden"
  },
  login: {
    publicKeyRequired: "\xD6ffentlicher Schl\xFCssel ist erforderlich",
    invalidEmail: "Ung\xFCltige E-Mail",
    getPublicKey: "\xD6ffentlichen Schl\xFCssel aus Erweiterung",
    emailTab: "E-Mail",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "Mit E-Mail anmelden.",
    googleDescription: "Mit Google anmelden",
    nostrPluginDescription: "Mit Nos2x oder \xE4hnlichem anmelden.",
    nostrKeyDescription: "Mit Ihrem privaten Schl\xFCssel anmelden.",
    nostrOtherDescription: "Signatur auf anderem Weg bereitstellen.",
    loadedPublicKey: "\xD6ffentlicher Schl\xFCssel geladen",
    noKeyLoaded: "Kein Schl\xFCssel geladen...",
    enterPublicKey: "Geben Sie Ihren \xF6ffentlichen Schl\xFCssel ein",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "ihre-email@anbieter.com",
    enterCode: "Geben Sie den Code aus der E-Mail ein",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "Geben Sie Ihren privaten Schl\xFCssel ein",
    challengeResponseLabel: "Geben Sie Ihre Challenge-Antwort ein",
    emailInstructions: "Klicken Sie den Link in der E-Mail oder kopieren Sie den Code und f\xFCgen Sie ihn hier ein.",
    nostrInstructions: "Ihre Nostr-Erweiterung sollte Sie auffordern, ein Authentifizierungs-Event zu signieren.",
    challenge: "Challenge: ",
    loginWithExtension: "Fortfahren...",
    redirectingGoogle: "Weiterleitung zu Google...",
    redirectingGithub: "Weiterleitung zu GitHub...",
    redirectingMicrosoft: "Weiterleitung zu Microsoft...",
    githubNoChallenge: "GitHub-Challenge konnte nicht abgerufen werden",
    microsoftNoChallenge: "Microsoft-Challenge konnte nicht abgerufen werden",
    checkYourEmail: "\xDCberpr\xFCfen Sie Ihre E-Mail f\xFCr den Login-Link",
    emailSent: "Wir haben einen Login-Link an Ihre E-Mail gesendet",
    clickLinkToLogin: "Klicken Sie auf den Link in der E-Mail, um die Anmeldung abzuschlie\xDFen",
    wrongEmail: "Falsche E-Mail? Versuchen Sie es erneut",
    errorNotPrimaryEmail: "Diese E-Mail ist nicht Ihre prim\xE4re Konto-E-Mail.",
    errorDifferentAuthMethod: "Diese E-Mail ist mit einer anderen Authentifizierungsmethode registriert",
    errorGoogleEmailNotVerified: "Google-E-Mail nicht verifiziert",
    errorInvalidAuthMethodGoogle: "Dieses Konto verwendet Google-Anmeldung",
    errorInvalidAuthMethodGithub: "Dieses Konto verwendet GitHub-Anmeldung",
    errorInvalidAuthMethodMicrosoft: "Dieses Konto verwendet Microsoft-Anmeldung",
    errorInvalidAuthMethodNostr: "Dieses Konto verwendet Nostr-Anmeldung",
    errorInvalidNostrSignature: "Ung\xFCltige Nostr-Signatur",
    errorNostrKeyMismatch: "Nostr-Schl\xFCssel stimmt nicht \xFCberein",
    errorOAuthFailed: "OAuth-Authentifizierung fehlgeschlagen",
    errorTokenExchange: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    errorCodeExpired: "Anmeldesitzung abgelaufen. Bitte erneut einloggen.",
    invalidLoginResponse: "Ung\xFCltige Anmeldeantwort. Bitte erneut einloggen.",
    errorRateLimited: "Zu viele Anmeldeversuche. Bitte {{seconds}} Sekunden warten und erneut versuchen.",
    processing: "Anmeldung wird verarbeitet...",
    somethingWrong: "Etwas ist schief gelaufen",
    invalidMagicLink: "Ung\xFCltiger Magic-Link",
    noIdProvided: "Keine Sitzungs-ID angegeben",
    noChallengeProvided: "Keine Challenge angegeben",
    back: "zur\xFCck",
    cancel: "Abbrechen",
    submit: "Absenden",
    twoFactorAuth: "Zwei-Faktor-Authentifizierung",
    twoFactorRequired: "Verifizierung erforderlich",
    enterTwoFactorCode: "Geben Sie den 6-stelligen Code aus Ihrer Authentifizierungs-App oder einen Wiederherstellungscode ein.",
    verify: "\xDCberpr\xFCfen",
    useRecoveryCode: "Sie k\xF6nnen auch einen Wiederherstellungscode verwenden",
    invalid2FACode: "Ung\xFCltiger Verifizierungscode. Bitte versuchen Sie es erneut.",
    tooMany2FAAttempts: "Zu viele fehlgeschlagene Versuche. Bitte beginnen Sie erneut.",
    invalid2FASession: "Ung\xFCltige oder abgelaufene 2FA-Sitzung.",
    backToLogin: "Zur\xFCck zur Anmeldung"
  },
  glob_buttons: {
    save: "Speichern",
    cancel: "Abbrechen",
    submit: "Absenden",
    create: "Erstellen",
    update: "Aktualisieren",
    updateUnsaved: "Aktualisieren (Ungespeicherte \xC4nderungen)",
    delete: "L\xF6schen",
    calculate: "Berechnen",
    login: "Anmelden",
    back: "zur\xFCck"
  },
  support: {
    title: "Support",
    getHelp: "Hilfe bei {{serviceName}} erhalten",
    description: "Haben Sie eine Frage oder ben\xF6tigen Unterst\xFCtzung? Wir sind hier, um zu helfen! F\xFCllen Sie das folgende Formular aus und wir melden uns so schnell wie m\xF6glich bei Ihnen.",
    thankYou: "Vielen Dank!",
    successMessage: "Ihre Support-Anfrage wurde erfolgreich \xFCbermittelt. Wir melden uns so schnell wie m\xF6glich bei Ihnen.",
    submitAnother: "Weitere Anfrage stellen",
    successAlert: "Erfolg!",
    successAlertMessage: "Ihre Support-Anfrage wurde erfolgreich \xFCbermittelt!",
    nameLabel: "Name (Optional)",
    namePlaceholder: "Ihr vollst\xE4ndiger Name",
    emailLabel: "E-Mail",
    emailPlaceholder: "ihre.email@beispiel.com",
    loggedInEmail: "Ihre angemeldete E-Mail wird verwendet",
    subjectLabel: "Betreff",
    subjectPlaceholder: "W\xE4hlen Sie die Art Ihrer Anfrage",
    messageLabel: "Nachricht",
    messagePlaceholder: "Bitte geben Sie Details zu Ihrer Frage oder Ihrem Problem an...",
    formInfo: "Dieses Formular enth\xE4lt Ihre Anmeldemethode (",
    formInfoEnd: ") und Benutzerkennung, um Ihnen besser helfen zu k\xF6nnen.",
    submitting: "Wird \xFCbermittelt...",
    submitButton: "Support-Anfrage senden",
    types: {
      general: "Allgemeine Frage",
      technical: "Technische Frage",
      feature: "Feature-Anfrage",
      bug: "Fehler melden"
    }
  },
  colorScheme: {
    lightMode: "Heller Modus (f\xFCr dunkel klicken)",
    darkMode: "Dunkler Modus (f\xFCr automatisch klicken)",
    autoMode: "Automatischer Modus (f\xFCr hell klicken)",
    toggle: "Farbschema umschalten"
  },
  privacy: {
    title: "Datenschutz",
    backHome: "zur Startseite",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} DSGVO-konform. Server befinden sich in Deutschland. "
  },
  terms: {
    title: "Nutzungsbedingungen"
  },
  news: {
    title: "Aus unserem Blog",
    loading: "L\xE4dt ...",
    rssDescription: "Sie k\xF6nnen diesen Atom-Feed hier abonnieren "
  },
  profile: {
    balance: "Guthaben",
    addMoney: "Geld hinzuf\xFCgen",
    noBalanceFound: "Kein Guthaben gefunden.",
    depositSuccess: "Einzahlung erfolgreich",
    depositSuccessMessage: "Ihre Einzahlung war erfolgreich. Kartenzahlungen sollten innerhalb von Sekunden verbucht werden.",
    wirePaymentInfo: "Per \xDCberweisung oder Bitcoin zahlen? (\u20AC100+): ",
    personalInformation: "Pers\xF6nliche Informationen",
    personalInfoMessage: "Wir wissen eigentlich nicht sehr viel \xFCber Sie.",
    personalInfoContact: "Senden Sie eine E-Mail an ",
    personalInfoGreeting: " um Hallo zu sagen.",
    emails: "E-Mails",
    loginInformation: "Anmelde-Informationen",
    currentlyLoggedIn: "Sie sind derzeit angemeldet mit ",
    saveKeysAlert: "Speichern Sie diese Schl\xFCssel in Ihrem Passwort-Manager oder an einem sicheren Ort. Wir k\xF6nnen sie nicht wiederherstellen. Sie k\xF6nnen sie verwenden, um von anderen Ger\xE4ten auf den Service zuzugreifen und sich bei unseren anderen Services anzumelden.",
    downloadKeys: "Schl\xFCssel herunterladen",
    publicKey: "\xD6ffentlicher Schl\xFCssel",
    publicKeyDescription: "Ihr \xF6ffentlicher Schl\xFCssel identifiziert Sie; wir speichern ihn auf unserem Server.",
    privateKey: "Privater Schl\xFCssel",
    privateKeyDescription: "Ihr privater Schl\xFCssel wird f\xFCr die Anmeldung verwendet und verl\xE4sst niemals Ihren Computer.",
    security: "Sicherheit"
  },
  common: {
    copy: "Kopieren",
    copied: "Kopiert!",
    done: "Fertig",
    cancel: "Abbrechen"
  },
  twoFactor: {
    loading: "2FA-Status wird geladen...",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    description: "Erh\xF6hen Sie die Sicherheit Ihres Kontos durch einen Verifizierungscode zus\xE4tzlich zu Ihrem Passwort.",
    enable: "Zwei-Faktor-Authentifizierung aktivieren",
    setupTitle: "Zwei-Faktor-Authentifizierung einrichten",
    scanQRCode: "Scannen Sie diesen QR-Code mit Ihrer Authentifizierungs-App (z.B. Google Authenticator, Authy).",
    cantScanQR: "QR-Code nicht scannen? Geben Sie diesen geheimen Schl\xFCssel manuell ein:",
    next: "Weiter",
    verifySetup: "Einrichtung \xFCberpr\xFCfen",
    enterCodeFromApp: "Geben Sie den 6-stelligen Code aus Ihrer Authentifizierungs-App ein, um die Einrichtung zu best\xE4tigen.",
    recoveryCodes: "Wiederherstellungscodes",
    saveRecoveryCodes: "Speichern Sie diese Wiederherstellungscodes an einem sicheren Ort. Sie k\xF6nnen verwendet werden, um auf Ihr Konto zuzugreifen, wenn Sie den Zugang zu Ihrer Authentifizierungs-App verlieren.",
    copyAllCodes: "Alle Codes kopieren",
    recoveryCodesRemaining: "Verbleibende Wiederherstellungscodes",
    regenerateRecoveryCodes: "Wiederherstellungscodes neu generieren",
    regenerateWarning: "Dies macht alle bestehenden Wiederherstellungscodes ung\xFCltig und generiert neue.",
    enterCodeToRegenerate: "Geben Sie einen Code aus Ihrer Authentifizierungs-App ein, um die Wiederherstellungscodes neu zu generieren.",
    regenerate: "Neu generieren",
    disable2FA: "Zwei-Faktor-Authentifizierung deaktivieren",
    disableWarning: "Das Deaktivieren von 2FA macht Ihr Konto weniger sicher. Sie ben\xF6tigen nur noch Ihr Passwort zum Anmelden.",
    enterCodeToDisable: "Geben Sie einen Code aus Ihrer Authentifizierungs-App oder einen Wiederherstellungscode ein, um 2FA zu deaktivieren.",
    disable: "Deaktivieren"
  },
  emails: {
    accountEmail: "Konto-E-Mail",
    accountEmailDescription: "Dies ist Ihre Konto-E-Mail, die f\xFCr die Anmeldung und Benachrichtigungen verwendet wird, einschlie\xDFlich Benachrichtigungen \xFCber niedrige Guthaben.",
    makePrimary: "Als Prim\xE4r festlegen",
    resendVerification: "Best\xE4tigung erneut senden",
    verificationSent: "Best\xE4tigungs-E-Mail gesendet. \xDCberpr\xFCfen Sie Ihren Posteingang.",
    accountEmailUpdated: "Konto-E-Mail erfolgreich aktualisiert."
  },
  countries: {
    AD: "Andorra",
    AE: "Vereinigte Arabische Emirate",
    AF: "Afghanistan",
    AG: "Antigua und Barbuda",
    AI: "Anguilla",
    AL: "Albanien",
    AM: "Armenien",
    AO: "Angola",
    AQ: "Antarktis",
    AR: "Argentinien",
    AS: "Amerikanisch-Samoa",
    AT: "\xD6sterreich",
    AU: "Australien",
    AW: "Aruba",
    AX: "\xC5land-Inseln",
    AZ: "Aserbaidschan",
    BA: "Bosnien und Herzegowina",
    BB: "Barbados",
    BD: "Bangladesch",
    BE: "Belgien",
    BF: "Burkina Faso",
    BG: "Bulgarien",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint-Barth\xE9lemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivien",
    BQ: "Karibische Niederlande",
    BR: "Brasilien",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvetinsel",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Kanada",
    CC: "Kokosinseln",
    CD: "Demokratische Republik Kongo",
    CF: "Zentralafrikanische Republik",
    CG: "Republik Kongo",
    CH: "Schweiz",
    CI: "Elfenbeink\xFCste",
    CK: "Cookinseln",
    CL: "Chile",
    CM: "Kamerun",
    CN: "China",
    CO: "Kolumbien",
    CR: "Costa Rica",
    CU: "Kuba",
    CV: "Kap Verde",
    CW: "Cura\xE7ao",
    CX: "Weihnachtsinsel",
    CY: "Zypern",
    CZ: "Tschechische Republik",
    DE: "Deutschland",
    DJ: "Dschibuti",
    DK: "D\xE4nemark",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    DZ: "Algerien",
    EC: "Ecuador",
    EE: "Estland",
    EG: "\xC4gypten",
    EH: "Westsahara",
    ER: "Eritrea",
    ES: "Spanien",
    ET: "\xC4thiopien",
    FI: "Finnland",
    FJ: "Fidschi",
    FK: "Falklandinseln",
    FM: "Mikronesien",
    FO: "F\xE4r\xF6er",
    FR: "Frankreich",
    GA: "Gabun",
    GB: "Vereinigtes K\xF6nigreich",
    GD: "Grenada",
    GE: "Georgien",
    GF: "Franz\xF6sisch-Guayana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Gr\xF6nland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "\xC4quatorialguinea",
    GR: "Griechenland",
    GS: "S\xFCdgeorgien und die S\xFCdlichen Sandwichinseln",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hongkong",
    HM: "Heard und McDonaldinseln",
    HN: "Honduras",
    HR: "Kroatien",
    HT: "Haiti",
    HU: "Ungarn",
    ID: "Indonesien",
    IE: "Irland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "Indien",
    IO: "Britisches Territorium im Indischen Ozean",
    IQ: "Irak",
    IR: "Iran",
    IS: "Island",
    IT: "Italien",
    JE: "Jersey",
    JM: "Jamaika",
    JO: "Jordanien",
    JP: "Japan",
    KE: "Kenia",
    KG: "Kirgisistan",
    KH: "Kambodscha",
    KI: "Kiribati",
    KM: "Komoren",
    KN: "St. Kitts und Nevis",
    KP: "Nordkorea",
    KR: "S\xFCdkorea",
    KW: "Kuwait",
    KY: "Kaimaninseln",
    KZ: "Kasachstan",
    LA: "Laos",
    LB: "Libanon",
    LC: "St. Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Litauen",
    LU: "Luxemburg",
    LV: "Lettland",
    LY: "Libyen",
    MA: "Marokko",
    MC: "Monaco",
    MD: "Moldau",
    ME: "Montenegro",
    MF: "Saint-Martin",
    MG: "Madagaskar",
    MH: "Marshallinseln",
    MK: "Nordmazedonien",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolei",
    MO: "Macao",
    MP: "N\xF6rdliche Marianen",
    MQ: "Martinique",
    MR: "Mauretanien",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Malediven",
    MW: "Malawi",
    MX: "Mexiko",
    MY: "Malaysia",
    MZ: "Mosambik",
    NA: "Namibia",
    NC: "Neukaledonien",
    NE: "Niger",
    NF: "Norfolkinsel",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Niederlande",
    NO: "Norwegen",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "Neuseeland",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "Franz\xF6sisch-Polynesien",
    PG: "Papua-Neuguinea",
    PH: "Philippinen",
    PK: "Pakistan",
    PL: "Polen",
    PM: "St. Pierre und Miquelon",
    PN: "Pitcairninseln",
    PR: "Puerto Rico",
    PS: "Pal\xE4stina",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Katar",
    RE: "R\xE9union",
    RO: "Rum\xE4nien",
    RS: "Serbien",
    RU: "Russland",
    RW: "Ruanda",
    SA: "Saudi-Arabien",
    SB: "Salomonen",
    SC: "Seychellen",
    SD: "Sudan",
    SE: "Schweden",
    SG: "Singapur",
    SH: "St. Helena",
    SI: "Slowenien",
    SJ: "Spitzbergen und Jan Mayen",
    SK: "Slowakei",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "S\xFCdsudan",
    ST: "S\xE3o Tom\xE9 und Pr\xEDncipe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syrien",
    SZ: "Eswatini",
    TC: "Turks- und Caicosinseln",
    TD: "Tschad",
    TF: "Franz\xF6sische S\xFCd- und Antarktisgebiete",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tadschikistan",
    TK: "Tokelau",
    TL: "Osttimor",
    TM: "Turkmenistan",
    TN: "Tunesien",
    TO: "Tonga",
    TR: "T\xFCrkei",
    TT: "Trinidad und Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tansania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "Kleinere Inselbesitzungen der Vereinigten Staaten",
    US: "Vereinigte Staaten",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VA: "Vatikanstadt",
    VC: "St. Vincent und die Grenadinen",
    VE: "Venezuela",
    VG: "Britische Jungferninseln",
    VI: "Amerikanische Jungferninseln",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis und Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Jemen",
    YT: "Mayotte",
    ZA: "S\xFCdafrika",
    ZM: "Sambia",
    ZW: "Simbabwe"
  },
  glob_footer: {
    product: "Produkt",
    account: "Konto"
  },
  glob_billing: {
    recentAccountMovements: "Aktuelle Kontobewegungen",
    loadingAccountMovements: "Kontobewegungen werden geladen...",
    noAccountMovements: "Keine Kontobewegungen gefunden.",
    date: "Datum",
    amount: "Betrag",
    type: "Typ",
    features: "Funktionen",
    credit: "Gutschrift",
    debit: "Belastung",
    billingOverview: "Abrechnungs\xFCbersicht",
    payAsYouGoCredits: "Pay-as-you-go Guthaben",
    noBalanceFound: "Kein Guthaben gefunden",
    addCredits: "Guthaben hinzuf\xFCgen",
    hybridBillingModel: "Hybrides Abrechnungsmodell",
    hybridBillingDescription: "Wenn Abonnement-Kontingente aufgebraucht sind, wechselt die Nutzung automatisch zu Pay-as-you-go Guthaben. Sie verlieren nie den Service - nur zus\xE4tzliche Nutzung \xFCber Ihre Planlimits hinaus.",
    yourReferralCode: "Ihr Empfehlungscode",
    shareDirectLink: "Oder teilen Sie diesen direkten Anmeldelink:",
    referralDescription: "Wenn sich jemand \xFCber Ihren Empfehlungslink anmeldet und seine erste Abonnementzahlung oder Einzahlung t\xE4tigt, erhalten Sie 10% dieses Betrags und sie erhalten einen 10% Bonus.",
    copy: "Kopieren",
    copied: "Kopiert",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert",
    referralStatistics: "Empfehlungsstatistiken",
    totalReferrals: "Empfehlungen gesamt",
    totalEarnings: "Gesamteinnahmen",
    pendingEarnings: "Ausstehende Einnahmen",
    recentReferrals: "Aktuelle Empfehlungen",
    firstPayment: "Erste Zahlung",
    bonus: "Bonus",
    status: "Status",
    processed: "Verarbeitet",
    pending: "Ausstehend",
    bonusPaid: "Bonus bezahlt",
    awaitingBonus: "Wartet auf Bonus",
    pendingPayment: "Zahlung ausstehend",
    noReferrals: "Noch keine Empfehlungen. Teilen Sie Ihren Empfehlungscode, um Provisionen zu verdienen!",
    loadingReferralHistory: "Empfehlungshistorie wird geladen...",
    loadingReferralInfo: "Empfehlungsinformationen werden geladen...",
    noActiveSubscription: "Kein aktives Abonnement",
    noActiveSubscriptionDescription: "Sie haben kein aktives Abonnement. Sie nutzen unser Pay-as-you-go Abrechnungsmodell.",
    currentSubscription: "Aktuelles Abonnement",
    plan: "Plan",
    periodStarted: "Periode gestartet",
    nextBilling: "N\xE4chste Abrechnung",
    nextCycle: "N\xE4chster Zyklus",
    free: "Kostenlos",
    unlimited: "Unbegrenzt",
    manageViaStripe: "\xDCber Stripe verwalten",
    cancel: "Abbrechen"
  }
};

// src/i18n/locales/es.json
var es_default = {
  glob_navigation: {
    home: "Inicio",
    pricing: "Precios",
    docs: "Documentaci\xF3n",
    news: "Noticias",
    more: "M\xE1s",
    login: "Iniciar sesi\xF3n",
    signup: "Registrarse",
    forms: "Formularios",
    integrations: "Integraciones",
    messages: "Mensajes",
    profile: "Perfil",
    support: "Soporte",
    logout: "Cerrar sesi\xF3n",
    terms: "T\xE9rminos",
    billing: "Facturaci\xF3n",
    usageAndCredits: "Uso y cr\xE9ditos",
    subscriptions: "Suscripciones",
    referrals: "Referencias",
    apiKeys: "Claves API",
    chat: "Chat"
  },
  auth: {
    login: "Iniciar sesi\xF3n",
    signup: "Registrarse",
    logout: "Cerrar sesi\xF3n",
    step1: "Paso 1",
    step2: "Paso 2",
    authenticate: "Autenticar",
    enterKey: "Identificador",
    newHere: "\xBFNuevo aqu\xED? ",
    howToSignup: "C\xF3mo registrarse",
    alreadyAccount: "Si a\xFAn no tiene una cuenta, se crear\xE1 una para usted la primera vez que inicie sesi\xF3n. ",
    emailSection: "Enlace por email",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Plugin de navegador Nostr",
    signupDescription: "Reciba un enlace enviado a su email para iniciar sesi\xF3n. ",
    googleDescription: "Inicie sesi\xF3n con su cuenta de Google. ",
    githubDescription: "Inicie sesi\xF3n con su cuenta de GitHub. ",
    microsoftDescription: "Inicie sesi\xF3n con su cuenta de Microsoft. ",
    nostrDescription: "Reg\xEDstrese usando un ",
    browserPlugin: "plugin de navegador",
    signupLoginEmail: "Iniciar sesi\xF3n con email.",
    signupLoginGoogle: "Iniciar sesi\xF3n con Google",
    signupLoginGithub: "Iniciar sesi\xF3n con GitHub",
    signupLoginMicrosoft: "Iniciar sesi\xF3n con Microsoft",
    signupLoginNostr: "Iniciar sesi\xF3n con Nostr"
  },
  login: {
    publicKeyRequired: "Se requiere clave p\xFAblica",
    invalidEmail: "Email inv\xE1lido",
    getPublicKey: "Obtener clave p\xFAblica de la extensi\xF3n",
    emailTab: "Email",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "Iniciar sesi\xF3n con email.",
    googleDescription: "Iniciar sesi\xF3n con Google",
    nostrPluginDescription: "Iniciar sesi\xF3n con Nos2x o similar.",
    nostrKeyDescription: "Iniciar sesi\xF3n con su clave privada.",
    nostrOtherDescription: "Proporcionar firma por otros medios.",
    loadedPublicKey: "Clave p\xFAblica cargada",
    noKeyLoaded: "No se carg\xF3 ninguna clave...",
    enterPublicKey: "Ingrese su clave p\xFAblica",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "Direcci\xF3n de email",
    emailPlaceholder: "su-email@proveedor.com",
    enterCode: "Ingrese el c\xF3digo del email",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "Ingrese su clave privada",
    challengeResponseLabel: "Ingrese su respuesta al desaf\xEDo",
    emailInstructions: "Haga clic en el enlace del email, o copie el c\xF3digo y p\xE9guelo aqu\xED.",
    nostrInstructions: "Su extensi\xF3n Nostr deber\xEDa solicitarle firmar un evento de autenticaci\xF3n para continuar.",
    challenge: "Desaf\xEDo: ",
    loginWithExtension: "Iniciar sesi\xF3n con extensi\xF3n",
    redirectingGoogle: "Redirigiendo a Google...",
    redirectingGithub: "Redirigiendo a GitHub...",
    redirectingMicrosoft: "Redirigiendo a Microsoft...",
    githubNoChallenge: "Error al obtener el desaf\xEDo de GitHub",
    microsoftNoChallenge: "Error al obtener el desaf\xEDo de Microsoft",
    checkYourEmail: "Revisa tu correo electr\xF3nico para el enlace de inicio de sesi\xF3n",
    emailSent: "Hemos enviado un enlace de inicio de sesi\xF3n a tu correo electr\xF3nico",
    clickLinkToLogin: "Haz clic en el enlace del correo electr\xF3nico para completar el inicio de sesi\xF3n",
    wrongEmail: "\xBFCorreo electr\xF3nico incorrecto? Int\xE9ntalo de nuevo",
    errorNotPrimaryEmail: "Este correo electr\xF3nico no es tu correo electr\xF3nico principal de la cuenta.",
    errorDifferentAuthMethod: "Este correo electr\xF3nico est\xE1 registrado con un m\xE9todo de autenticaci\xF3n diferente",
    errorGoogleEmailNotVerified: "Correo de Google no verificado",
    errorInvalidAuthMethodGoogle: "Esta cuenta usa inicio de sesi\xF3n con Google",
    errorInvalidAuthMethodGithub: "Esta cuenta usa inicio de sesi\xF3n con GitHub",
    errorInvalidAuthMethodMicrosoft: "Esta cuenta usa inicio de sesi\xF3n con Microsoft",
    errorInvalidAuthMethodNostr: "Esta cuenta usa inicio de sesi\xF3n con Nostr",
    errorInvalidNostrSignature: "Firma Nostr inv\xE1lida",
    errorNostrKeyMismatch: "Las claves Nostr no coinciden",
    errorOAuthFailed: "Autenticaci\xF3n OAuth fallida",
    errorTokenExchange: "Error al completar el inicio de sesi\xF3n. Int\xE9ntalo de nuevo.",
    errorCodeExpired: "La sesi\xF3n de inicio expir\xF3. Inicia sesi\xF3n de nuevo.",
    invalidLoginResponse: "Respuesta de inicio de sesi\xF3n no v\xE1lida. Int\xE9ntalo de nuevo.",
    errorRateLimited: "Demasiados intentos de inicio de sesi\xF3n. Espera {{seconds}} segundos e int\xE9ntalo de nuevo.",
    processing: "Procesando inicio de sesi\xF3n...",
    somethingWrong: "Algo sali\xF3 mal",
    invalidMagicLink: "Enlace m\xE1gico inv\xE1lido",
    noIdProvided: "No se proporcion\xF3 ID de sesi\xF3n",
    noChallengeProvided: "No se proporcion\xF3 desaf\xEDo",
    back: "atr\xE1s",
    cancel: "Cancelar",
    submit: "Enviar"
  },
  glob_buttons: {
    save: "Guardar",
    cancel: "Cancelar",
    submit: "Enviar",
    create: "Crear",
    update: "Actualizar",
    updateUnsaved: "Actualizar (Cambios sin guardar)",
    delete: "Eliminar",
    calculate: "Calcular",
    login: "Iniciar sesi\xF3n",
    back: "atr\xE1s"
  },
  support: {
    title: "Soporte",
    getHelp: "Obtener ayuda con {{serviceName}}",
    description: "\xBFTiene una pregunta o necesita asistencia? \xA1Estamos aqu\xED para ayudar! Complete el formulario a continuaci\xF3n y nos pondremos en contacto con usted lo antes posible.",
    thankYou: "\xA1Gracias!",
    successMessage: "Su solicitud de soporte ha sido enviada exitosamente. Nos pondremos en contacto con usted lo antes posible.",
    submitAnother: "Enviar otra solicitud",
    successAlert: "\xA1\xC9xito!",
    successAlertMessage: "\xA1Su solicitud de soporte ha sido enviada exitosamente!",
    nameLabel: "Nombre (Opcional)",
    namePlaceholder: "Su nombre completo",
    emailLabel: "Email",
    emailPlaceholder: "su.email@ejemplo.com",
    loggedInEmail: "Usando su email de sesi\xF3n iniciada",
    subjectLabel: "Asunto",
    subjectPlaceholder: "Seleccione el tipo de su solicitud",
    messageLabel: "Mensaje",
    messagePlaceholder: "Por favor proporcione detalles sobre su pregunta o problema...",
    formInfo: "Este formulario incluir\xE1 su m\xE9todo de inicio de sesi\xF3n (",
    formInfoEnd: ") e identificador de usuario para ayudarle mejor.",
    submitting: "Enviando...",
    submitButton: "Enviar solicitud de soporte",
    types: {
      general: "Pregunta general",
      technical: "Pregunta t\xE9cnica",
      feature: "Solicitud de funcionalidad",
      bug: "Reportar un error"
    }
  },
  colorScheme: {
    lightMode: "Modo claro (clic para oscuro)",
    darkMode: "Modo oscuro (clic para autom\xE1tico)",
    autoMode: "Modo autom\xE1tico (clic para claro)",
    toggle: "Cambiar esquema de color"
  },
  privacy: {
    title: "Privacidad",
    backHome: "volver al inicio",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} Cumple con GDPR. Los servidores est\xE1n ubicados en Alemania. "
  },
  terms: {
    title: "T\xE9rminos de servicio"
  },
  news: {
    title: "Desde nuestro blog",
    loading: "Cargando ...",
    rssDescription: "Puede suscribirse a este feed Atom aqu\xED "
  },
  profile: {
    balance: "Saldo",
    addMoney: "Agregar dinero",
    noBalanceFound: "No se encontr\xF3 saldo.",
    depositSuccess: "Dep\xF3sito exitoso",
    depositSuccessMessage: "Su dep\xF3sito fue exitoso. Los pagos con tarjeta deber\xEDan aplicarse en segundos.",
    wirePaymentInfo: "\xBFQuiere pagar por transferencia o Bitcoin? (\u20AC100+): ",
    personalInformation: "Informaci\xF3n personal",
    personalInfoMessage: "En realidad no sabemos mucho sobre usted.",
    personalInfoContact: "Env\xEDe un email a ",
    personalInfoGreeting: " para saludar.",
    emails: "Emails",
    loginInformation: "Informaci\xF3n de inicio de sesi\xF3n",
    currentlyLoggedIn: "Actualmente ha iniciado sesi\xF3n con ",
    saveKeysAlert: "Guarde estas claves en su administrador de contrase\xF1as o en un lugar seguro. No podemos recuperarlas. Puede usarlas para acceder al servicio desde otros dispositivos e iniciar sesi\xF3n en nuestros otros servicios.",
    downloadKeys: "Descargar claves",
    publicKey: "Clave p\xFAblica",
    publicKeyDescription: "Su clave p\xFAblica es lo que le identifica; la almacenamos en nuestro servidor.",
    privateKey: "Clave privada",
    privateKeyDescription: "Su clave privada es lo que usa para iniciar sesi\xF3n y nunca sale de su computadora."
  },
  emails: {
    accountEmail: "Correo de la cuenta",
    accountEmailDescription: "Este es su correo de cuenta usado para iniciar sesi\xF3n y notificaciones, incluidas las alertas de saldo bajo.",
    makePrimary: "Establecer como principal",
    resendVerification: "Reenviar verificaci\xF3n",
    verificationSent: "Correo de verificaci\xF3n enviado. Revise su bandeja de entrada.",
    accountEmailUpdated: "Correo de la cuenta actualizado correctamente."
  },
  glob_footer: {
    product: "Producto",
    account: "Cuenta"
  },
  glob_billing: {
    recentAccountMovements: "Movimientos recientes de cuenta",
    loadingAccountMovements: "Cargando movimientos de cuenta...",
    noAccountMovements: "No se encontraron movimientos de cuenta.",
    date: "Fecha",
    amount: "Cantidad",
    type: "Tipo",
    features: "Caracter\xEDsticas",
    credit: "Cr\xE9dito",
    debit: "D\xE9bito",
    billingOverview: "Resumen de facturaci\xF3n",
    payAsYouGoCredits: "Cr\xE9ditos de pago por uso",
    noBalanceFound: "No se encontr\xF3 saldo",
    addCredits: "Agregar cr\xE9ditos",
    hybridBillingModel: "Modelo de facturaci\xF3n h\xEDbrida",
    hybridBillingDescription: "Cuando se agotan las asignaciones de suscripci\xF3n, el uso vuelve autom\xE1ticamente a los cr\xE9ditos de pago por uso. Nunca perder\xE1s el servicio - solo uso adicional m\xE1s all\xE1 de los l\xEDmites de tu plan.",
    yourReferralCode: "Tu c\xF3digo de referencia",
    shareDirectLink: "O comparte este enlace de registro directo:",
    referralDescription: "Cuando alguien se registra con tu enlace de referencia y realiza su primer pago de suscripci\xF3n o dep\xF3sito, ganas el 10% de esa cantidad, y ellos reciben un bono del 10%.",
    copy: "Copiar",
    copied: "Copiado",
    copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado",
    referralStatistics: "Estad\xEDsticas de referencia",
    totalReferrals: "Referencias totales",
    totalEarnings: "Ganancias totales",
    pendingEarnings: "Ganancias pendientes",
    recentReferrals: "Referencias recientes",
    firstPayment: "Primer pago",
    bonus: "Bono",
    status: "Estado",
    processed: "Procesado",
    pending: "Pendiente",
    bonusPaid: "Bono pagado",
    awaitingBonus: "Esperando bono",
    pendingPayment: "Pago pendiente",
    noReferrals: "A\xFAn no hay referencias. \xA1Comparte tu c\xF3digo de referencia para comenzar a ganar comisiones!",
    loadingReferralHistory: "Cargando historial de referencias...",
    loadingReferralInfo: "Cargando informaci\xF3n de referencia...",
    noActiveSubscription: "Sin suscripci\xF3n activa",
    noActiveSubscriptionDescription: "No tienes una suscripci\xF3n activa. Est\xE1s usando nuestro modelo de facturaci\xF3n de pago por uso.",
    currentSubscription: "Suscripci\xF3n actual",
    plan: "Plan",
    periodStarted: "Per\xEDodo iniciado",
    nextBilling: "Pr\xF3xima facturaci\xF3n",
    nextCycle: "Pr\xF3ximo ciclo",
    free: "Gratis",
    unlimited: "Ilimitado",
    manageViaStripe: "Gestionar v\xEDa Stripe",
    cancel: "Cancelar"
  }
};

// src/i18n/locales/fr.json
var fr_default = {
  glob_navigation: {
    home: "Accueil",
    pricing: "Tarifs",
    docs: "Documentation",
    news: "Actualit\xE9s",
    more: "Plus",
    login: "Se connecter",
    signup: "S'inscrire",
    forms: "Formulaires",
    integrations: "Int\xE9grations",
    messages: "Messages",
    profile: "Profil",
    support: "Support",
    logout: "Se d\xE9connecter",
    terms: "Conditions",
    billing: "Facturation",
    usageAndCredits: "Utilisation et cr\xE9dits",
    subscriptions: "Abonnements",
    referrals: "Parrainages",
    apiKeys: "Cl\xE9s API",
    chat: "Chat"
  },
  auth: {
    login: "Se connecter",
    signup: "S'inscrire",
    logout: "Se d\xE9connecter",
    step1: "\xC9tape 1",
    step2: "\xC9tape 2",
    authenticate: "Authentifier",
    enterKey: "Identifiant",
    newHere: "Nouveau ici ? ",
    howToSignup: "Comment s'inscrire",
    alreadyAccount: "Si vous n'avez pas encore de compte, un compte sera cr\xE9\xE9 pour vous lors de votre premi\xE8re connexion. ",
    emailSection: "Lien par email",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Plugin navigateur Nostr",
    signupDescription: "Recevez un lien envoy\xE9 \xE0 votre email pour vous connecter. ",
    googleDescription: "Connectez-vous avec votre compte Google. ",
    githubDescription: "Connectez-vous avec votre compte GitHub. ",
    microsoftDescription: "Connectez-vous avec votre compte Microsoft. ",
    nostrDescription: "Inscrivez-vous en utilisant un ",
    browserPlugin: "plugin de navigateur",
    signupLoginEmail: "Se connecter avec un email.",
    signupLoginGoogle: "Se connecter avec Google",
    signupLoginGithub: "Se connecter avec GitHub",
    signupLoginMicrosoft: "Se connecter avec Microsoft",
    signupLoginNostr: "Se connecter avec Nostr"
  },
  login: {
    publicKeyRequired: "Cl\xE9 publique requise",
    invalidEmail: "Email invalide",
    getPublicKey: "Obtenir la cl\xE9 publique depuis l'extension",
    emailTab: "Email",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "Se connecter avec un email.",
    googleDescription: "Se connecter avec Google",
    nostrPluginDescription: "Se connecter avec Nos2x ou similaire.",
    nostrKeyDescription: "Se connecter avec votre cl\xE9 priv\xE9e.",
    nostrOtherDescription: "Fournir la signature par d'autres moyens.",
    loadedPublicKey: "Cl\xE9 publique charg\xE9e",
    noKeyLoaded: "Aucune cl\xE9 charg\xE9e...",
    enterPublicKey: "Saisissez votre cl\xE9 publique",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "Adresse email",
    emailPlaceholder: "votre-email@fournisseur.com",
    enterCode: "Saisissez le code de l'email",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "Saisissez votre cl\xE9 priv\xE9e",
    challengeResponseLabel: "Saisissez votre r\xE9ponse au d\xE9fi",
    emailInstructions: "Cliquez sur le lien dans l'email, ou copiez le code et collez-le ici.",
    nostrInstructions: "Votre extension Nostr devrait vous demander de signer un \xE9v\xE9nement d'authentification pour continuer.",
    challenge: "D\xE9fi : ",
    loginWithExtension: "Se connecter avec l'extension",
    redirectingGoogle: "Redirection vers Google...",
    redirectingGithub: "Redirection vers GitHub...",
    redirectingMicrosoft: "Redirection vers Microsoft...",
    githubNoChallenge: "\xC9chec de l'obtention du d\xE9fi GitHub",
    microsoftNoChallenge: "\xC9chec de l'obtention du d\xE9fi Microsoft",
    checkYourEmail: "V\xE9rifiez votre email pour le lien de connexion",
    emailSent: "Nous avons envoy\xE9 un lien de connexion \xE0 votre email",
    clickLinkToLogin: "Cliquez sur le lien dans l'email pour terminer la connexion",
    wrongEmail: "Mauvais email ? R\xE9essayez",
    errorNotPrimaryEmail: "Cet email n'est pas votre email de compte principal.",
    errorDifferentAuthMethod: "Cet email est enregistr\xE9 avec une m\xE9thode d'authentification diff\xE9rente",
    errorGoogleEmailNotVerified: "Email Google non v\xE9rifi\xE9",
    errorInvalidAuthMethodGoogle: "Ce compte utilise la connexion Google",
    errorInvalidAuthMethodGithub: "Ce compte utilise la connexion GitHub",
    errorInvalidAuthMethodMicrosoft: "Ce compte utilise la connexion Microsoft",
    errorInvalidAuthMethodNostr: "Ce compte utilise la connexion Nostr",
    errorInvalidNostrSignature: "Signature Nostr invalide",
    errorNostrKeyMismatch: "Cl\xE9 Nostr incompatible",
    errorOAuthFailed: "\xC9chec de l'authentification OAuth",
    errorTokenExchange: "\xC9chec de la connexion. Veuillez r\xE9essayer.",
    errorCodeExpired: "Session de connexion expir\xE9e. Veuillez vous reconnecter.",
    invalidLoginResponse: "R\xE9ponse de connexion invalide. Veuillez vous reconnecter.",
    errorRateLimited: "Trop de tentatives de connexion. Veuillez patienter {{seconds}} secondes et r\xE9essayer.",
    processing: "Traitement de la connexion...",
    somethingWrong: "Quelque chose s'est mal pass\xE9",
    invalidMagicLink: "Lien magique invalide",
    noIdProvided: "Aucun ID de session fourni",
    noChallengeProvided: "Aucun d\xE9fi fourni",
    back: "retour",
    cancel: "Annuler",
    submit: "Soumettre"
  },
  glob_buttons: {
    save: "Enregistrer",
    cancel: "Annuler",
    submit: "Soumettre",
    create: "Cr\xE9er",
    update: "Mettre \xE0 jour",
    updateUnsaved: "Mettre \xE0 jour (Modifications non sauvegard\xE9es)",
    delete: "Supprimer",
    calculate: "Calculer",
    login: "Se connecter",
    back: "retour"
  },
  support: {
    title: "Support",
    getHelp: "Obtenir de l'aide avec {{serviceName}}",
    description: "Vous avez une question ou besoin d'assistance ? Nous sommes l\xE0 pour vous aider ! Remplissez le formulaire ci-dessous et nous vous r\xE9pondrons d\xE8s que possible.",
    thankYou: "Merci !",
    successMessage: "Votre demande de support a \xE9t\xE9 soumise avec succ\xE8s. Nous vous r\xE9pondrons d\xE8s que possible.",
    submitAnother: "Soumettre une autre demande",
    successAlert: "Succ\xE8s !",
    successAlertMessage: "Votre demande de support a \xE9t\xE9 soumise avec succ\xE8s !",
    nameLabel: "Nom (Optionnel)",
    namePlaceholder: "Votre nom complet",
    emailLabel: "Email",
    emailPlaceholder: "votre.email@exemple.com",
    loggedInEmail: "Utilisation de votre email de connexion",
    subjectLabel: "Sujet",
    subjectPlaceholder: "S\xE9lectionnez le type de votre demande",
    messageLabel: "Message",
    messagePlaceholder: "Veuillez fournir des d\xE9tails sur votre question ou probl\xE8me...",
    formInfo: "Ce formulaire inclura votre m\xE9thode de connexion (",
    formInfoEnd: ") et identifiant utilisateur pour mieux vous aider.",
    submitting: "Envoi en cours...",
    submitButton: "Soumettre la demande de support",
    types: {
      general: "Question g\xE9n\xE9rale",
      technical: "Question technique",
      feature: "Demande de fonctionnalit\xE9",
      bug: "Signaler un bug"
    }
  },
  colorScheme: {
    lightMode: "Mode clair (clic pour sombre)",
    darkMode: "Mode sombre (clic pour auto)",
    autoMode: "Mode automatique (clic pour clair)",
    toggle: "Basculer le sch\xE9ma de couleurs"
  },
  privacy: {
    title: "Confidentialit\xE9",
    backHome: "retour \xE0 l'accueil",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} Conforme RGPD. Les serveurs sont situ\xE9s en Allemagne. "
  },
  terms: {
    title: "Conditions de service"
  },
  news: {
    title: "De notre blog",
    loading: "Chargement ...",
    rssDescription: "Vous pouvez vous abonner \xE0 ce flux Atom ici "
  },
  profile: {
    balance: "Solde",
    addMoney: "Ajouter de l'argent",
    noBalanceFound: "Aucun solde trouv\xE9.",
    depositSuccess: "D\xE9p\xF4t r\xE9ussi",
    depositSuccessMessage: "Votre d\xE9p\xF4t a \xE9t\xE9 effectu\xE9 avec succ\xE8s. Les paiements par carte devraient \xEAtre appliqu\xE9s en quelques secondes.",
    wirePaymentInfo: "Vous souhaitez payer par virement ou Bitcoin ? (\u20AC100+) : ",
    personalInformation: "Informations personnelles",
    personalInfoMessage: "Nous ne savons vraiment pas grand-chose sur vous.",
    personalInfoContact: "Envoyez un email \xE0 ",
    personalInfoGreeting: " pour dire bonjour.",
    emails: "Emails",
    loginInformation: "Informations de connexion",
    currentlyLoggedIn: "Vous \xEAtes actuellement connect\xE9 avec ",
    saveKeysAlert: "Sauvegardez ces cl\xE9s dans votre gestionnaire de mots de passe ou dans un endroit s\xFBr. Nous ne pouvons pas les r\xE9cup\xE9rer. Vous pouvez les utiliser pour acc\xE9der au service depuis d'autres appareils et vous connecter \xE0 nos autres services.",
    downloadKeys: "T\xE9l\xE9charger les cl\xE9s",
    publicKey: "Cl\xE9 publique",
    publicKeyDescription: "Votre cl\xE9 publique est ce qui vous identifie ; nous la stockons sur notre serveur.",
    privateKey: "Cl\xE9 priv\xE9e",
    privateKeyDescription: "Votre cl\xE9 priv\xE9e est ce que vous utilisez pour vous connecter et ne quitte jamais votre ordinateur."
  },
  emails: {
    accountEmail: "E-mail du compte",
    accountEmailDescription: "Ceci est votre e-mail de compte utilis\xE9 pour la connexion et les notifications, y compris les alertes de solde faible.",
    makePrimary: "D\xE9finir comme principal",
    resendVerification: "Renvoyer la v\xE9rification",
    verificationSent: "E-mail de v\xE9rification envoy\xE9. V\xE9rifiez votre bo\xEEte de r\xE9ception.",
    accountEmailUpdated: "E-mail du compte mis \xE0 jour avec succ\xE8s."
  },
  glob_footer: {
    product: "Produit",
    account: "Compte"
  },
  glob_billing: {
    recentAccountMovements: "Mouvements de compte r\xE9cents",
    loadingAccountMovements: "Chargement des mouvements de compte...",
    noAccountMovements: "Aucun mouvement de compte trouv\xE9.",
    date: "Date",
    amount: "Montant",
    type: "Type",
    features: "Fonctionnalit\xE9s",
    credit: "Cr\xE9dit",
    debit: "D\xE9bit",
    billingOverview: "Aper\xE7u de facturation",
    payAsYouGoCredits: "Cr\xE9dits \xE0 la demande",
    noBalanceFound: "Aucun solde trouv\xE9",
    addCredits: "Ajouter des cr\xE9dits",
    hybridBillingModel: "Mod\xE8le de facturation hybride",
    hybridBillingDescription: "Lorsque les allocations d'abonnement sont \xE9puis\xE9es, l'utilisation bascule automatiquement sur les cr\xE9dits \xE0 la demande. Vous ne perdrez jamais le service - juste une utilisation suppl\xE9mentaire au-del\xE0 de vos limites de plan.",
    yourReferralCode: "Votre code de parrainage",
    shareDirectLink: "Ou partagez ce lien d'inscription direct :",
    referralDescription: "Lorsque quelqu'un s'inscrit avec votre lien de parrainage et effectue son premier paiement d'abonnement ou d\xE9p\xF4t, vous gagnez 10% de ce montant, et ils re\xE7oivent un bonus de 10%.",
    copy: "Copier",
    copied: "Copi\xE9",
    copyLink: "Copier le lien",
    linkCopied: "Lien copi\xE9",
    referralStatistics: "Statistiques de parrainage",
    totalReferrals: "Parrainages totaux",
    totalEarnings: "Gains totaux",
    pendingEarnings: "Gains en attente",
    recentReferrals: "Parrainages r\xE9cents",
    firstPayment: "Premier paiement",
    bonus: "Bonus",
    status: "Statut",
    processed: "Trait\xE9",
    pending: "En attente",
    bonusPaid: "Bonus pay\xE9",
    awaitingBonus: "En attente du bonus",
    pendingPayment: "Paiement en attente",
    noReferrals: "Aucun parrainage encore. Partagez votre code de parrainage pour commencer \xE0 gagner des commissions !",
    loadingReferralHistory: "Chargement de l'historique de parrainage...",
    loadingReferralInfo: "Chargement des informations de parrainage...",
    noActiveSubscription: "Aucun abonnement actif",
    noActiveSubscriptionDescription: "Vous n'avez pas d'abonnement actif. Vous utilisez notre mod\xE8le de facturation \xE0 la demande.",
    currentSubscription: "Abonnement actuel",
    plan: "Plan",
    periodStarted: "P\xE9riode commenc\xE9e",
    nextBilling: "Prochaine facturation",
    nextCycle: "Prochain cycle",
    free: "Gratuit",
    unlimited: "Illimit\xE9",
    manageViaStripe: "G\xE9rer via Stripe",
    cancel: "Annuler"
  }
};

// src/i18n/locales/pt.json
var pt_default = {
  glob_navigation: {
    home: "In\xEDcio",
    pricing: "Pre\xE7os",
    docs: "Documenta\xE7\xE3o",
    news: "Not\xEDcias",
    more: "Mais",
    login: "Entrar",
    signup: "Cadastrar",
    forms: "Formul\xE1rios",
    integrations: "Integra\xE7\xF5es",
    messages: "Mensagens",
    profile: "Perfil",
    support: "Suporte",
    logout: "Sair",
    terms: "Termos",
    billing: "Faturamento",
    usageAndCredits: "Uso e cr\xE9ditos",
    subscriptions: "Assinaturas",
    referrals: "Indica\xE7\xF5es",
    apiKeys: "Chaves API",
    chat: "Chat"
  },
  auth: {
    login: "Entrar",
    signup: "Cadastrar",
    logout: "Sair",
    step1: "Passo 1",
    step2: "Passo 2",
    authenticate: "Autenticar",
    enterKey: "Identificador",
    newHere: "Novo aqui? ",
    howToSignup: "Como se cadastrar",
    alreadyAccount: "Se voc\xEA ainda n\xE3o tem uma conta, uma ser\xE1 criada para voc\xEA na primeira vez que fizer login. ",
    emailSection: "Link por email",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Plugin do navegador Nostr",
    signupDescription: "Receba um link enviado para seu email para fazer login. ",
    googleDescription: "Fa\xE7a login com sua conta do Google. ",
    githubDescription: "Fa\xE7a login com sua conta do GitHub. ",
    microsoftDescription: "Fa\xE7a login com sua conta da Microsoft. ",
    nostrDescription: "Cadastre-se usando um ",
    browserPlugin: "plugin de navegador",
    signupLoginEmail: "Entrar com email.",
    signupLoginGoogle: "Entrar com Google",
    signupLoginGithub: "Entrar com GitHub",
    signupLoginMicrosoft: "Entrar com Microsoft",
    signupLoginNostr: "Entrar com Nostr"
  },
  login: {
    publicKeyRequired: "Chave p\xFAblica \xE9 obrigat\xF3ria",
    invalidEmail: "Email inv\xE1lido",
    getPublicKey: "Obter chave p\xFAblica da extens\xE3o",
    emailTab: "Email",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "Entrar com email.",
    googleDescription: "Entrar com Google",
    nostrPluginDescription: "Entrar com Nos2x ou similar.",
    nostrKeyDescription: "Entrar com sua chave privada.",
    nostrOtherDescription: "Fornecer assinatura por outros meios.",
    loadedPublicKey: "Chave p\xFAblica carregada",
    noKeyLoaded: "Nenhuma chave carregada...",
    enterPublicKey: "Digite sua chave p\xFAblica",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "Endere\xE7o de email",
    emailPlaceholder: "seu-email@provedor.com",
    enterCode: "Digite o c\xF3digo do email",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "Digite sua chave privada",
    challengeResponseLabel: "Digite sua resposta ao desafio",
    emailInstructions: "Clique no link do email, ou copie o c\xF3digo e cole aqui.",
    nostrInstructions: "Sua extens\xE3o Nostr deve solicitar que voc\xEA assine um evento de autentica\xE7\xE3o para continuar.",
    challenge: "Desafio: ",
    loginWithExtension: "Entrar com extens\xE3o",
    redirectingGoogle: "Redirecionando para o Google...",
    redirectingGithub: "Redirecionando para o GitHub...",
    redirectingMicrosoft: "Redirecionando para o Microsoft...",
    githubNoChallenge: "Falha ao obter o desafio do GitHub",
    microsoftNoChallenge: "Falha ao obter o desafio do Microsoft",
    checkYourEmail: "Verifique seu email para o link de login",
    emailSent: "Enviamos um link de login para seu email",
    clickLinkToLogin: "Clique no link no email para concluir o login",
    wrongEmail: "Email errado? Tente novamente",
    errorNotPrimaryEmail: "Este email n\xE3o \xE9 seu email principal da conta.",
    errorDifferentAuthMethod: "Este email est\xE1 registrado com um m\xE9todo de autentica\xE7\xE3o diferente",
    errorGoogleEmailNotVerified: "Email do Google n\xE3o verificado",
    errorInvalidAuthMethodGoogle: "Esta conta usa login com Google",
    errorInvalidAuthMethodGithub: "Esta conta usa login com GitHub",
    errorInvalidAuthMethodMicrosoft: "Esta conta usa login com Microsoft",
    errorInvalidAuthMethodNostr: "Esta conta usa login com Nostr",
    errorInvalidNostrSignature: "Assinatura Nostr inv\xE1lida",
    errorNostrKeyMismatch: "Chaves Nostr n\xE3o correspondem",
    errorOAuthFailed: "Falha na autentica\xE7\xE3o OAuth",
    errorTokenExchange: "Falha ao completar o login. Tente novamente.",
    errorCodeExpired: "Sess\xE3o de login expirada. Fa\xE7a login novamente.",
    invalidLoginResponse: "Resposta de login inv\xE1lida. Fa\xE7a login novamente.",
    errorRateLimited: "Muitas tentativas de login. Aguarde {{seconds}} segundos e tente novamente.",
    processing: "Processando login...",
    somethingWrong: "Algo deu errado",
    invalidMagicLink: "Link m\xE1gico inv\xE1lido",
    noIdProvided: "Nenhum ID de sess\xE3o fornecido",
    noChallengeProvided: "Nenhum desafio fornecido",
    back: "voltar",
    cancel: "Cancelar",
    submit: "Enviar",
    twoFactorAuth: "Autentica\xE7\xE3o de dois fatores",
    twoFactorRequired: "Verifica\xE7\xE3o necess\xE1ria",
    enterTwoFactorCode: "Digite o c\xF3digo de 6 d\xEDgitos do seu aplicativo autenticador ou um c\xF3digo de recupera\xE7\xE3o.",
    verify: "Verificar",
    useRecoveryCode: "Voc\xEA tamb\xE9m pode usar um c\xF3digo de recupera\xE7\xE3o",
    invalid2FACode: "C\xF3digo de verifica\xE7\xE3o inv\xE1lido. Por favor, tente novamente.",
    tooMany2FAAttempts: "Muitas tentativas falhas. Por favor, comece novamente.",
    invalid2FASession: "Sess\xE3o 2FA inv\xE1lida ou expirada.",
    backToLogin: "Voltar ao login"
  },
  glob_buttons: {
    save: "Salvar",
    cancel: "Cancelar",
    submit: "Enviar",
    create: "Criar",
    update: "Atualizar",
    updateUnsaved: "Atualizar (Altera\xE7\xF5es n\xE3o salvas)",
    delete: "Excluir",
    calculate: "Calcular",
    login: "Entrar",
    back: "voltar"
  },
  support: {
    title: "Suporte",
    getHelp: "Obter ajuda com {{serviceName}}",
    description: "Tem uma pergunta ou precisa de assist\xEAncia? Estamos aqui para ajudar! Preencha o formul\xE1rio abaixo e entraremos em contato o mais breve poss\xEDvel.",
    thankYou: "Obrigado!",
    successMessage: "Sua solicita\xE7\xE3o de suporte foi enviada com sucesso. Entraremos em contato o mais breve poss\xEDvel.",
    submitAnother: "Enviar outra solicita\xE7\xE3o",
    successAlert: "Sucesso!",
    successAlertMessage: "Sua solicita\xE7\xE3o de suporte foi enviada com sucesso!",
    nameLabel: "Nome (Opcional)",
    namePlaceholder: "Seu nome completo",
    emailLabel: "Email",
    emailPlaceholder: "seu.email@exemplo.com",
    loggedInEmail: "Usando seu email logado",
    subjectLabel: "Assunto",
    subjectPlaceholder: "Selecione o tipo da sua solicita\xE7\xE3o",
    messageLabel: "Mensagem",
    messagePlaceholder: "Por favor, forne\xE7a detalhes sobre sua pergunta ou problema...",
    formInfo: "Este formul\xE1rio incluir\xE1 seu m\xE9todo de login (",
    formInfoEnd: ") e identificador de usu\xE1rio para ajud\xE1-lo melhor.",
    submitting: "Enviando...",
    submitButton: "Enviar solicita\xE7\xE3o de suporte",
    types: {
      general: "Pergunta geral",
      technical: "Pergunta t\xE9cnica",
      feature: "Solicita\xE7\xE3o de funcionalidade",
      bug: "Reportar um bug"
    }
  },
  colorScheme: {
    lightMode: "Modo claro (clique para escuro)",
    darkMode: "Modo escuro (clique para autom\xE1tico)",
    autoMode: "Modo autom\xE1tico (clique para claro)",
    toggle: "Alternar esquema de cores"
  },
  privacy: {
    title: "Privacidade",
    backHome: "voltar ao in\xEDcio",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} Compat\xEDvel com GDPR. Servidores est\xE3o localizados na Alemanha. "
  },
  terms: {
    title: "Termos de servi\xE7o"
  },
  news: {
    title: "Do nosso blog",
    loading: "Carregando ...",
    rssDescription: "Voc\xEA pode se inscrever neste feed Atom aqui "
  },
  profile: {
    balance: "Saldo",
    addMoney: "Adicionar dinheiro",
    noBalanceFound: "Nenhum saldo encontrado.",
    depositSuccess: "Dep\xF3sito bem-sucedido",
    depositSuccessMessage: "Seu dep\xF3sito foi bem-sucedido. Pagamentos com cart\xE3o devem ser aplicados em segundos.",
    wirePaymentInfo: "Quer pagar por transfer\xEAncia ou Bitcoin? (\u20AC100+): ",
    personalInformation: "Informa\xE7\xF5es pessoais",
    personalInfoMessage: "N\xF3s realmente n\xE3o sabemos muito sobre voc\xEA.",
    personalInfoContact: "Envie um email para ",
    personalInfoGreeting: " para dizer oi.",
    emails: "Emails",
    loginInformation: "Informa\xE7\xF5es de login",
    currentlyLoggedIn: "Voc\xEA est\xE1 atualmente logado com ",
    saveKeysAlert: "Salve essas chaves em seu gerenciador de senhas ou em um local seguro. N\xE3o podemos recuper\xE1-las. Voc\xEA pode us\xE1-las para acessar o servi\xE7o de outros dispositivos e fazer login em nossos outros servi\xE7os.",
    downloadKeys: "Baixar chaves",
    publicKey: "Chave p\xFAblica",
    publicKeyDescription: "Sua chave p\xFAblica \xE9 o que te identifica; n\xF3s a armazenamos em nosso servidor.",
    privateKey: "Chave privada",
    privateKeyDescription: "Sua chave privada \xE9 o que voc\xEA usa para fazer login e nunca sai do seu computador.",
    security: "Seguran\xE7a"
  },
  common: {
    copy: "Copiar",
    copied: "Copiado!",
    done: "Conclu\xEDdo",
    cancel: "Cancelar"
  },
  twoFactor: {
    loading: "Carregando status 2FA...",
    enabled: "Ativado",
    disabled: "Desativado",
    description: "Adicione uma camada extra de seguran\xE7a \xE0 sua conta exigindo um c\xF3digo de verifica\xE7\xE3o al\xE9m da sua senha.",
    enable: "Ativar autentica\xE7\xE3o de dois fatores",
    setupTitle: "Configurar autentica\xE7\xE3o de dois fatores",
    scanQRCode: "Escaneie este c\xF3digo QR com seu aplicativo autenticador (ex: Google Authenticator, Authy).",
    cantScanQR: "N\xE3o consegue escanear o c\xF3digo QR? Insira esta chave secreta manualmente:",
    next: "Pr\xF3ximo",
    verifySetup: "Verificar configura\xE7\xE3o",
    enterCodeFromApp: "Digite o c\xF3digo de 6 d\xEDgitos do seu aplicativo autenticador para confirmar a configura\xE7\xE3o.",
    recoveryCodes: "C\xF3digos de recupera\xE7\xE3o",
    saveRecoveryCodes: "Salve estes c\xF3digos de recupera\xE7\xE3o em um local seguro. Eles podem ser usados para acessar sua conta se voc\xEA perder o acesso ao seu aplicativo autenticador.",
    copyAllCodes: "Copiar todos os c\xF3digos",
    recoveryCodesRemaining: "C\xF3digos de recupera\xE7\xE3o restantes",
    regenerateRecoveryCodes: "Regenerar c\xF3digos de recupera\xE7\xE3o",
    regenerateWarning: "Isso invalidar\xE1 todos os c\xF3digos de recupera\xE7\xE3o existentes e gerar\xE1 novos.",
    enterCodeToRegenerate: "Digite um c\xF3digo do seu aplicativo autenticador para regenerar os c\xF3digos de recupera\xE7\xE3o.",
    regenerate: "Regenerar",
    disable2FA: "Desativar autentica\xE7\xE3o de dois fatores",
    disableWarning: "Desativar 2FA tornar\xE1 sua conta menos segura. Voc\xEA precisar\xE1 apenas da sua senha para fazer login.",
    enterCodeToDisable: "Digite um c\xF3digo do seu aplicativo autenticador ou um c\xF3digo de recupera\xE7\xE3o para desativar 2FA.",
    disable: "Desativar"
  },
  emails: {
    accountEmail: "E-mail da conta",
    accountEmailDescription: "Este \xE9 seu e-mail de conta usado para login e notifica\xE7\xF5es, incluindo alertas de saldo baixo.",
    makePrimary: "Definir como principal",
    resendVerification: "Reenviar verifica\xE7\xE3o",
    verificationSent: "E-mail de verifica\xE7\xE3o enviado. Verifique sua caixa de entrada.",
    accountEmailUpdated: "E-mail da conta atualizado com sucesso."
  },
  glob_footer: {
    product: "Produto",
    account: "Conta"
  },
  glob_billing: {
    recentAccountMovements: "Movimentos recentes da conta",
    loadingAccountMovements: "Carregando movimentos da conta...",
    noAccountMovements: "Nenhum movimento de conta encontrado.",
    date: "Data",
    amount: "Valor",
    type: "Tipo",
    features: "Recursos",
    credit: "Cr\xE9dito",
    debit: "D\xE9bito",
    billingOverview: "Resumo de faturamento",
    payAsYouGoCredits: "Cr\xE9ditos pr\xE9-pagos",
    noBalanceFound: "Nenhum saldo encontrado",
    addCredits: "Adicionar cr\xE9ditos",
    hybridBillingModel: "Modelo de faturamento h\xEDbrido",
    hybridBillingDescription: "Quando as permiss\xF5es de assinatura s\xE3o esgotadas, o uso volta automaticamente para os cr\xE9ditos pr\xE9-pagos. Voc\xEA nunca perder\xE1 o servi\xE7o - apenas uso adicional al\xE9m dos limites do seu plano.",
    yourReferralCode: "Seu c\xF3digo de indica\xE7\xE3o",
    shareDirectLink: "Ou compartilhe este link de cadastro direto:",
    referralDescription: "Quando algu\xE9m se cadastra com seu link de indica\xE7\xE3o e faz o primeiro pagamento de assinatura ou dep\xF3sito, voc\xEA ganha 10% desse valor, e eles recebem um b\xF4nus de 10%.",
    copy: "Copiar",
    copied: "Copiado",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    referralStatistics: "Estat\xEDsticas de indica\xE7\xE3o",
    totalReferrals: "Indica\xE7\xF5es totais",
    totalEarnings: "Ganhos totais",
    pendingEarnings: "Ganhos pendentes",
    recentReferrals: "Indica\xE7\xF5es recentes",
    firstPayment: "Primeiro pagamento",
    bonus: "B\xF4nus",
    status: "Status",
    processed: "Processado",
    pending: "Pendente",
    bonusPaid: "B\xF4nus pago",
    awaitingBonus: "Aguardando b\xF4nus",
    pendingPayment: "Pagamento pendente",
    noReferrals: "Ainda n\xE3o h\xE1 indica\xE7\xF5es. Compartilhe seu c\xF3digo de indica\xE7\xE3o para come\xE7ar a ganhar comiss\xF5es!",
    loadingReferralHistory: "Carregando hist\xF3rico de indica\xE7\xF5es...",
    loadingReferralInfo: "Carregando informa\xE7\xF5es de indica\xE7\xE3o...",
    noActiveSubscription: "Nenhuma assinatura ativa",
    noActiveSubscriptionDescription: "Voc\xEA n\xE3o tem uma assinatura ativa. Voc\xEA est\xE1 usando nosso modelo de faturamento pr\xE9-pago.",
    currentSubscription: "Assinatura atual",
    plan: "Plano",
    periodStarted: "Per\xEDodo iniciado",
    nextBilling: "Pr\xF3xima cobran\xE7a",
    nextCycle: "Pr\xF3ximo ciclo",
    free: "Gr\xE1tis",
    unlimited: "Ilimitado",
    manageViaStripe: "Gerenciar via Stripe",
    cancel: "Cancelar"
  }
};

// src/i18n/locales/zh.json
var zh_default = {
  glob_navigation: {
    home: "\u9996\u9875",
    pricing: "\u4EF7\u683C",
    docs: "\u6587\u6863",
    news: "\u65B0\u95FB",
    more: "\u66F4\u591A",
    login: "\u767B\u5F55",
    signup: "\u6CE8\u518C",
    forms: "\u8868\u5355",
    integrations: "\u96C6\u6210",
    messages: "\u6D88\u606F",
    profile: "\u6863\u6848",
    support: "\u652F\u6301",
    logout: "\u767B\u51FA",
    terms: "\u6761\u6B3E",
    billing: "\u8D26\u5355",
    usageAndCredits: "\u7528\u91CF\u4E0E\u4F59\u989D",
    subscriptions: "\u8BA2\u9605",
    referrals: "\u63A8\u8350",
    apiKeys: "API\u5BC6\u94A5",
    chat: "\u804A\u5929"
  },
  auth: {
    login: "\u767B\u5F55",
    signup: "\u6CE8\u518C",
    logout: "\u767B\u51FA",
    step1: "\u6B65\u9AA4 1",
    step2: "\u6B65\u9AA4 2",
    authenticate: "\u9A8C\u8BC1",
    enterKey: "\u6807\u8BC6\u7B26",
    newHere: "\u65B0\u7528\u6237\uFF1F",
    howToSignup: "\u5982\u4F55\u6CE8\u518C",
    alreadyAccount: "\u5982\u679C\u60A8\u8FD8\u6CA1\u6709\u8D26\u6237\uFF0C\u6211\u4EEC\u4F1A\u5728\u60A8\u9996\u6B21\u767B\u5F55\u65F6\u4E3A\u60A8\u521B\u5EFA\u4E00\u4E2A\u3002",
    emailSection: "\u90AE\u4EF6\u94FE\u63A5",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "Nostr \u6D4F\u89C8\u5668\u63D2\u4EF6",
    signupDescription: "\u83B7\u53D6\u53D1\u9001\u5230\u60A8\u90AE\u7BB1\u7684\u767B\u5F55\u94FE\u63A5\u3002",
    googleDescription: "\u4F7F\u7528\u60A8\u7684 Google \u8D26\u6237\u767B\u5F55\u3002",
    githubDescription: "\u4F7F\u7528\u60A8\u7684 GitHub \u8D26\u6237\u767B\u5F55\u3002",
    microsoftDescription: "\u4F7F\u7528\u60A8\u7684 Microsoft \u8D26\u6237\u767B\u5F55\u3002",
    nostrDescription: "\u4F7F\u7528\u652F\u6301\u7684",
    browserPlugin: "\u6D4F\u89C8\u5668\u63D2\u4EF6",
    signupLoginEmail: "\u4F7F\u7528\u90AE\u7BB1\u767B\u5F55\u3002",
    signupLoginGoogle: "\u4F7F\u7528 Google \u767B\u5F55",
    signupLoginGithub: "\u4F7F\u7528 GitHub \u767B\u5F55",
    signupLoginMicrosoft: "\u4F7F\u7528 Microsoft \u767B\u5F55",
    signupLoginNostr: "\u4F7F\u7528 Nostr \u767B\u5F55"
  },
  login: {
    publicKeyRequired: "\u9700\u8981\u516C\u94A5",
    invalidEmail: "\u65E0\u6548\u90AE\u7BB1",
    getPublicKey: "\u4ECE\u6269\u5C55\u83B7\u53D6\u516C\u94A5",
    emailTab: "\u90AE\u7BB1",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "\u4F7F\u7528\u90AE\u7BB1\u767B\u5F55\u3002",
    googleDescription: "\u4F7F\u7528 Google \u767B\u5F55",
    nostrPluginDescription: "\u4F7F\u7528 Nos2x \u6216\u7C7B\u4F3C\u5DE5\u5177\u767B\u5F55\u3002",
    nostrKeyDescription: "\u4F7F\u7528\u60A8\u7684\u79C1\u94A5\u767B\u5F55\u3002",
    nostrOtherDescription: "\u901A\u8FC7\u5176\u4ED6\u65B9\u5F0F\u63D0\u4F9B\u7B7E\u540D\u3002",
    loadedPublicKey: "\u5DF2\u52A0\u8F7D\u516C\u94A5",
    noKeyLoaded: "\u672A\u52A0\u8F7D\u5BC6\u94A5...",
    enterPublicKey: "\u8F93\u5165\u60A8\u7684\u516C\u94A5",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "\u90AE\u7BB1\u5730\u5740",
    emailPlaceholder: "your-email@provider.com",
    enterCode: "\u8F93\u5165\u90AE\u4EF6\u4E2D\u7684\u4EE3\u7801",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "\u8F93\u5165\u60A8\u7684\u79C1\u94A5",
    challengeResponseLabel: "\u8F93\u5165\u60A8\u7684\u6311\u6218\u54CD\u5E94",
    emailInstructions: "\u70B9\u51FB\u90AE\u4EF6\u4E2D\u7684\u94FE\u63A5\uFF0C\u6216\u590D\u5236\u4EE3\u7801\u5E76\u7C98\u8D34\u5230\u8FD9\u91CC\u3002",
    nostrInstructions: "\u60A8\u7684 Nostr \u6269\u5C55\u5E94\u8BE5\u4F1A\u63D0\u793A\u60A8\u7B7E\u7F72\u8EAB\u4EFD\u9A8C\u8BC1\u4E8B\u4EF6\u4EE5\u7EE7\u7EED\u3002",
    challenge: "\u6311\u6218\uFF1A",
    loginWithExtension: "\u4F7F\u7528\u6269\u5C55\u767B\u5F55",
    redirectingGoogle: "\u6B63\u5728\u91CD\u5B9A\u5411\u5230 Google...",
    redirectingGithub: "\u6B63\u5728\u91CD\u5B9A\u5411\u5230 GitHub...",
    redirectingMicrosoft: "\u6B63\u5728\u91CD\u5B9A\u5411\u5230 Microsoft...",
    githubNoChallenge: "\u83B7\u53D6 GitHub \u6311\u6218\u5931\u8D25",
    microsoftNoChallenge: "\u83B7\u53D6 Microsoft \u6311\u6218\u5931\u8D25",
    checkYourEmail: "Check your email for the login link",
    emailSent: "We've sent a login link to your email",
    clickLinkToLogin: "Click the link in the email to complete login",
    wrongEmail: "Wrong email? Try again",
    errorNotPrimaryEmail: "This email is not your primary account email.",
    errorDifferentAuthMethod: "This email is registered with a different authentication method",
    errorGoogleEmailNotVerified: "Google email not verified",
    errorInvalidAuthMethodGoogle: "This account uses Google login",
    errorInvalidAuthMethodGithub: "This account uses GitHub login",
    errorInvalidAuthMethodMicrosoft: "This account uses Microsoft login",
    errorInvalidAuthMethodNostr: "This account uses Nostr login",
    errorInvalidNostrSignature: "Invalid Nostr signature",
    errorNostrKeyMismatch: "Nostr key mismatch",
    errorOAuthFailed: "OAuth authentication failed",
    errorTokenExchange: "\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002",
    errorCodeExpired: "\u767B\u5F55\u4F1A\u8BDD\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55\u3002",
    invalidLoginResponse: "\u65E0\u6548\u7684\u767B\u5F55\u54CD\u5E94\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55\u3002",
    errorRateLimited: "\u767B\u5F55\u5C1D\u8BD5\u8FC7\u591A\uFF0C\u8BF7\u7B49\u5F85 {{seconds}} \u79D2\u540E\u91CD\u8BD5\u3002",
    processing: "Processing login...",
    somethingWrong: "Something went wrong",
    invalidMagicLink: "Invalid magic link",
    noIdProvided: "No session ID provided",
    noChallengeProvided: "No challenge provided",
    back: "\u8FD4\u56DE",
    cancel: "\u53D6\u6D88",
    submit: "\u63D0\u4EA4"
  },
  glob_buttons: {
    save: "\u4FDD\u5B58",
    cancel: "\u53D6\u6D88",
    submit: "\u63D0\u4EA4",
    create: "\u521B\u5EFA",
    update: "\u66F4\u65B0",
    updateUnsaved: "\u66F4\u65B0\uFF08\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF09",
    delete: "\u5220\u9664",
    calculate: "\u8BA1\u7B97",
    login: "\u767B\u5F55",
    back: "\u8FD4\u56DE"
  },
  support: {
    title: "\u652F\u6301",
    getHelp: "\u83B7\u53D6 {{serviceName}} \u5E2E\u52A9",
    description: "\u6709\u95EE\u9898\u6216\u9700\u8981\u5E2E\u52A9\uFF1F\u6211\u4EEC\u5728\u8FD9\u91CC\u4E3A\u60A8\u670D\u52A1\uFF01\u8BF7\u586B\u5199\u4E0B\u9762\u7684\u8868\u5355\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u56DE\u590D\u60A8\u3002",
    thankYou: "\u8C22\u8C22\uFF01",
    successMessage: "\u60A8\u7684\u652F\u6301\u8BF7\u6C42\u5DF2\u6210\u529F\u63D0\u4EA4\u3002\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u56DE\u590D\u60A8\u3002",
    submitAnother: "\u63D0\u4EA4\u53E6\u4E00\u4E2A\u8BF7\u6C42",
    successAlert: "\u6210\u529F\uFF01",
    successAlertMessage: "\u60A8\u7684\u652F\u6301\u8BF7\u6C42\u5DF2\u6210\u529F\u63D0\u4EA4\uFF01",
    nameLabel: "\u59D3\u540D\uFF08\u53EF\u9009\uFF09",
    namePlaceholder: "\u60A8\u7684\u5168\u540D",
    emailLabel: "\u90AE\u7BB1",
    emailPlaceholder: "your.email@example.com",
    loggedInEmail: "\u4F7F\u7528\u60A8\u7684\u767B\u5F55\u90AE\u7BB1",
    subjectLabel: "\u4E3B\u9898",
    subjectPlaceholder: "\u9009\u62E9\u60A8\u7684\u8BF7\u6C42\u7C7B\u578B",
    messageLabel: "\u6D88\u606F",
    messagePlaceholder: "\u8BF7\u63D0\u4F9B\u5173\u4E8E\u60A8\u95EE\u9898\u7684\u8BE6\u7EC6\u4FE1\u606F...",
    formInfo: "\u6B64\u8868\u5355\u5C06\u5305\u542B\u60A8\u7684\u767B\u5F55\u65B9\u5F0F\uFF08",
    formInfoEnd: "\uFF09\u548C\u7528\u6237\u6807\u8BC6\u7B26\uFF0C\u4EE5\u4FBF\u66F4\u597D\u5730\u4E3A\u60A8\u63D0\u4F9B\u5E2E\u52A9\u3002",
    submitting: "\u63D0\u4EA4\u4E2D...",
    submitButton: "\u63D0\u4EA4\u652F\u6301\u8BF7\u6C42",
    types: {
      general: "\u4E00\u822C\u95EE\u9898",
      technical: "\u6280\u672F\u95EE\u9898",
      feature: "\u529F\u80FD\u8BF7\u6C42",
      bug: "\u62A5\u544A\u9519\u8BEF"
    }
  },
  colorScheme: {
    lightMode: "\u6D45\u8272\u6A21\u5F0F\uFF08\u70B9\u51FB\u5207\u6362\u6DF1\u8272\uFF09",
    darkMode: "\u6DF1\u8272\u6A21\u5F0F\uFF08\u70B9\u51FB\u5207\u6362\u81EA\u52A8\uFF09",
    autoMode: "\u81EA\u52A8\u6A21\u5F0F\uFF08\u70B9\u51FB\u5207\u6362\u6D45\u8272\uFF09",
    toggle: "\u5207\u6362\u989C\u8272\u65B9\u6848"
  },
  privacy: {
    title: "\u9690\u79C1",
    backHome: "\u8FD4\u56DE\u9996\u9875",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} \u7B26\u5408 GDPR\u3002\u670D\u52A1\u5668\u4F4D\u4E8E\u5FB7\u56FD\u3002"
  },
  terms: {
    title: "\u670D\u52A1\u6761\u6B3E"
  },
  news: {
    title: "\u6765\u81EA\u6211\u4EEC\u7684\u535A\u5BA2",
    loading: "\u52A0\u8F7D\u4E2D...",
    rssDescription: "\u60A8\u53EF\u4EE5\u5728\u8FD9\u91CC\u8BA2\u9605\u6B64 Atom \u8BA2\u9605\u6E90"
  },
  profile: {
    balance: "\u4F59\u989D",
    addMoney: "\u5145\u503C",
    noBalanceFound: "\u672A\u627E\u5230\u4F59\u989D\u3002",
    depositSuccess: "\u5145\u503C\u6210\u529F",
    depositSuccessMessage: "\u60A8\u7684\u5145\u503C\u5DF2\u6210\u529F\u3002\u94F6\u884C\u5361\u652F\u4ED8\u5E94\u5728\u51E0\u79D2\u949F\u5185\u5230\u8D26\u3002",
    wirePaymentInfo: "\u60F3\u8981\u901A\u8FC7\u6C47\u6B3E\u6216\u6BD4\u7279\u5E01\u4ED8\u6B3E\uFF1F\uFF08\u20AC100+\uFF09\uFF1A",
    personalInformation: "\u4E2A\u4EBA\u4FE1\u606F",
    personalInfoMessage: "\u6211\u4EEC\u5176\u5B9E\u5BF9\u60A8\u4E86\u89E3\u4E0D\u591A\u3002",
    personalInfoContact: "\u53D1\u9001\u90AE\u4EF6\u81F3",
    personalInfoGreeting: "\u6253\u4E2A\u62DB\u547C\u3002",
    emails: "\u90AE\u7BB1",
    loginInformation: "\u767B\u5F55\u4FE1\u606F",
    currentlyLoggedIn: "\u60A8\u5F53\u524D\u767B\u5F55\u65B9\u5F0F\uFF1A",
    saveKeysAlert: "\u5C06\u8FD9\u4E9B\u5BC6\u94A5\u4FDD\u5B58\u5728\u60A8\u7684\u5BC6\u7801\u7BA1\u7406\u5668\u6216\u5B89\u5168\u4F4D\u7F6E\u3002\u6211\u4EEC\u65E0\u6CD5\u6062\u590D\u5B83\u4EEC\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u5B83\u4EEC\u4ECE\u5176\u4ED6\u8BBE\u5907\u8BBF\u95EE\u670D\u52A1\uFF0C\u5E76\u767B\u5F55\u6211\u4EEC\u7684\u5176\u4ED6\u670D\u52A1\u3002",
    downloadKeys: "\u4E0B\u8F7D\u5BC6\u94A5",
    publicKey: "\u516C\u94A5",
    publicKeyDescription: "\u60A8\u7684\u516C\u94A5\u7528\u4E8E\u8BC6\u522B\u60A8\u7684\u8EAB\u4EFD\uFF1B\u6211\u4EEC\u5C06\u5176\u5B58\u50A8\u5728\u670D\u52A1\u5668\u4E0A\u3002",
    privateKey: "\u79C1\u94A5",
    privateKeyDescription: "\u60A8\u7684\u79C1\u94A5\u7528\u4E8E\u767B\u5F55\uFF0C\u6C38\u8FDC\u4E0D\u4F1A\u79BB\u5F00\u60A8\u7684\u8BA1\u7B97\u673A\u3002"
  },
  emails: {
    accountEmail: "\u8D26\u6237\u90AE\u7BB1",
    accountEmailDescription: "\u8FD9\u662F\u60A8\u7684\u8D26\u6237\u90AE\u7BB1\uFF0C\u7528\u4E8E\u767B\u5F55\u548C\u901A\u77E5\uFF0C\u5305\u62EC\u4F4E\u4F59\u989D\u63D0\u9192\u3002",
    makePrimary: "\u8BBE\u4E3A\u4E3B\u90AE\u7BB1",
    resendVerification: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1",
    verificationSent: "\u9A8C\u8BC1\u90AE\u4EF6\u5DF2\u53D1\u9001\u3002\u8BF7\u68C0\u67E5\u60A8\u7684\u6536\u4EF6\u7BB1\u3002",
    accountEmailUpdated: "\u8D26\u6237\u90AE\u7BB1\u66F4\u65B0\u6210\u529F\u3002"
  },
  glob_footer: {
    product: "\u4EA7\u54C1",
    account: "\u8D26\u6237"
  },
  glob_billing: {
    recentAccountMovements: "\u6700\u8FD1\u8D26\u6237\u53D8\u52A8",
    loadingAccountMovements: "\u6B63\u5728\u52A0\u8F7D\u8D26\u6237\u53D8\u52A8...",
    noAccountMovements: "\u672A\u627E\u5230\u8D26\u6237\u53D8\u52A8\u3002",
    date: "\u65E5\u671F",
    amount: "\u91D1\u989D",
    type: "\u7C7B\u578B",
    features: "\u529F\u80FD",
    credit: "\u6536\u5165",
    debit: "\u652F\u51FA",
    billingOverview: "\u8D26\u5355\u6982\u89C8",
    payAsYouGoCredits: "\u6309\u9700\u4ED8\u8D39\u79EF\u5206",
    noBalanceFound: "\u672A\u627E\u5230\u4F59\u989D",
    addCredits: "\u6DFB\u52A0\u79EF\u5206",
    hybridBillingModel: "\u6DF7\u5408\u8BA1\u8D39\u6A21\u5F0F",
    hybridBillingDescription: "\u5F53\u8BA2\u9605\u989D\u5EA6\u7528\u5C3D\u65F6\uFF0C\u4F7F\u7528\u4F1A\u81EA\u52A8\u56DE\u843D\u5230\u6309\u9700\u4ED8\u8D39\u79EF\u5206\u3002\u60A8\u6C38\u8FDC\u4E0D\u4F1A\u5931\u53BB\u670D\u52A1 - \u53EA\u662F\u8D85\u51FA\u8BA1\u5212\u9650\u5236\u7684\u989D\u5916\u4F7F\u7528\u3002",
    yourReferralCode: "\u60A8\u7684\u63A8\u8350\u7801",
    shareDirectLink: "\u6216\u5206\u4EAB\u6B64\u76F4\u63A5\u6CE8\u518C\u94FE\u63A5\uFF1A",
    referralDescription: "\u5F53\u6709\u4EBA\u901A\u8FC7\u60A8\u7684\u63A8\u8350\u94FE\u63A5\u6CE8\u518C\u5E76\u5B8C\u6210\u9996\u6B21\u8BA2\u9605\u4ED8\u6B3E\u6216\u5145\u503C\u65F6\uFF0C\u60A8\u53EF\u4EE5\u83B7\u5F97\u8BE5\u91D1\u989D\u768410%\uFF0C\u4ED6\u4EEC\u4E5F\u4F1A\u83B7\u5F9710%\u7684\u5956\u52B1\u3002",
    copy: "\u590D\u5236",
    copied: "\u5DF2\u590D\u5236",
    copyLink: "\u590D\u5236\u94FE\u63A5",
    linkCopied: "\u94FE\u63A5\u5DF2\u590D\u5236",
    referralStatistics: "\u63A8\u8350\u7EDF\u8BA1",
    totalReferrals: "\u603B\u63A8\u8350\u6570",
    totalEarnings: "\u603B\u6536\u76CA",
    pendingEarnings: "\u5F85\u5904\u7406\u6536\u76CA",
    recentReferrals: "\u6700\u8FD1\u63A8\u8350",
    firstPayment: "\u9996\u6B21\u4ED8\u6B3E",
    bonus: "\u5956\u52B1",
    status: "\u72B6\u6001",
    processed: "\u5DF2\u5904\u7406",
    pending: "\u5F85\u5904\u7406",
    bonusPaid: "\u5956\u52B1\u5DF2\u652F\u4ED8",
    awaitingBonus: "\u7B49\u5F85\u5956\u52B1",
    pendingPayment: "\u5F85\u4ED8\u6B3E",
    noReferrals: "\u5C1A\u672A\u6709\u63A8\u8350\u3002\u5206\u4EAB\u60A8\u7684\u63A8\u8350\u7801\u5F00\u59CB\u8D5A\u53D6\u4F63\u91D1\uFF01",
    loadingReferralHistory: "\u6B63\u5728\u52A0\u8F7D\u63A8\u8350\u5386\u53F2...",
    loadingReferralInfo: "\u6B63\u5728\u52A0\u8F7D\u63A8\u8350\u4FE1\u606F...",
    noActiveSubscription: "\u65E0\u6D3B\u8DC3\u8BA2\u9605",
    noActiveSubscriptionDescription: "\u60A8\u6CA1\u6709\u6D3B\u8DC3\u7684\u8BA2\u9605\u3002\u60A8\u6B63\u5728\u4F7F\u7528\u6211\u4EEC\u7684\u6309\u9700\u4ED8\u8D39\u8BA1\u8D39\u6A21\u5F0F\u3002",
    currentSubscription: "\u5F53\u524D\u8BA2\u9605",
    plan: "\u8BA1\u5212",
    periodStarted: "\u5468\u671F\u5F00\u59CB",
    nextBilling: "\u4E0B\u6B21\u8BA1\u8D39",
    nextCycle: "\u4E0B\u4E2A\u5468\u671F",
    free: "\u514D\u8D39",
    unlimited: "\u65E0\u9650\u5236",
    manageViaStripe: "\u901A\u8FC7Stripe\u7BA1\u7406",
    cancel: "\u53D6\u6D88"
  }
};

// src/i18n/locales/th.json
var th_default = {
  glob_navigation: {
    home: "\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01",
    pricing: "\u0E23\u0E32\u0E04\u0E32",
    docs: "\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23",
    news: "\u0E02\u0E48\u0E32\u0E27\u0E2A\u0E32\u0E23",
    more: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    login: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    signup: "\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
    forms: "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    integrations: "\u0E01\u0E32\u0E23\u0E23\u0E27\u0E21\u0E23\u0E30\u0E1A\u0E1A",
    messages: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
    profile: "\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
    support: "\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    logout: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    terms: "\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02",
    billing: "\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19",
    usageAndCredits: "\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15",
    subscriptions: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
    referrals: "\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33",
    apiKeys: "\u0E04\u0E35\u0E22\u0E4C API",
    chat: "\u0E41\u0E0A\u0E17"
  },
  auth: {
    login: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    signup: "\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
    logout: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    step1: "\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E35\u0E48 1",
    step2: "\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E35\u0E48 2",
    authenticate: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19",
    enterKey: "\u0E15\u0E31\u0E27\u0E23\u0E30\u0E1A\u0E38",
    newHere: "\u0E43\u0E2B\u0E21\u0E48\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48? ",
    howToSignup: "\u0E27\u0E34\u0E18\u0E35\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01",
    alreadyAccount: "\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35 \u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E43\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E41\u0E23\u0E01\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A ",
    emailSection: "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2D\u0E35\u0E40\u0E21\u0E25",
    googleSection: "Google",
    githubSection: "GitHub",
    microsoftSection: "Microsoft",
    nostrSection: "\u0E1B\u0E25\u0E31\u0E4A\u0E01\u0E2D\u0E34\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C Nostr",
    signupDescription: "\u0E23\u0E31\u0E1A\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A ",
    googleDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Google \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 ",
    githubDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E0D\u0E0A\u0E35 GitHub \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 ",
    microsoftDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Microsoft \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 ",
    nostrDescription: "\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49",
    browserPlugin: "\u0E1B\u0E25\u0E31\u0E4A\u0E01\u0E2D\u0E34\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C",
    signupLoginEmail: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E2D\u0E35\u0E40\u0E21\u0E25",
    signupLoginGoogle: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google",
    signupLoginGithub: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 GitHub",
    signupLoginMicrosoft: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Microsoft",
    signupLoginNostr: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Nostr"
  },
  login: {
    publicKeyRequired: "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    invalidEmail: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    getPublicKey: "\u0E23\u0E31\u0E1A\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E08\u0E32\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
    emailTab: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    googleTab: "Google",
    githubTab: "GitHub",
    microsoftTab: "Microsoft",
    nostrTab: "Nostr",
    emailDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E2D\u0E35\u0E40\u0E21\u0E25",
    googleDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Google",
    nostrPluginDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22 Nos2x \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E25\u0E49\u0E32\u0E22\u0E01\u0E31\u0E19",
    nostrKeyDescription: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    nostrOtherDescription: "\u0E43\u0E2B\u0E49\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E27\u0E34\u0E18\u0E35\u0E2D\u0E37\u0E48\u0E19",
    loadedPublicKey: "\u0E42\u0E2B\u0E25\u0E14\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E41\u0E25\u0E49\u0E27",
    noKeyLoaded: "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E42\u0E2B\u0E25\u0E14\u0E04\u0E35\u0E22\u0E4C...",
    enterPublicKey: "\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
    emailPlaceholder: "your-email@provider.com",
    enterCode: "\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E08\u0E32\u0E01\u0E2D\u0E35\u0E40\u0E21\u0E25",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    challengeResponseLabel: "\u0E1B\u0E49\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E2A\u0E19\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    emailInstructions: "\u0E04\u0E25\u0E34\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E43\u0E19\u0E2D\u0E35\u0E40\u0E21\u0E25 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E25\u0E30\u0E27\u0E32\u0E07\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    nostrInstructions: "\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Nostr \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E04\u0E27\u0E23\u0E41\u0E08\u0E49\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E25\u0E07\u0E19\u0E32\u0E21\u0E43\u0E19\u0E40\u0E2B\u0E15\u0E38\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E31\u0E27\u0E15\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D",
    challenge: "\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22: ",
    loginWithExtension: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
    redirectingGoogle: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Google...",
    redirectingGithub: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 GitHub...",
    redirectingMicrosoft: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Microsoft...",
    githubNoChallenge: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E08\u0E32\u0E01 GitHub \u0E44\u0E14\u0E49",
    microsoftNoChallenge: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22\u0E08\u0E32\u0E01 Microsoft \u0E44\u0E14\u0E49",
    checkYourEmail: "Check your email for the login link",
    emailSent: "We've sent a login link to your email",
    clickLinkToLogin: "Click the link in the email to complete login",
    wrongEmail: "Wrong email? Try again",
    errorNotPrimaryEmail: "This email is not your primary account email.",
    errorDifferentAuthMethod: "This email is registered with a different authentication method",
    errorGoogleEmailNotVerified: "Google email not verified",
    errorInvalidAuthMethodGoogle: "This account uses Google login",
    errorInvalidAuthMethodGithub: "This account uses GitHub login",
    errorInvalidAuthMethodMicrosoft: "This account uses Microsoft login",
    errorInvalidAuthMethodNostr: "This account uses Nostr login",
    errorInvalidNostrSignature: "Invalid Nostr signature",
    errorNostrKeyMismatch: "Nostr key mismatch",
    errorOAuthFailed: "OAuth authentication failed",
    errorTokenExchange: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    errorCodeExpired: "\u0E40\u0E0B\u0E2A\u0E0A\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    invalidLoginResponse: "\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    errorRateLimited: "\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E21\u0E32\u0E01\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D {{seconds}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    processing: "Processing login...",
    somethingWrong: "Something went wrong",
    invalidMagicLink: "Invalid magic link",
    noIdProvided: "No session ID provided",
    noChallengeProvided: "No challenge provided",
    back: "\u0E01\u0E25\u0E31\u0E1A",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    submit: "\u0E2A\u0E48\u0E07"
  },
  glob_buttons: {
    save: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    submit: "\u0E2A\u0E48\u0E07",
    create: "\u0E2A\u0E23\u0E49\u0E32\u0E07",
    update: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15",
    updateUnsaved: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 (\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01)",
    delete: "\u0E25\u0E1A",
    calculate: "\u0E04\u0E33\u0E19\u0E27\u0E13",
    login: "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    back: "\u0E01\u0E25\u0E31\u0E1A"
  },
  support: {
    title: "\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    getHelp: "\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E08\u0E32\u0E01 {{serviceName}}",
    description: "\u0E21\u0E35\u0E04\u0E33\u0E16\u0E32\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E27\u0E32\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D? \u0E40\u0E23\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D! \u0E01\u0E23\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E01\u0E25\u0E31\u0E1A\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
    thankYou: "\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13!",
    successMessage: "\u0E04\u0E33\u0E02\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E23\u0E32\u0E08\u0E30\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E01\u0E25\u0E31\u0E1A\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
    submitAnother: "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E2D\u0E37\u0E48\u0E19",
    successAlert: "\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08!",
    successAlertMessage: "\u0E04\u0E33\u0E02\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27!",
    nameLabel: "\u0E0A\u0E37\u0E48\u0E2D (\u0E44\u0E21\u0E48\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A)",
    namePlaceholder: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E15\u0E47\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    emailLabel: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    emailPlaceholder: "your.email@example.com",
    loggedInEmail: "\u0E43\u0E0A\u0E49\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    subjectLabel: "\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07",
    subjectPlaceholder: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    messageLabel: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21",
    messagePlaceholder: "\u0E42\u0E1B\u0E23\u0E14\u0E43\u0E2B\u0E49\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13...",
    formInfo: "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E23\u0E27\u0E21\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 (",
    formInfoEnd: ") \u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E23\u0E30\u0E1A\u0E38\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E14\u0E35\u0E02\u0E36\u0E49\u0E19",
    submitting: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07...",
    submitButton: "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    types: {
      general: "\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
      technical: "\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E32\u0E07\u0E40\u0E17\u0E04\u0E19\u0E34\u0E04",
      feature: "\u0E04\u0E33\u0E02\u0E2D\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C",
      bug: "\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14"
    }
  },
  colorScheme: {
    lightMode: "\u0E42\u0E2B\u0E21\u0E14\u0E2A\u0E27\u0E48\u0E32\u0E07 (\u0E04\u0E25\u0E34\u0E01\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E2B\u0E21\u0E14\u0E21\u0E37\u0E14)",
    darkMode: "\u0E42\u0E2B\u0E21\u0E14\u0E21\u0E37\u0E14 (\u0E04\u0E25\u0E34\u0E01\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E2B\u0E21\u0E14\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34)",
    autoMode: "\u0E42\u0E2B\u0E21\u0E14\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 (\u0E04\u0E25\u0E34\u0E01\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E2B\u0E21\u0E14\u0E2A\u0E27\u0E48\u0E32\u0E07)",
    toggle: "\u0E2A\u0E25\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E2A\u0E35"
  },
  privacy: {
    title: "\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
    backHome: "\u0E01\u0E25\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} \u0E2A\u0E2D\u0E14\u0E04\u0E25\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A GDPR \u0E40\u0E0B\u0E34\u0E23\u0E4C\u0E1F\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E15\u0E31\u0E49\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E40\u0E22\u0E2D\u0E23\u0E21\u0E19\u0E35 "
  },
  terms: {
    title: "\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23"
  },
  news: {
    title: "\u0E08\u0E32\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32",
    loading: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14 ...",
    rssDescription: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E23\u0E31\u0E1A Atom feed \u0E19\u0E35\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48 "
  },
  profile: {
    balance: "\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19",
    addMoney: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E07\u0E34\u0E19",
    noBalanceFound: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19",
    depositSuccess: "\u0E1D\u0E32\u0E01\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    depositSuccessMessage: "\u0E01\u0E32\u0E23\u0E1D\u0E32\u0E01\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23\u0E04\u0E27\u0E23\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E19\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
    wirePaymentInfo: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E19\u0E2B\u0E23\u0E37\u0E2D Bitcoin? (\u20AC100+): ",
    personalInformation: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25",
    personalInfoMessage: "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E04\u0E48\u0E2D\u0E22\u0E23\u0E39\u0E49\u0E2D\u0E30\u0E44\u0E23\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E40\u0E17\u0E48\u0E32\u0E44\u0E2B\u0E23\u0E48",
    personalInfoContact: "\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E44\u0E1B\u0E17\u0E35\u0E48 ",
    personalInfoGreeting: " \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E17\u0E31\u0E01\u0E17\u0E32\u0E22",
    emails: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    loginInformation: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    currentlyLoggedIn: "\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E2D\u0E22\u0E39\u0E48\u0E14\u0E49\u0E27\u0E22 ",
    saveKeysAlert: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E43\u0E19\u0E15\u0E31\u0E27\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E44\u0E14\u0E49 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E08\u0E32\u0E01\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E41\u0E25\u0E30\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E37\u0E48\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32",
    downloadKeys: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E04\u0E35\u0E22\u0E4C",
    publicKey: "\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    publicKeyDescription: "\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E04\u0E37\u0E2D\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E31\u0E27\u0E15\u0E19\u0E04\u0E38\u0E13 \u0E40\u0E23\u0E32\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E1A\u0E19\u0E40\u0E0B\u0E34\u0E23\u0E4C\u0E1F\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32",
    privateKey: "\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27",
    privateKeyDescription: "\u0E04\u0E35\u0E22\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E04\u0E37\u0E2D\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E40\u0E04\u0E22\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
  },
  emails: {
    accountEmail: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    accountEmailDescription: "\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E15\u0E48\u0E33",
    makePrimary: "\u0E15\u0E31\u0E49\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E31\u0E01",
    resendVerification: "\u0E2A\u0E48\u0E07\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    verificationSent: "\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E25\u0E48\u0E2D\u0E07\u0E08\u0E14\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    accountEmailUpdated: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27"
  },
  glob_footer: {
    product: "\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    account: "\u0E1A\u0E31\u0E0D\u0E0A\u0E35"
  },
  glob_billing: {
    recentAccountMovements: "\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
    loadingAccountMovements: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E1A\u0E31\u0E0D\u0E0A\u0E35...",
    noAccountMovements: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    date: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    amount: "\u0E08\u0E33\u0E19\u0E27\u0E19",
    type: "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17",
    features: "\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34",
    credit: "\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15",
    debit: "\u0E40\u0E14\u0E1A\u0E34\u0E15",
    billingOverview: "\u0E20\u0E32\u0E1E\u0E23\u0E27\u0E21\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19",
    payAsYouGoCredits: "\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E41\u0E1A\u0E1A\u0E08\u0E48\u0E32\u0E22\u0E15\u0E32\u0E21\u0E43\u0E0A\u0E49",
    noBalanceFound: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19",
    addCredits: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15",
    hybridBillingModel: "\u0E42\u0E21\u0E40\u0E14\u0E25\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E41\u0E1A\u0E1A\u0E1C\u0E2A\u0E21",
    hybridBillingDescription: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E42\u0E04\u0E27\u0E15\u0E49\u0E32\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E2B\u0E21\u0E14 \u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E08\u0E30\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E41\u0E1A\u0E1A\u0E08\u0E48\u0E32\u0E22\u0E15\u0E32\u0E21\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E40\u0E2A\u0E35\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 - \u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E04\u0E48\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E34\u0E19\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14\u0E41\u0E1C\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    yourReferralCode: "\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E19\u0E30\u0E19\u0E33\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    shareDirectLink: "\u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E19\u0E35\u0E49:",
    referralDescription: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E21\u0E35\u0E04\u0E19\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E14\u0E49\u0E27\u0E22\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E41\u0E19\u0E30\u0E19\u0E33\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E1D\u0E32\u0E01\u0E40\u0E07\u0E34\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E41\u0E23\u0E01 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A 10% \u0E02\u0E2D\u0E07\u0E08\u0E33\u0E19\u0E27\u0E19\u0E19\u0E31\u0E49\u0E19 \u0E41\u0E25\u0E30\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E42\u0E1A\u0E19\u0E31\u0E2A 10%",
    copy: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
    copied: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27",
    copyLink: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C",
    linkCopied: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E41\u0E25\u0E49\u0E27",
    referralStatistics: "\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33",
    totalReferrals: "\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    totalEarnings: "\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    pendingEarnings: "\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    recentReferrals: "\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
    firstPayment: "\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E41\u0E23\u0E01",
    bonus: "\u0E42\u0E1A\u0E19\u0E31\u0E2A",
    status: "\u0E2A\u0E16\u0E32\u0E19\u0E30",
    processed: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27",
    pending: "\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    bonusPaid: "\u0E08\u0E48\u0E32\u0E22\u0E42\u0E1A\u0E19\u0E31\u0E2A\u0E41\u0E25\u0E49\u0E27",
    awaitingBonus: "\u0E23\u0E2D\u0E42\u0E1A\u0E19\u0E31\u0E2A",
    pendingPayment: "\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    noReferrals: "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33 \u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E19\u0E30\u0E19\u0E33\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E04\u0E2D\u0E21\u0E21\u0E34\u0E0A\u0E0A\u0E31\u0E48\u0E19!",
    loadingReferralHistory: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33...",
    loadingReferralInfo: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E41\u0E19\u0E30\u0E19\u0E33...",
    noActiveSubscription: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48",
    noActiveSubscriptionDescription: "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48 \u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E0A\u0E49\u0E42\u0E21\u0E40\u0E14\u0E25\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E41\u0E1A\u0E1A\u0E08\u0E48\u0E32\u0E22\u0E15\u0E32\u0E21\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32",
    currentSubscription: "\u0E01\u0E32\u0E23\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19",
    plan: "\u0E41\u0E1C\u0E19",
    periodStarted: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19",
    nextBilling: "\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E04\u0E23\u0E31\u0E49\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B",
    nextCycle: "\u0E23\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E44\u0E1B",
    free: "\u0E1F\u0E23\u0E35",
    unlimited: "\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14",
    manageViaStripe: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E1C\u0E48\u0E32\u0E19 Stripe",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"
  }
};

// src/i18n/locales/ar.json
var ar_default = {
  glob_navigation: {
    home: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    pricing: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
    docs: "\u0627\u0644\u062A\u0648\u062B\u064A\u0642",
    news: "\u0627\u0644\u0623\u062E\u0628\u0627\u0631",
    more: "\u0627\u0644\u0645\u0632\u064A\u062F",
    login: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    signup: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644",
    forms: "\u0627\u0644\u0646\u0645\u0627\u0630\u062C",
    integrations: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
    messages: "\u0627\u0644\u0631\u0633\u0627\u0626\u0644",
    profile: "\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A",
    support: "\u0627\u0644\u062F\u0639\u0645",
    logout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    terms: "\u0627\u0644\u0634\u0631\u0648\u0637",
    billing: "\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631",
    usageAndCredits: "\u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0648\u0627\u0644\u0631\u0635\u064A\u062F",
    subscriptions: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A",
    referrals: "\u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
    apiKeys: "\u0645\u0641\u0627\u062A\u064A\u062D API",
    chat: "\u0627\u0644\u062F\u0631\u062F\u0634\u0629"
  },
  auth: {
    login: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    signup: "\u0627\u0644\u062A\u0633\u062C\u064A\u0644",
    logout: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
    step1: "\u0627\u0644\u062E\u0637\u0648\u0629 1",
    step2: "\u0627\u0644\u062E\u0637\u0648\u0629 2",
    authenticate: "\u0627\u0644\u062A\u062D\u0642\u0642",
    enterKey: "\u0627\u0644\u0645\u0639\u0631\u0641",
    newHere: "\u062C\u062F\u064A\u062F \u0647\u0646\u0627\u061F ",
    howToSignup: "\u0643\u064A\u0641\u064A\u0629 \u0627\u0644\u062A\u0633\u062C\u064A\u0644",
    alreadyAccount: "\u0625\u0630\u0627 \u0644\u0645 \u064A\u0643\u0646 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0639\u062F\u060C \u0633\u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0648\u0627\u062D\u062F \u0644\u0643 \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0623\u0648\u0644\u0649 \u0627\u0644\u062A\u064A \u062A\u0633\u062C\u0644 \u0641\u064A\u0647\u0627 \u0627\u0644\u062F\u062E\u0648\u0644. ",
    emailSection: "\u0631\u0627\u0628\u0637 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    googleSection: "\u062C\u0648\u062C\u0644",
    githubSection: "GitHub",
    microsoftSection: "\u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A",
    nostrSection: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062A\u0635\u0641\u062D Nostr",
    signupDescription: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0631\u0627\u0628\u0637 \u0645\u0631\u0633\u0644 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. ",
    googleDescription: "\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062D\u0633\u0627\u0628 \u062C\u0648\u062C\u0644 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. ",
    githubDescription: "\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062D\u0633\u0627\u0628 GitHub \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. ",
    microsoftDescription: "\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062D\u0633\u0627\u0628 \u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. ",
    nostrDescription: "\u0633\u062C\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 ",
    browserPlugin: "\u0625\u0636\u0627\u0641\u0629 \u0645\u062A\u0635\u0641\u062D",
    signupLoginEmail: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.",
    signupLoginGoogle: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062C\u0648\u062C\u0644",
    signupLoginGithub: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 GitHub",
    signupLoginMicrosoft: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A",
    signupLoginNostr: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 Nostr"
  },
  login: {
    publicKeyRequired: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645 \u0645\u0637\u0644\u0648\u0628",
    invalidEmail: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
    getPublicKey: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645 \u0645\u0646 \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
    emailTab: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    googleTab: "\u062C\u0648\u062C\u0644",
    githubTab: "GitHub",
    microsoftTab: "\u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A",
    nostrTab: "Nostr",
    emailDescription: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.",
    googleDescription: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062C\u0648\u062C\u0644",
    nostrPluginDescription: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 Nos2x \u0623\u0648 \u0645\u0634\u0627\u0628\u0647.",
    nostrKeyDescription: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0641\u062A\u0627\u062D\u0643 \u0627\u0644\u062E\u0627\u0635.",
    nostrOtherDescription: "\u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0628\u0648\u0633\u0627\u0626\u0644 \u0623\u062E\u0631\u0649.",
    loadedPublicKey: "\u062A\u0645 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645",
    noKeyLoaded: "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u0645\u064A\u0644 \u0623\u064A \u0645\u0641\u062A\u0627\u062D...",
    enterPublicKey: "\u0623\u062F\u062E\u0644 \u0645\u0641\u062A\u0627\u062D\u0643 \u0627\u0644\u0639\u0627\u0645",
    publicKeyPlaceholder: "32b72e6432f7282135cf124a8...",
    emailLabel: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    emailPlaceholder: "your-email@provider.com",
    enterCode: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    codePlaceholder: "6fd7e67e-6f42-4354-b8f8-775bc1e52a50",
    privateKeyLabel: "\u0623\u062F\u062E\u0644 \u0645\u0641\u062A\u0627\u062D\u0643 \u0627\u0644\u062E\u0627\u0635",
    challengeResponseLabel: "\u0623\u062F\u062E\u0644 \u0627\u0633\u062A\u062C\u0627\u0628\u062A\u0643 \u0644\u0644\u062A\u062D\u062F\u064A",
    emailInstructions: "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0623\u0648 \u0627\u0646\u0633\u062E \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647 \u0647\u0646\u0627.",
    nostrInstructions: "\u064A\u062C\u0628 \u0623\u0646 \u062A\u0637\u0644\u0628 \u0645\u0646\u0643 \u0625\u0636\u0627\u0641\u0629 Nostr \u062A\u0648\u0642\u064A\u0639 \u062D\u062F\u062B \u0627\u0644\u062A\u062D\u0642\u0642 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
    challenge: "\u0627\u0644\u062A\u062D\u062F\u064A: ",
    loginWithExtension: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629",
    redirectingGoogle: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647 \u0625\u0644\u0649 \u062C\u0648\u062C\u0644...",
    redirectingGithub: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647 \u0625\u0644\u0649 GitHub...",
    redirectingMicrosoft: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647 \u0625\u0644\u0649 \u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A...",
    githubNoChallenge: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062D\u062F\u064A GitHub",
    microsoftNoChallenge: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u062D\u062F\u064A \u0645\u0627\u064A\u0643\u0631\u0648\u0633\u0648\u0641\u062A",
    checkYourEmail: "Check your email for the login link",
    emailSent: "We've sent a login link to your email",
    clickLinkToLogin: "Click the link in the email to complete login",
    wrongEmail: "Wrong email? Try again",
    errorNotPrimaryEmail: "This email is not your primary account email.",
    errorDifferentAuthMethod: "This email is registered with a different authentication method",
    errorGoogleEmailNotVerified: "Google email not verified",
    errorInvalidAuthMethodGoogle: "This account uses Google login",
    errorInvalidAuthMethodGithub: "This account uses GitHub login",
    errorInvalidAuthMethodMicrosoft: "This account uses Microsoft login",
    errorInvalidAuthMethodNostr: "This account uses Nostr login",
    errorInvalidNostrSignature: "Invalid Nostr signature",
    errorNostrKeyMismatch: "Nostr key mismatch",
    errorOAuthFailed: "OAuth authentication failed",
    errorTokenExchange: "\u0641\u0634\u0644 \u0625\u0643\u0645\u0627\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
    errorCodeExpired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u062C\u0644\u0633\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644. \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
    invalidLoginResponse: "\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629. \u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
    errorRateLimited: "\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u0643\u062B\u064A\u0631\u0629 \u062C\u062F\u0627\u064B. \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 {{seconds}} \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
    processing: "Processing login...",
    somethingWrong: "Something went wrong",
    invalidMagicLink: "Invalid magic link",
    noIdProvided: "No session ID provided",
    noChallengeProvided: "No challenge provided",
    back: "\u0639\u0648\u062F\u0629",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    submit: "\u0625\u0631\u0633\u0627\u0644"
  },
  glob_buttons: {
    save: "\u062D\u0641\u0638",
    cancel: "\u0625\u0644\u063A\u0627\u0621",
    submit: "\u0625\u0631\u0633\u0627\u0644",
    create: "\u0625\u0646\u0634\u0627\u0621",
    update: "\u062A\u062D\u062F\u064A\u062B",
    updateUnsaved: "\u062A\u062D\u062F\u064A\u062B (\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u063A\u064A\u0631 \u0645\u062D\u0641\u0648\u0638\u0629)",
    delete: "\u062D\u0630\u0641",
    calculate: "\u062D\u0633\u0627\u0628",
    login: "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    back: "\u0639\u0648\u062F\u0629"
  },
  support: {
    title: "\u0627\u0644\u062F\u0639\u0645",
    getHelp: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0645\u0639 {{serviceName}}",
    description: "\u0644\u062F\u064A\u0643 \u0633\u0624\u0627\u0644 \u0623\u0648 \u062A\u062D\u062A\u0627\u062C \u0645\u0633\u0627\u0639\u062F\u0629\u061F \u0646\u062D\u0646 \u0647\u0646\u0627 \u0644\u0644\u0645\u0633\u0627\u0639\u062F\u0629! \u0627\u0645\u0644\u0623 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0623\u062F\u0646\u0627\u0647 \u0648\u0633\u0646\u0639\u0648\u062F \u0625\u0644\u064A\u0643 \u0641\u064A \u0623\u0642\u0631\u0628 \u0648\u0642\u062A \u0645\u0645\u0643\u0646.",
    thankYou: "\u0634\u0643\u0631\u0627\u064B \u0644\u0643!",
    successMessage: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0628\u0646\u062C\u0627\u062D. \u0633\u0646\u0639\u0648\u062F \u0625\u0644\u064A\u0643 \u0641\u064A \u0623\u0642\u0631\u0628 \u0648\u0642\u062A \u0645\u0645\u0643\u0646.",
    submitAnother: "\u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0622\u062E\u0631",
    successAlert: "\u0646\u062C\u062D!",
    successAlertMessage: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062F\u0639\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0628\u0646\u062C\u0627\u062D!",
    nameLabel: "\u0627\u0644\u0627\u0633\u0645 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
    namePlaceholder: "\u0627\u0633\u0645\u0643 \u0627\u0644\u0643\u0627\u0645\u0644",
    emailLabel: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    emailPlaceholder: "your.email@example.com",
    loggedInEmail: "\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0633\u062C\u0644",
    subjectLabel: "\u0627\u0644\u0645\u0648\u0636\u0648\u0639",
    subjectPlaceholder: "\u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0637\u0644\u0628\u0643",
    messageLabel: "\u0627\u0644\u0631\u0633\u0627\u0644\u0629",
    messagePlaceholder: "\u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u062A\u0641\u0627\u0635\u064A\u0644 \u062D\u0648\u0644 \u0633\u0624\u0627\u0644\u0643 \u0623\u0648 \u0645\u0634\u0643\u0644\u062A\u0643...",
    formInfo: "\u0633\u064A\u062A\u0636\u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0637\u0631\u064A\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 (",
    formInfoEnd: ") \u0648\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0645\u0633\u0627\u0639\u062F\u062A\u0643 \u0628\u0634\u0643\u0644 \u0623\u0641\u0636\u0644.",
    submitting: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644...",
    submitButton: "\u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0627\u0644\u062F\u0639\u0645",
    types: {
      general: "\u0633\u0624\u0627\u0644 \u0639\u0627\u0645",
      technical: "\u0633\u0624\u0627\u0644 \u062A\u0642\u0646\u064A",
      feature: "\u0637\u0644\u0628 \u0645\u064A\u0632\u0629",
      bug: "\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u062E\u0637\u0623"
    }
  },
  colorScheme: {
    lightMode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D (\u0627\u0646\u0642\u0631 \u0644\u0644\u0648\u0636\u0639 \u0627\u0644\u0645\u0638\u0644\u0645)",
    darkMode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0645\u0638\u0644\u0645 (\u0627\u0646\u0642\u0631 \u0644\u0644\u0648\u0636\u0639 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A)",
    autoMode: "\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A (\u0627\u0646\u0642\u0631 \u0644\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D)",
    toggle: "\u062A\u0628\u062F\u064A\u0644 \u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0644\u0648\u0627\u0646"
  },
  privacy: {
    title: "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
    backHome: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0644\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
    gdprCompliant: "\u{1F1E9}\u{1F1EA} \u0645\u062A\u0648\u0627\u0641\u0642 \u0645\u0639 \u0642\u0627\u0646\u0648\u0646 \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629. \u0627\u0644\u062E\u0648\u0627\u062F\u0645 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0623\u0644\u0645\u0627\u0646\u064A\u0627. "
  },
  terms: {
    title: "\u0634\u0631\u0648\u0637 \u0627\u0644\u062E\u062F\u0645\u0629"
  },
  news: {
    title: "\u0645\u0646 \u0645\u062F\u0648\u0646\u062A\u0646\u0627",
    loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644 ...",
    rssDescription: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0641\u064A \u062E\u0644\u0627\u0635\u0629 Atom \u0647\u0630\u0647 \u0647\u0646\u0627 "
  },
  profile: {
    balance: "\u0627\u0644\u0631\u0635\u064A\u062F",
    addMoney: "\u0625\u0636\u0627\u0641\u0629 \u0623\u0645\u0648\u0627\u0644",
    noBalanceFound: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0631\u0635\u064A\u062F.",
    depositSuccess: "\u0625\u064A\u062F\u0627\u0639 \u0646\u0627\u062C\u062D",
    depositSuccessMessage: "\u0643\u0627\u0646 \u0625\u064A\u062F\u0627\u0639\u0643 \u0646\u0627\u062C\u062D\u0627\u064B. \u064A\u062C\u0628 \u062A\u0637\u0628\u064A\u0642 \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0641\u064A \u063A\u0636\u0648\u0646 \u062B\u0648\u0627\u0646\u064D.",
    wirePaymentInfo: "\u062A\u0631\u064A\u062F \u0627\u0644\u062F\u0641\u0639 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0623\u0648 \u0627\u0644\u0628\u064A\u062A\u0643\u0648\u064A\u0646\u061F (\u20AC100+): ",
    personalInformation: "\u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062E\u0635\u064A\u0629",
    personalInfoMessage: "\u0646\u062D\u0646 \u0644\u0627 \u0646\u0639\u0631\u0641 \u0627\u0644\u0643\u062B\u064A\u0631 \u0639\u0646\u0643 \u062D\u0642\u0627\u064B.",
    personalInfoContact: "\u0623\u0631\u0633\u0644 \u0628\u0631\u064A\u062F\u0627\u064B \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0627\u064B \u0625\u0644\u0649 ",
    personalInfoGreeting: " \u0644\u0642\u0648\u0644 \u0645\u0631\u062D\u0628\u0627\u064B.",
    emails: "\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
    loginInformation: "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    currentlyLoggedIn: "\u0623\u0646\u062A \u0645\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u062D\u0627\u0644\u064A\u0627\u064B \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 ",
    saveKeysAlert: "\u0627\u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D \u0641\u064A \u0645\u062F\u064A\u0631 \u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0623\u0648 \u0641\u064A \u0645\u0643\u0627\u0646 \u0622\u0645\u0646. \u0644\u0627 \u064A\u0645\u0643\u0646\u0646\u0627 \u0627\u0633\u062A\u0631\u062F\u0627\u062F\u0647\u0627. \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u062E\u062F\u0645\u0629 \u0645\u0646 \u0623\u062C\u0647\u0632\u0629 \u0623\u062E\u0631\u0649 \u0648\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062E\u062F\u0645\u0627\u062A\u0646\u0627 \u0627\u0644\u0623\u062E\u0631\u0649.",
    downloadKeys: "\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0641\u0627\u062A\u064A\u062D",
    publicKey: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0639\u0627\u0645",
    publicKeyDescription: "\u0645\u0641\u062A\u0627\u062D\u0643 \u0627\u0644\u0639\u0627\u0645 \u0647\u0648 \u0645\u0627 \u064A\u062D\u062F\u062F \u0647\u0648\u064A\u062A\u0643\u061B \u0646\u062D\u0646 \u0646\u062E\u0632\u0646\u0647 \u0639\u0644\u0649 \u062E\u0627\u062F\u0645\u0646\u0627.",
    privateKey: "\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u062E\u0627\u0635",
    privateKeyDescription: "\u0645\u0641\u062A\u0627\u062D\u0643 \u0627\u0644\u062E\u0627\u0635 \u0647\u0648 \u0645\u0627 \u062A\u0633\u062A\u062E\u062F\u0645\u0647 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0644\u0627 \u064A\u063A\u0627\u062F\u0631 \u062C\u0647\u0627\u0632 \u0627\u0644\u0643\u0645\u0628\u064A\u0648\u062A\u0631 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0623\u0628\u062F\u0627\u064B."
  },
  emails: {
    accountEmail: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062D\u0633\u0627\u0628",
    accountEmailDescription: "\u0647\u0630\u0627 \u0647\u0648 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0648\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A\u060C \u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u062A\u0646\u0628\u064A\u0647\u0627\u062A \u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u0646\u062E\u0641\u0636.",
    makePrimary: "\u062A\u0639\u064A\u064A\u0646 \u0643\u0623\u0633\u0627\u0633\u064A",
    resendVerification: "\u0625\u0639\u0627\u062F\u0629 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062A\u062D\u0642\u0642",
    verificationSent: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0628\u0631\u064A\u062F \u0627\u0644\u062A\u062D\u0642\u0642. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0648\u0627\u0631\u062F.",
    accountEmailUpdated: "\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062D\u0633\u0627\u0628 \u0628\u0646\u062C\u0627\u062D."
  },
  glob_footer: {
    product: "\u0627\u0644\u0645\u0646\u062A\u062C",
    account: "\u0627\u0644\u062D\u0633\u0627\u0628"
  },
  glob_billing: {
    recentAccountMovements: "\u062D\u0631\u0643\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0623\u062E\u064A\u0631\u0629",
    loadingAccountMovements: "\u062C\u0627\u0631\u064A \u062A\u062D\u0645\u064A\u0644 \u062D\u0631\u0643\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628...",
    noAccountMovements: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062D\u0631\u0643\u0627\u062A \u062D\u0633\u0627\u0628.",
    date: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    amount: "\u0627\u0644\u0645\u0628\u0644\u063A",
    type: "\u0627\u0644\u0646\u0648\u0639",
    features: "\u0627\u0644\u0645\u064A\u0632\u0627\u062A",
    credit: "\u062F\u0627\u0626\u0646",
    debit: "\u0645\u062F\u064A\u0646",
    billingOverview: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u062A\u0631\u0629",
    payAsYouGoCredits: "\u0623\u0631\u0635\u062F\u0629 \u0627\u0644\u062F\u0641\u0639 \u062D\u0633\u0628 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
    noBalanceFound: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0631\u0635\u064A\u062F",
    addCredits: "\u0625\u0636\u0627\u0641\u0629 \u0623\u0631\u0635\u062F\u0629",
    hybridBillingModel: "\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0645\u062E\u062A\u0644\u0637",
    hybridBillingDescription: "\u0639\u0646\u062F\u0645\u0627 \u062A\u0646\u0641\u062F \u062D\u0635\u0635 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u060C \u064A\u062A\u062D\u0648\u0644 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u0625\u0644\u0649 \u0623\u0631\u0635\u062F\u0629 \u0627\u0644\u062F\u0641\u0639 \u062D\u0633\u0628 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645. \u0644\u0646 \u062A\u0641\u0642\u062F \u0627\u0644\u062E\u062F\u0645\u0629 \u0623\u0628\u062F\u0627\u064B - \u0641\u0642\u0637 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0625\u0636\u0627\u0641\u064A \u064A\u062A\u062C\u0627\u0648\u0632 \u062D\u062F\u0648\u062F \u062E\u0637\u062A\u0643.",
    yourReferralCode: "\u0631\u0645\u0632 \u0627\u0644\u0625\u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
    shareDirectLink: "\u0623\u0648 \u0634\u0627\u0631\u0643 \u0631\u0627\u0628\u0637 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0647\u0630\u0627:",
    referralDescription: "\u0639\u0646\u062F\u0645\u0627 \u064A\u0633\u062C\u0644 \u0634\u062E\u0635 \u0645\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0627\u0628\u0637 \u0627\u0644\u0625\u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0648\u064A\u0642\u0648\u0645 \u0628\u0623\u0648\u0644 \u062F\u0641\u0639\u0629 \u0627\u0634\u062A\u0631\u0627\u0643 \u0623\u0648 \u0625\u064A\u062F\u0627\u0639\u060C \u0633\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 10% \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0628\u0644\u063A\u060C \u0648\u0633\u064A\u062D\u0635\u0644\u0648\u0646 \u0639\u0644\u0649 \u0645\u0643\u0627\u0641\u0623\u0629 10%.",
    copy: "\u0646\u0633\u062E",
    copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
    copyLink: "\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637",
    linkCopied: "\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637",
    referralStatistics: "\u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A \u0627\u0644\u0625\u062D\u0627\u0644\u0629",
    totalReferrals: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
    totalEarnings: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0623\u0631\u0628\u0627\u062D",
    pendingEarnings: "\u0627\u0644\u0623\u0631\u0628\u0627\u062D \u0627\u0644\u0645\u0639\u0644\u0642\u0629",
    recentReferrals: "\u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629",
    firstPayment: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0623\u0648\u0644\u0649",
    bonus: "\u0645\u0643\u0627\u0641\u0623\u0629",
    status: "\u0627\u0644\u062D\u0627\u0644\u0629",
    processed: "\u062A\u0645\u062A \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629",
    pending: "\u0645\u0639\u0644\u0642",
    bonusPaid: "\u062A\u0645 \u062F\u0641\u0639 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
    awaitingBonus: "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0643\u0627\u0641\u0623\u0629",
    pendingPayment: "\u0627\u0644\u062F\u0641\u0639 \u0645\u0639\u0644\u0642",
    noReferrals: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0625\u062D\u0627\u0644\u0627\u062A \u0628\u0639\u062F. \u0634\u0627\u0631\u0643 \u0631\u0645\u0632 \u0627\u0644\u0625\u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0628\u062F\u0621 \u0643\u0633\u0628 \u0627\u0644\u0639\u0645\u0648\u0644\u0627\u062A!",
    loadingReferralHistory: "\u062C\u0627\u0631\u064A \u062A\u062D\u0645\u064A\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A...",
    loadingReferralInfo: "\u062C\u0627\u0631\u064A \u062A\u062D\u0645\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0625\u062D\u0627\u0644\u0629...",
    noActiveSubscription: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u0634\u062A\u0631\u0627\u0643 \u0646\u0634\u0637",
    noActiveSubscriptionDescription: "\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0634\u062A\u0631\u0627\u0643 \u0646\u0634\u0637. \u0623\u0646\u062A \u062A\u0633\u062A\u062E\u062F\u0645 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0628\u0627\u0644\u062F\u0641\u0639 \u062D\u0633\u0628 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645.",
    currentSubscription: "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643 \u0627\u0644\u062D\u0627\u0644\u064A",
    plan: "\u0627\u0644\u062E\u0637\u0629",
    periodStarted: "\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0641\u062A\u0631\u0629",
    nextBilling: "\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
    nextCycle: "\u0627\u0644\u062F\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
    free: "\u0645\u062C\u0627\u0646\u064A",
    unlimited: "\u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F",
    manageViaStripe: "\u0625\u062F\u0627\u0631\u0629 \u0639\u0628\u0631 Stripe",
    cancel: "\u0625\u0644\u063A\u0627\u0621"
  }
};

// src/i18n/index.ts
var libraryI18n = i18n.createInstance();
libraryI18n.use(initReactI18next).init({
  resources: {
    en: { translation: en_default },
    de: { translation: de_default },
    es: { translation: es_default },
    fr: { translation: fr_default },
    pt: { translation: pt_default },
    zh: { translation: zh_default },
    th: { translation: th_default },
    ar: { translation: ar_default }
  },
  lng: typeof window !== "undefined" ? localStorage.getItem("saved-language") || navigator.language.split("-")[0] || "en" : "en",
  // Set language synchronously
  fallbackLng: "en",
  defaultNS: "translation",
  interpolation: {
    escapeValue: false
  }
});
var i18n_default = libraryI18n;

// src/components/I18nProvider.tsx
import { jsx } from "react/jsx-runtime";
function LibraryI18nProvider({ children }) {
  return /* @__PURE__ */ jsx(I18nextProvider, { i18n: i18n_default, children });
}

// src/components/withLibraryI18n.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function withLibraryI18n(Component) {
  const WrappedComponent = (props) => /* @__PURE__ */ jsx2(LibraryI18nProvider, { children: /* @__PURE__ */ jsx2(Component, { ...props }) });
  WrappedComponent.displayName = `withLibraryI18n(${Component.displayName || Component.name || "Component"})`;
  return WrappedComponent;
}

// src/components/Common/News.tsx
import { Anchor, List, ListItem, Pill, Text as Text2 } from "@mantine/core";
import { parseRSS } from "@gofranz/common";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// src/components/Common/TitleWithText.tsx
import { Stack, Box, Text, useMantineTheme as useMantineTheme2 } from "@mantine/core";

// src/components/Common/Title.tsx
import { Title, useMantineTheme } from "@mantine/core";
import { jsx as jsx3 } from "react/jsx-runtime";
function LargeTitle({ title, ...stackProps }) {
  const theme = useMantineTheme();
  const primaryColor = theme.colors["brand-primary"]?.[6] || theme.colors.primary[6];
  const accentColor = theme.colors["brand-accent"]?.[6] || theme.colors["brand-secondary"]?.[6] || theme.colors.primary[8];
  return /* @__PURE__ */ jsx3(
    Title,
    {
      order: 1,
      style: {
        background: `linear-gradient(45deg, ${primaryColor}, ${accentColor})`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        marginBottom: "1rem",
        fontSize: "clamp(50px, 8vw, 60px)",
        fontWeight: 900,
        letterSpacing: "-2px"
      },
      ...stackProps,
      children: title
    }
  );
}

// src/components/Common/TitleWithText.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
function LargeTitleWithText({
  title,
  text,
  ...stackProps
}) {
  const theme = useMantineTheme2();
  const subtitleColor = theme.colors["neutral-dark"]?.[6] || "dimmed";
  return /* @__PURE__ */ jsx4(Stack, { gap: "xl", ...stackProps, children: /* @__PURE__ */ jsxs(Box, { style: { textAlign: "center" }, children: [
    /* @__PURE__ */ jsx4(LargeTitle, { title }),
    text && /* @__PURE__ */ jsx4(Text, { size: "lg", c: subtitleColor, maw: 600, mx: "auto", children: text })
  ] }) });
}

// src/components/Common/News.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
function News(props) {
  const { t } = useTranslation();
  const { blogBaseUrl, maxItems = 10, summaryLength = 180 } = props;
  const url = `${blogBaseUrl}/feed.xml`;
  const [feed, setFeed] = useState(null);
  useEffect(() => {
    (async () => {
      const res = await fetch(url);
      const resData = await res.text();
      const parsedFeed = parseRSS(resData);
      setFeed(parsedFeed.feed);
    })();
  }, [url]);
  const category = (cat, index) => /* @__PURE__ */ jsx5(Pill, { color: "gray", size: "xs", children: /* @__PURE__ */ jsx5("span", { style: { fontSize: "12px", color: "var(--mantine-color-dimmed)" }, children: cat }) }, `${cat}-${index}`);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx5(LargeTitleWithText, { title: t("news.title"), mb: "md" }),
    /* @__PURE__ */ jsx5(List, { mb: "md", maw: 680, children: feed ? feed?.entry.slice(0, maxItems).map((item) => /* @__PURE__ */ jsxs2(ListItem, { mb: "xs", children: [
      /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(Anchor, { href: item.id, title: item.title, children: item.title }) }),
      /* @__PURE__ */ jsx5("div", { style: { fontSize: "12px", marginBottom: "8px" }, children: item.category.map((cat, index) => category(cat.toLowerCase(), index)) }),
      /* @__PURE__ */ jsxs2("div", { style: { fontSize: "14px", lineHeight: "1.4" }, children: [
        item.summary.replace(/<[^>]*>/g, "").slice(0, summaryLength),
        " ..."
      ] })
    ] }, `news-${item.id}`)) : /* @__PURE__ */ jsx5(Text2, { children: t("news.loading") }) }),
    /* @__PURE__ */ jsxs2(Text2, { children: [
      t("news.rssDescription"),
      " ",
      /* @__PURE__ */ jsx5(Anchor, { href: url, children: url.replace("https://", "") })
    ] })
  ] });
}

// src/components/VerifiedEmail/Email.tsx
import { ActionIcon, Badge, Button, Grid, Group as Group2, Text as Text4 } from "@mantine/core";
import { IconTrash, IconUser } from "@tabler/icons-react";
import { useState as useState2 } from "react";

// src/components/Common/Verified.tsx
import { Group, Text as Text3 } from "@mantine/core";
import { IconCheckbox, IconSquare } from "@tabler/icons-react";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
function IsVerified(props) {
  const Icon = () => {
    return props.isVerified ? /* @__PURE__ */ jsx6(IconCheckbox, {}) : /* @__PURE__ */ jsx6(IconSquare, {});
  };
  return /* @__PURE__ */ jsxs3(Group, { children: [
    /* @__PURE__ */ jsx6(Icon, {}),
    /* @__PURE__ */ jsx6(Text3, { children: "Verified" })
  ] });
}

// src/components/VerifiedEmail/Email.tsx
import { useTranslation as useTranslation2 } from "react-i18next";
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
function VerifiedEmailComponent(props) {
  const { t } = useTranslation2();
  const [message, setMessage] = useState2("");
  const { verifiedEmail } = props;
  const verifyCb = async (id) => {
    await props.verifyCb(id);
    setMessage(t("emails.verificationSent"));
  };
  const setAccountEmailCb = async (id) => {
    await props.setAccountEmailCb(id);
    setMessage(t("emails.accountEmailUpdated"));
  };
  return /* @__PURE__ */ jsxs4(Fragment2, { children: [
    /* @__PURE__ */ jsxs4(Grid, { children: [
      /* @__PURE__ */ jsx7(Grid.Col, { span: 5, children: /* @__PURE__ */ jsxs4(Group2, { children: [
        /* @__PURE__ */ jsx7(
          ActionIcon,
          {
            color: "red",
            onClick: () => props.deleteCb(verifiedEmail.id),
            loading: props.isBusy,
            variant: "filled",
            "aria-label": "Delete",
            children: /* @__PURE__ */ jsx7(IconTrash, { style: { width: "70%", height: "70%" }, stroke: 1.5 })
          }
        ),
        /* @__PURE__ */ jsx7(Text4, { children: verifiedEmail.email }),
        verifiedEmail.is_account_email && /* @__PURE__ */ jsx7(Badge, { color: "blue", variant: "light", leftSection: /* @__PURE__ */ jsx7(IconUser, { size: 12 }), children: t("emails.accountEmail") })
      ] }) }),
      /* @__PURE__ */ jsx7(Grid.Col, { span: "auto", children: /* @__PURE__ */ jsxs4(Group2, { children: [
        /* @__PURE__ */ jsx7(IsVerified, { isVerified: verifiedEmail.is_verified }),
        verifiedEmail.is_verified === false && /* @__PURE__ */ jsx7(
          Button,
          {
            onClick: () => verifyCb(verifiedEmail.id),
            loading: props.isBusy,
            variant: "outline",
            children: t("emails.resendVerification")
          }
        ),
        verifiedEmail.is_verified && !verifiedEmail.is_account_email && /* @__PURE__ */ jsx7(
          Button,
          {
            onClick: () => setAccountEmailCb(verifiedEmail.id),
            loading: props.isBusy,
            variant: "outline",
            size: "xs",
            children: t("emails.makePrimary")
          }
        )
      ] }) })
    ] }),
    verifiedEmail.is_account_email && /* @__PURE__ */ jsx7(Text4, { size: "xs", c: "dimmed", mt: "xs", children: t("emails.accountEmailDescription") }),
    message !== "" && /* @__PURE__ */ jsx7(Text4, { size: "sm", c: "green", mt: "xs", children: message })
  ] });
}

// src/components/Login/Login.tsx
import {
  LOGIN_METHOD,
  decodeNostrPublicKey
} from "@gofranz/common";
import {
  Button as Button2,
  Center,
  Loader,
  PinInput,
  Stack as Stack2,
  Text as Text5,
  TextInput
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconBrandGithub, IconBrandGoogle, IconBrandWindows, IconBrowser, IconRecordMail, IconShieldLock } from "@tabler/icons-react";
import { useState as useState3 } from "react";
import { useTranslation as useTranslation3 } from "react-i18next";
import { Fragment as Fragment3, jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var StepOne = ({
  googleLogin,
  githubLogin,
  microsoftLogin,
  nostrLogin,
  magicLinkLoginChallenge,
  loginMethods,
  isBusy,
  t
}) => {
  const formRequestEmailMagicLink = useForm({
    initialValues: {
      email: ""
    },
    validate: {
      email: (value) => /^\S+@\S+$/.test(value) ? null : t("login.invalidEmail")
    }
  });
  const hasGoogleLogin = loginMethods?.includes(LOGIN_METHOD.GOOGLE);
  const hasGithubLogin = loginMethods?.includes(LOGIN_METHOD.GITHUB);
  const hasMicrosoftLogin = loginMethods?.includes(LOGIN_METHOD.MICROSOFT);
  const hasNostrLogin = loginMethods?.includes(LOGIN_METHOD.NOSTR);
  const hasEmailMagicLinkLogin = loginMethods?.includes(LOGIN_METHOD.EMAIL_MAGIC_LINK);
  return /* @__PURE__ */ jsxs5(Stack2, { children: [
    hasGoogleLogin && /* @__PURE__ */ jsx8(Button2, { type: "submit", loading: isBusy, onClick: googleLogin, leftSection: /* @__PURE__ */ jsx8(IconBrandGoogle, {}), variant: "outline", children: t("login.googleTab") }),
    hasGithubLogin && /* @__PURE__ */ jsx8(Button2, { type: "submit", loading: isBusy, onClick: githubLogin, leftSection: /* @__PURE__ */ jsx8(IconBrandGithub, {}), variant: "outline", children: t("login.githubTab") }),
    hasMicrosoftLogin && /* @__PURE__ */ jsx8(Button2, { type: "submit", loading: isBusy, onClick: microsoftLogin, leftSection: /* @__PURE__ */ jsx8(IconBrandWindows, {}), variant: "outline", children: t("login.microsoftTab") }),
    hasNostrLogin && /* @__PURE__ */ jsx8(Button2, { type: "submit", loading: isBusy, onClick: nostrLogin, leftSection: /* @__PURE__ */ jsx8(IconBrowser, {}), variant: "outline", children: t("login.nostrTab") }),
    hasEmailMagicLinkLogin && /* @__PURE__ */ jsxs5(Fragment3, { children: [
      /* @__PURE__ */ jsxs5(Text5, { c: "dimmed", size: "sm", mt: "md", children: [
        t("auth.signupLoginEmail"),
        ":"
      ] }),
      /* @__PURE__ */ jsxs5(
        "form",
        {
          onSubmit: formRequestEmailMagicLink.onSubmit(() => magicLinkLoginChallenge(formRequestEmailMagicLink.values.email)),
          children: [
            /* @__PURE__ */ jsx8(
              TextInput,
              {
                withAsterisk: true,
                label: t("login.emailLabel"),
                placeholder: t("login.emailPlaceholder"),
                ...formRequestEmailMagicLink.getInputProps("email")
              }
            ),
            /* @__PURE__ */ jsx8(Button2, { type: "submit", loading: isBusy, mt: "xs", w: "100%", leftSection: /* @__PURE__ */ jsx8(IconRecordMail, {}), children: t("glob_buttons.login") })
          ]
        }
      )
    ] })
  ] });
};
var StepTwo = ({
  loginMethod,
  setActiveStep,
  t
}) => {
  return /* @__PURE__ */ jsxs5(Fragment3, { children: [
    loginMethod === LOGIN_METHOD.EMAIL_MAGIC_LINK && /* @__PURE__ */ jsx8(Fragment3, { children: /* @__PURE__ */ jsxs5(Stack2, { gap: "md", children: [
      /* @__PURE__ */ jsx8(Text5, { size: "lg", fw: 500, children: t("login.emailSent") }),
      /* @__PURE__ */ jsx8(Text5, { children: t("login.clickLinkToLogin") }),
      /* @__PURE__ */ jsx8(Text5, { size: "sm", c: "dimmed", children: t("login.wrongEmail") }),
      /* @__PURE__ */ jsx8(
        Button2,
        {
          variant: "outline",
          onClick: () => setActiveStep(0),
          children: t("login.back")
        }
      )
    ] }) }),
    loginMethod === LOGIN_METHOD.NOSTR && /* @__PURE__ */ jsxs5(Fragment3, { children: [
      /* @__PURE__ */ jsx8(Text5, { mb: "md", children: t("login.nostrInstructions") }),
      /* @__PURE__ */ jsx8(Center, { children: /* @__PURE__ */ jsx8(Loader, { size: "xl" }) })
    ] }),
    loginMethod === LOGIN_METHOD.GOOGLE && /* @__PURE__ */ jsxs5(Fragment3, { children: [
      /* @__PURE__ */ jsx8(Text5, { mb: "md", children: t("login.redirectingGoogle") }),
      /* @__PURE__ */ jsx8(Center, { children: /* @__PURE__ */ jsx8(Loader, { size: "xl" }) })
    ] }),
    loginMethod === LOGIN_METHOD.GITHUB && /* @__PURE__ */ jsxs5(Fragment3, { children: [
      /* @__PURE__ */ jsx8(Text5, { mb: "md", children: t("login.redirectingGithub") }),
      /* @__PURE__ */ jsx8(Center, { children: /* @__PURE__ */ jsx8(Loader, { size: "xl" }) })
    ] }),
    loginMethod === LOGIN_METHOD.MICROSOFT && /* @__PURE__ */ jsxs5(Fragment3, { children: [
      /* @__PURE__ */ jsx8(Text5, { mb: "md", children: t("login.redirectingMicrosoft") }),
      /* @__PURE__ */ jsx8(Center, { children: /* @__PURE__ */ jsx8(Loader, { size: "xl" }) })
    ] })
  ] });
};
var StepTwoFactor = ({
  pendingToken,
  verify2FA,
  loginDoneCb,
  setActiveStep,
  setHasError,
  t
}) => {
  const [code, setCode] = useState3("");
  const [isBusy, setIsBusy] = useState3(false);
  const handleVerify = async () => {
    if (code.length < 6) return;
    setIsBusy(true);
    setHasError(null);
    try {
      await verify2FA({
        pending_token: pendingToken,
        code
      });
      loginDoneCb();
    } catch (e) {
      console.error(e);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else if (e?.response?.status === 401) {
        setHasError(t("login.invalid2FACode"));
      } else if (e?.response?.status === 429) {
        setHasError(t("login.tooMany2FAAttempts"));
        setActiveStep(0);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
      setCode("");
    } finally {
      setIsBusy(false);
    }
  };
  return /* @__PURE__ */ jsxs5(Stack2, { gap: "md", align: "center", children: [
    /* @__PURE__ */ jsx8(IconShieldLock, { size: 48, stroke: 1.5 }),
    /* @__PURE__ */ jsx8(Text5, { size: "lg", fw: 500, children: t("login.twoFactorRequired") }),
    /* @__PURE__ */ jsx8(Text5, { size: "sm", c: "dimmed", ta: "center", children: t("login.enterTwoFactorCode") }),
    /* @__PURE__ */ jsx8(
      PinInput,
      {
        length: 6,
        type: "number",
        value: code,
        onChange: setCode,
        oneTimeCode: true,
        disabled: isBusy,
        size: "lg"
      }
    ),
    /* @__PURE__ */ jsx8(
      Button2,
      {
        onClick: handleVerify,
        loading: isBusy,
        disabled: code.length < 6,
        fullWidth: true,
        children: t("login.verify")
      }
    ),
    /* @__PURE__ */ jsx8(Text5, { size: "sm", c: "dimmed", ta: "center", children: t("login.useRecoveryCode") }),
    /* @__PURE__ */ jsx8(
      Button2,
      {
        variant: "subtle",
        size: "xs",
        onClick: () => setActiveStep(0),
        children: t("login.back")
      }
    )
  ] });
};
function Login(props) {
  const { t } = useTranslation3();
  const [activeStep, setActiveStep] = useState3(0);
  const [loginMethod, setLoginMethod] = useState3(
    LOGIN_METHOD.EMAIL_MAGIC_LINK
  );
  const [isBusy, setIsBusy] = useState3(false);
  const [hasError, setHasError] = useState3(null);
  const [pendingToken, setPendingToken] = useState3(null);
  const nostrLogin = async () => {
    setIsBusy(true);
    setLoginMethod(LOGIN_METHOD.NOSTR);
    setHasError(null);
    setActiveStep(1);
    try {
      const publicKey = await window.nostr.getPublicKey();
      if (!publicKey) {
        setHasError(t("login.nostrNoPublicKey"));
        return;
      }
      const challenge = await props.login({
        type: "NOSTR",
        content: {
          public_key: decodeNostrPublicKey(publicKey)
        }
      });
      if (!challenge || challenge.type !== "NOSTR") {
        setHasError(t("login.nostrNoChallenge"));
        return;
      }
      const loginResult = await props.loginChallenge({
        type: "NOSTR",
        content: {
          id: challenge.content.id,
          response: await window.nostr.signEvent({
            kind: 22242,
            created_at: Math.floor(Date.now() / 1e3),
            tags: [["challenge", challenge.content.challenge]],
            content: ""
          })
        }
      });
      if (!loginResult) {
        setHasError(t("login.nostrNoChallengeResponse"));
        return;
      }
      if (loginResult.status === "requires_2fa") {
        setPendingToken(loginResult.data.pending_token);
        setActiveStep(2);
        return;
      }
      props.loginDoneCb();
    } catch (e) {
      console.error(e);
      setActiveStep(0);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
    } finally {
      setIsBusy(false);
    }
  };
  const googleLogin = async () => {
    setIsBusy(true);
    setLoginMethod(LOGIN_METHOD.GOOGLE);
    setHasError(null);
    setActiveStep(1);
    try {
      const googleChallenge = await props.login({
        type: LOGIN_METHOD.GOOGLE,
        content: {}
      });
      if (!googleChallenge || googleChallenge.type !== LOGIN_METHOD.GOOGLE) {
        setHasError(t("login.googleNoChallenge"));
        return;
      }
      window.location.href = googleChallenge.content.auth_url;
    } catch (e) {
      console.error(e);
      setActiveStep(0);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
    } finally {
      setIsBusy(false);
    }
  };
  const githubLogin = async () => {
    setIsBusy(true);
    setLoginMethod(LOGIN_METHOD.GITHUB);
    setHasError(null);
    setActiveStep(1);
    try {
      const githubChallenge = await props.login({
        type: LOGIN_METHOD.GITHUB,
        content: {}
      });
      if (!githubChallenge || githubChallenge.type !== LOGIN_METHOD.GITHUB) {
        setHasError(t("login.githubNoChallenge"));
        return;
      }
      window.location.href = githubChallenge.content.auth_url;
    } catch (e) {
      console.error(e);
      setActiveStep(0);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
    } finally {
      setIsBusy(false);
    }
  };
  const microsoftLogin = async () => {
    setIsBusy(true);
    setLoginMethod(LOGIN_METHOD.MICROSOFT);
    setHasError(null);
    setActiveStep(1);
    try {
      const microsoftChallenge = await props.login({
        type: LOGIN_METHOD.MICROSOFT,
        content: {}
      });
      if (!microsoftChallenge || microsoftChallenge.type !== LOGIN_METHOD.MICROSOFT) {
        setHasError(t("login.microsoftNoChallenge"));
        return;
      }
      window.location.href = microsoftChallenge.content.auth_url;
    } catch (e) {
      console.error(e);
      setActiveStep(0);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
    } finally {
      setIsBusy(false);
    }
  };
  const magicLinkLoginChallenge = async (email) => {
    setIsBusy(true);
    setLoginMethod(LOGIN_METHOD.EMAIL_MAGIC_LINK);
    setHasError(null);
    try {
      const emailMagicLinkChallenge = await props.login({
        type: LOGIN_METHOD.EMAIL_MAGIC_LINK,
        content: {
          email
        }
      });
      if (!emailMagicLinkChallenge || emailMagicLinkChallenge.type !== LOGIN_METHOD.EMAIL_MAGIC_LINK) {
        setHasError(t("login.emailNoChallenge"));
        return;
      }
      setActiveStep(1);
    } catch (e) {
      console.error(e);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
    } finally {
      setIsBusy(false);
    }
  };
  const ErrorMessage = () => /* @__PURE__ */ jsx8(Text5, { c: "red", mb: "md", children: hasError });
  return /* @__PURE__ */ jsxs5(Fragment3, { children: [
    activeStep === 0 && /* @__PURE__ */ jsx8(
      StepOne,
      {
        googleLogin,
        githubLogin,
        microsoftLogin,
        nostrLogin,
        magicLinkLoginChallenge,
        loginMethods: props.loginMethods,
        isBusy,
        t
      }
    ),
    activeStep === 1 && /* @__PURE__ */ jsx8(
      StepTwo,
      {
        loginMethod,
        setActiveStep,
        t
      }
    ),
    activeStep === 2 && pendingToken && /* @__PURE__ */ jsx8(
      StepTwoFactor,
      {
        pendingToken,
        verify2FA: props.verify2FA,
        loginDoneCb: props.loginDoneCb,
        setActiveStep,
        setHasError,
        t
      }
    ),
    /* @__PURE__ */ jsx8(ErrorMessage, {})
  ] });
}

// src/components/Login/LoginCallback.tsx
import { decodeSessionTokens } from "@gofranz/common";
import { Box as Box2, Loader as Loader2, Text as Text6 } from "@mantine/core";
import { useEffect as useEffect2, useRef, useState as useState4 } from "react";
import { useTranslation as useTranslation4 } from "react-i18next";
import { Fragment as Fragment4, jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
function LoginCallback(props) {
  const { t } = useTranslation4();
  const [hasError, setHasError] = useState4([]);
  const [isExchanging, setIsExchanging] = useState4(false);
  const exchangeAttempted = useRef(false);
  useEffect2(() => {
    if (exchangeAttempted.current) return;
    exchangeAttempted.current = true;
    const controller = new AbortController();
    const url = new URL(window.location.href);
    const hashParams = new URLSearchParams(url.hash.split("?")[1]);
    const error = hashParams.get("error");
    const errorMessage = hashParams.get("error_message");
    if (error) {
      const errors = [];
      switch (error) {
        case "google_email_not_verified":
          errors.push(t("login.errorGoogleEmailNotVerified"), errorMessage || "");
          break;
        case "invalid_auth_method_google":
          errors.push(t("login.errorInvalidAuthMethodGoogle"), errorMessage || "");
          break;
        case "invalid_auth_method_github":
          errors.push(t("login.errorInvalidAuthMethodGithub"), errorMessage || "");
          break;
        case "invalid_auth_method_microsoft":
          errors.push(t("login.errorInvalidAuthMethodMicrosoft"), errorMessage || "");
          break;
        case "invalid_auth_method_nostr":
          errors.push(t("login.errorInvalidAuthMethodNostr"), errorMessage || "");
          break;
        default:
          errors.push(t("login.errorOAuthFailed"), errorMessage || error);
      }
      setHasError(errors.filter((e) => e));
      return;
    }
    const code = hashParams.get("code");
    const loginMethod = hashParams.get("login_method");
    if (!code) {
      setHasError([t("login.invalidLoginResponse")]);
      return;
    }
    setIsExchanging(true);
    fetch(`${props.apiBaseUrl}/login/exchange`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
      signal: controller.signal
    }).then(async (res) => {
      if (!res.ok) {
        if (res.status === 429) {
          const retryAfter = res.headers.get("Retry-After");
          throw new Error(t("login.errorRateLimited", { seconds: retryAfter || "60" }));
        }
        const body = await res.json().catch(() => ({}));
        if (body.error === "expired_or_used_auth_code") {
          throw new Error(t("login.errorCodeExpired"));
        }
        throw new Error(body.message || t("login.errorTokenExchange"));
      }
      return res.json();
    }).then((data) => {
      props.setSession({
        isLoggedIn: true,
        userId: data.user_id,
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        expiresAt: parseInt(data.expires_at),
        ...decodeSessionTokens({
          access_token: data.access_token,
          refresh_token: data.refresh_token
        }),
        method: loginMethod
      });
      props.loginDoneCb();
    }).catch((err) => {
      if (err.name === "AbortError") return;
      setIsExchanging(false);
      setHasError([err.message || t("login.errorTokenExchange")]);
    });
    return () => controller.abort();
  }, []);
  const ErrorMessage = () => /* @__PURE__ */ jsx9(Fragment4, { children: hasError.map((error, index) => /* @__PURE__ */ jsx9(Text6, { c: index === 0 ? "red" : "dimmed", mb: "xs", children: error }, index)) });
  return /* @__PURE__ */ jsxs6(Box2, { maw: 340, mx: "auto", children: [
    /* @__PURE__ */ jsx9(Text6, { size: "lg", mb: "md", children: t("login.loggingIn") }),
    isExchanging && /* @__PURE__ */ jsx9(Loader2, { size: "sm" }),
    hasError.length > 0 && /* @__PURE__ */ jsx9(ErrorMessage, {})
  ] });
}

// src/components/Login/index.ts
var Login2 = withLibraryI18n(Login);
var LoginCallback2 = withLibraryI18n(LoginCallback);

// src/components/Common/ColorSchemeToggle.tsx
import { ActionIcon as ActionIcon2, useMantineColorScheme, Tooltip } from "@mantine/core";
import { IconSun, IconMoon, IconDeviceDesktop } from "@tabler/icons-react";
import { jsx as jsx10 } from "react/jsx-runtime";
function ColorSchemeToggle() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const toggleColorScheme = () => {
    if (colorScheme === "light") {
      setColorScheme("dark");
    } else if (colorScheme === "dark") {
      setColorScheme("auto");
    } else {
      setColorScheme("light");
    }
  };
  const getIcon = () => {
    switch (colorScheme) {
      case "light":
        return /* @__PURE__ */ jsx10(IconSun, { size: 18 });
      case "dark":
        return /* @__PURE__ */ jsx10(IconMoon, { size: 18 });
      case "auto":
        return /* @__PURE__ */ jsx10(IconDeviceDesktop, { size: 18 });
      default:
        return /* @__PURE__ */ jsx10(IconSun, { size: 18 });
    }
  };
  const getTooltipLabel = () => {
    switch (colorScheme) {
      case "light":
        return "Light mode (click for dark)";
      case "dark":
        return "Dark mode (click for auto)";
      case "auto":
        return "Auto mode (click for light)";
      default:
        return "Toggle color scheme";
    }
  };
  return /* @__PURE__ */ jsx10(Tooltip, { label: getTooltipLabel(), children: /* @__PURE__ */ jsx10(
    ActionIcon2,
    {
      onClick: toggleColorScheme,
      variant: "subtle",
      size: "lg",
      "aria-label": "Toggle color scheme",
      children: getIcon()
    }
  ) });
}

// src/components/VerifiedEmail/Create.tsx
import { Button as Button3, Text as Text7, TextInput as TextInput2 } from "@mantine/core";
import { useForm as useForm2 } from "@mantine/form";
import { useState as useState5 } from "react";
import { Fragment as Fragment5, jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
function CreateVerifiedEmail(props) {
  const [isBusy, setIsBusy] = useState5(false);
  const [error, setError] = useState5("");
  const form = useForm2({
    initialValues: {
      email: ""
    },
    validate: {
      email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ? null : "Invalid Email"
    }
  });
  const submitForm = async () => {
    const newEmail = {
      email: form.values.email
    };
    setIsBusy(true);
    try {
      await props.submitFormCb(newEmail);
      form.reset();
    } catch (e) {
      setError(`Error: ${e}`);
      console.error(e);
    } finally {
      setIsBusy(false);
    }
  };
  return /* @__PURE__ */ jsxs7(Fragment5, { children: [
    /* @__PURE__ */ jsxs7("form", { onSubmit: form.onSubmit(submitForm), children: [
      /* @__PURE__ */ jsx11(
        TextInput2,
        {
          label: "Email",
          placeholder: "Email",
          value: form.values.email,
          onChange: (event) => form.setFieldValue("email", event.currentTarget.value),
          error: form.errors.email && "Invalid Email",
          mb: "md"
        }
      ),
      /* @__PURE__ */ jsx11(Button3, { type: "submit", loading: isBusy, children: "Verify" })
    ] }),
    error && /* @__PURE__ */ jsx11(Text7, { color: "red", children: error })
  ] });
}

// src/components/VerifiedEmail/Detail.tsx
import { Card, Text as Text8 } from "@mantine/core";
import { useEffect as useEffect3, useState as useState6 } from "react";
import { Fragment as Fragment6, jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
function VerifiedEmailDetail(props) {
  const [isBusy, setIsBusy] = useState6(false);
  const [verifiedEmails, setVerifiedEmails] = useState6([]);
  useEffect3(() => {
    const getVerifiedEmails = async () => {
      setIsBusy(true);
      try {
        const data = await props.getVerifiedEmails();
        setVerifiedEmails(data.data);
      } catch (e) {
        alert(e);
        console.error(e);
      } finally {
        setIsBusy(false);
      }
    };
    getVerifiedEmails();
  }, []);
  const submitCb = async (newEmail) => {
    try {
      setIsBusy(true);
      await props.submitFormCb(newEmail);
      const data = await props.getVerifiedEmails();
      setVerifiedEmails(data.data);
    } catch (e) {
      alert(e);
      console.error(e);
    } finally {
      setIsBusy(false);
    }
  };
  const verifyCb = async (id) => {
    try {
      setIsBusy(true);
      await props.verifyCb(id);
      const data = await props.getVerifiedEmails();
      setVerifiedEmails(data.data);
    } catch (e) {
      alert(e);
      console.error(e);
    } finally {
      setIsBusy(false);
    }
  };
  const deleteCb = async (id) => {
    try {
      setIsBusy(true);
      await props.deleteCb(id);
      const data = await props.getVerifiedEmails();
      setVerifiedEmails(data.data);
    } catch (e) {
      alert(e);
      console.error(e);
    } finally {
      setIsBusy(false);
    }
  };
  const setAccountEmailCb = async (id) => {
    try {
      setIsBusy(true);
      await props.setAccountEmailCb(id);
      const data = await props.getVerifiedEmails();
      setVerifiedEmails(data.data);
    } catch (e) {
      alert(e);
      console.error(e);
    } finally {
      setIsBusy(false);
    }
  };
  const Emails = () => verifiedEmails.map((email) => /* @__PURE__ */ jsx12(Card, { shadow: "xs", radius: "md", mb: "md", withBorder: true, children: /* @__PURE__ */ jsx12(
    VerifiedEmailComponent,
    {
      verifiedEmail: email,
      isBusy,
      verifyCb,
      deleteCb,
      setAccountEmailCb
    },
    `verified-email-${email.id}`
  ) }, email.id));
  const EmailsNotFount = () => /* @__PURE__ */ jsx12(Text8, { children: "No verified emails found." });
  return /* @__PURE__ */ jsxs8(Fragment6, { children: [
    verifiedEmails.length > 0 ? /* @__PURE__ */ jsx12(Emails, {}) : /* @__PURE__ */ jsx12(EmailsNotFount, {}),
    /* @__PURE__ */ jsx12(CreateVerifiedEmail, { submitFormCb: submitCb })
  ] });
}

// src/components/Entity/Entity.tsx
import { Text as Text9, Title as Title2 } from "@mantine/core";
import { Fragment as Fragment7, jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
function Entity({
  title,
  description,
  data,
  render,
  reload
}) {
  return /* @__PURE__ */ jsxs9(Fragment7, { children: [
    /* @__PURE__ */ jsx13(Title2, { order: 3, children: title }),
    description && /* @__PURE__ */ jsx13(Text9, { children: description }),
    render({ data, setParentLoading: () => {
    }, reload })
  ] });
}

// src/components/Entity/EntityCreatePage.tsx
import { useNavigate as useNavigate2 } from "react-router-dom";

// src/hooks/useLanguageAwareRouting.ts
import { useTranslation as useTranslation5 } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
var SUPPORTED_LANGUAGES = ["en", "de", "fr", "es", "pt", "zh", "th", "ar"];
function useLanguageAwareRouting() {
  const { i18n: i18n2 } = useTranslation5();
  const location = useLocation();
  const navigate = useNavigate();
  const getCurrentLanguage = () => {
    const path = location.pathname;
    const match = path.match(/^\/([a-z]{2})(?:\/|$)/);
    if (match && SUPPORTED_LANGUAGES.includes(match[1])) {
      return match[1];
    }
    if (i18n2.language && SUPPORTED_LANGUAGES.includes(i18n2.language)) {
      return i18n2.language;
    }
    return "en";
  };
  const createLanguageURL = (path, language) => {
    const lang = language || getCurrentLanguage();
    if (!path.startsWith("/")) {
      path = "/" + path;
    }
    const cleanPath = path.replace(/^\/([a-z]{2})(\/|$)/, "$2");
    const normalizedPath = cleanPath.startsWith("/") ? cleanPath : "/" + cleanPath;
    if (lang === "en") {
      return normalizedPath;
    }
    return `/${lang}${normalizedPath}`;
  };
  const isActive = (path) => {
    const currentLang = getCurrentLanguage();
    const expectedPath = createLanguageURL(path, currentLang);
    return location.pathname === expectedPath;
  };
  const navigateWithLanguage = (path, language) => {
    navigate(createLanguageURL(path, language));
  };
  const getStoredLanguage2 = () => {
    try {
      const stored = localStorage.getItem("checkoutbay-language") || localStorage.getItem("formshive-language");
      if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
        return stored;
      }
    } catch (error) {
      console.warn("Failed to read language from localStorage:", error);
    }
    const browserLang = navigator.language.split("-")[0];
    return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : "en";
  };
  const redirectFromBaseURL2 = () => {
    const currentHash = window.location.hash;
    if (!currentHash || currentHash === "#" || currentHash === "#/") {
      const preferredLanguage = getStoredLanguage2() || i18n2.language || "en";
      let newHash;
      if (preferredLanguage === "en") {
        newHash = "#/";
      } else {
        newHash = `#/${preferredLanguage}/`;
      }
      window.location.replace(window.location.origin + window.location.pathname + newHash);
      return true;
    }
    return false;
  };
  const currentLanguage = getCurrentLanguage();
  return {
    createLanguageURL,
    isActive,
    currentLanguage,
    getCurrentLanguage,
    navigateWithLanguage,
    redirectFromBaseURL: redirectFromBaseURL2,
    getStoredLanguage: getStoredLanguage2
  };
}

// src/hooks/useSessionCheck.ts
import { useEffect as useEffect4, useRef as useRef2 } from "react";
function useSessionCheck({
  auth,
  isLoggedIn,
  logout,
  checkInterval = 1e4
}) {
  const { createLanguageURL } = useLanguageAwareRouting();
  const consecutiveFailures = useRef2(0);
  const maxConsecutiveFailures = 3;
  const isCheckingRef = useRef2(false);
  const checkSession = async () => {
    if (!isLoggedIn || isCheckingRef.current) {
      return;
    }
    isCheckingRef.current = true;
    try {
      console.debug("Checking session...");
      if (!auth?.hasValidSession()) {
        console.warn("Refresh token expired. Logging out.");
        consecutiveFailures.current = 0;
        await logout();
        window.location.replace(createLanguageURL("/"));
        return;
      }
      if (!auth?.hasValidAccessToken()) {
        if (consecutiveFailures.current >= maxConsecutiveFailures) {
          console.warn(`Too many consecutive refresh failures (${consecutiveFailures.current}), logging out`);
          await logout();
          window.location.replace(createLanguageURL("/"));
          return;
        }
        console.info("Access token expired. Refreshing...");
        try {
          await auth?.refresh();
          consecutiveFailures.current = 0;
          console.debug("Token refresh successful");
        } catch (error) {
          consecutiveFailures.current++;
          console.warn(`Token refresh failed (attempt ${consecutiveFailures.current}/${maxConsecutiveFailures}):`, error);
          if (error.message?.includes("Authentication failed") || error.message?.includes("Maximum refresh attempts exceeded") || consecutiveFailures.current >= maxConsecutiveFailures) {
            console.warn("Session invalidated, logging out");
            await logout();
            window.location.replace(createLanguageURL("/"));
          }
        }
      } else {
        consecutiveFailures.current = 0;
      }
    } finally {
      isCheckingRef.current = false;
    }
  };
  useEffect4(() => {
    checkSession();
    const intervalId = setInterval(checkSession, checkInterval);
    return () => clearInterval(intervalId);
  }, [isLoggedIn, checkInterval]);
  return { checkSession };
}

// src/hooks/usePagination.ts
import { useState as useState7, useCallback, useEffect as useEffect5 } from "react";
function usePagination({
  perPage = 10,
  initialPage = 1,
  fetchData,
  additionalParams = {}
}) {
  const [data, setData] = useState7([]);
  const [loading, setLoading] = useState7(false);
  const [error, setError] = useState7(null);
  const [total, setTotal] = useState7(0);
  const [page, setPage] = useState7(initialPage);
  const [currentAdditionalParams, setCurrentAdditionalParams] = useState7(additionalParams);
  const loadData = useCallback(async (targetPage, params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchData({
        nextPage: targetPage,
        ...currentAdditionalParams,
        ...params
      });
      setData(result.data);
      setTotal(result.total);
      setPage(targetPage);
      return result.data;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch data");
      setData([]);
      setTotal(0);
      return [];
    } finally {
      setLoading(false);
    }
  }, [fetchData, currentAdditionalParams]);
  const refetch = useCallback(() => {
    loadData(page);
  }, [loadData, page]);
  const handleSetPage = useCallback(async (newPage) => {
    return loadData(newPage);
  }, [loadData]);
  const setAdditionalParams = useCallback((params) => {
    setCurrentAdditionalParams(params);
    loadData(1, params);
  }, [loadData]);
  const loadPage = useCallback(async (targetPage, params = {}) => {
    return loadData(targetPage, params);
  }, [loadData]);
  useEffect5(() => {
    loadData(initialPage);
  }, []);
  const paginationConfig = {
    total,
    initial: initialPage,
    perPage
  };
  return {
    data,
    loading,
    error,
    total,
    page,
    perPage,
    paginationConfig,
    refetch,
    setPage: handleSetPage,
    setAdditionalParams,
    loadPage
  };
}

// src/components/Entity/EntityCreatePage.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function GeneralizedCreatePage({
  CreateComponent,
  createFunction,
  redirectPath
}) {
  const nav = useNavigate2();
  const { createLanguageURL } = useLanguageAwareRouting();
  const submit = async (params, newItem) => {
    const item = await createFunction(params, newItem);
    nav(createLanguageURL(redirectPath(item)));
  };
  return /* @__PURE__ */ jsx14(CreateComponent, { submitFormCb: submit });
}

// src/components/Entity/EntityFormCreate.tsx
import { axiosFieldValidationErrorToFormErrors, hasFieldValidationError } from "@gofranz/common";
import { Button as Button4, Text as Text10, Title as Title3 } from "@mantine/core";
import { useForm as useForm3 } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState as useState8 } from "react";
import { Fragment as Fragment8, jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
function EntityFormCreate({
  title,
  description,
  initialValues,
  validation,
  submitFormCb,
  renderFields,
  primaryEntityId
}) {
  const [isBusy, setIsBusy] = useState8(false);
  const [error, setError] = useState8("");
  const setLoading = (loading) => {
    setIsBusy(loading);
  };
  const getInitialValidation = () => {
    if (typeof validation === "function") {
      const result = validation(initialValues);
      return result;
    }
    return validation;
  };
  const form = useForm3({
    mode: "controlled",
    initialValues,
    validate: getInitialValidation()
  });
  const handleFormSubmit = async (values) => {
    if (typeof validation === "function") {
      const validationRules = validation(values);
      const errors = {};
      if (validationRules) {
        Object.entries(validationRules).forEach(([fieldName, validator]) => {
          if (validator && typeof validator === "function") {
            const fieldValue = values[fieldName];
            const error2 = validator(fieldValue);
            if (error2) {
              errors[fieldName] = error2;
            }
          }
        });
      }
      if (Object.keys(errors).length > 0) {
        form.setErrors(errors);
        showWarningNotification(
          "Validation Error",
          "Please fix the highlighted fields and try again.",
          notifications
        );
        return;
      }
    } else {
      const validationResult = form.validate();
      if (validationResult.hasErrors) {
        showWarningNotification(
          "Validation Error",
          "Please fix the highlighted fields and try again.",
          notifications
        );
        return;
      }
    }
    await submitForm({
      primaryEntityId
    }, values);
  };
  const submitForm = async (params, data) => {
    setIsBusy(true);
    try {
      setSubmittedValues(data);
      await submitFormCb(params, data);
      setError("");
    } catch (e) {
      setError(`${e}`);
      if (hasFieldValidationError(e)) {
        console.log(axiosFieldValidationErrorToFormErrors(e));
        form.setErrors(axiosFieldValidationErrorToFormErrors(e));
      }
    } finally {
      setIsBusy(false);
    }
  };
  const [submittedValues, setSubmittedValues] = useState8(null);
  return /* @__PURE__ */ jsxs10(Fragment8, { children: [
    /* @__PURE__ */ jsx15(Title3, { order: 3, children: title }),
    description && /* @__PURE__ */ jsx15(Text10, { children: description }),
    /* @__PURE__ */ jsxs10("form", { onSubmit: form.onSubmit(handleFormSubmit), children: [
      renderFields({
        form,
        submittedValues,
        setParentLoading: setLoading,
        primaryEntityId,
        entityId: void 0,
        // Not needed for creation
        isEditing: false
      }),
      /* @__PURE__ */ jsx15(Button4, { type: "submit", loading: isBusy, disabled: isBusy, mt: "xs", children: "Create" })
    ] }),
    error && /* @__PURE__ */ jsx15(Text10, { c: "red", children: error })
  ] });
}

// src/components/Entity/EntityFormEdit.tsx
import { Button as Button5, Text as Text11, Title as Title4 } from "@mantine/core";
import { useForm as useForm4 } from "@mantine/form";
import { notifications as notifications2 } from "@mantine/notifications";
import { useState as useState9 } from "react";
import { axiosFieldValidationErrorToFormErrors as axiosFieldValidationErrorToFormErrors2, hasFieldValidationError as hasFieldValidationError2 } from "@gofranz/common";
import { Fragment as Fragment9, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
function EntityFormEdit({
  title,
  description,
  initialValues,
  validation,
  submitFormCb,
  id,
  renderFields,
  primaryEntityId
}) {
  const [isBusy, setIsBusy] = useState9(false);
  const [error, setError] = useState9("");
  const setLoading = (loading) => {
    setIsBusy(loading);
  };
  const convertEntityToEdit = (entity) => {
    return entity;
  };
  const getInitialValidation = () => {
    if (typeof validation === "function") {
      const editValues = convertEntityToEdit(initialValues);
      const result = validation(editValues);
      return result;
    }
    return validation;
  };
  const form = useForm4({
    mode: "controlled",
    initialValues: convertEntityToEdit(initialValues),
    validate: getInitialValidation()
  });
  const handleFormSubmit = async (values) => {
    if (typeof validation === "function") {
      const validationRules = validation(values);
      const errors = {};
      if (validationRules) {
        Object.entries(validationRules).forEach(([fieldName, validator]) => {
          if (validator && typeof validator === "function") {
            const fieldValue = values[fieldName];
            const error2 = validator(fieldValue);
            if (error2) {
              errors[fieldName] = error2;
            }
          }
        });
      }
      if (Object.keys(errors).length > 0) {
        form.setErrors(errors);
        showWarningNotification(
          "Validation Error",
          "Please fix the highlighted fields and try again.",
          notifications2
        );
        return;
      }
    } else {
      const validationResult = form.validate();
      if (validationResult.hasErrors) {
        showWarningNotification(
          "Validation Error",
          "Please fix the highlighted fields and try again.",
          notifications2
        );
        return;
      }
    }
    await submitForm(values);
  };
  const submitForm = async (data) => {
    setIsBusy(true);
    try {
      setSubmittedValues(data);
      await submitFormCb({
        primaryEntityId,
        entityId: id
      }, data);
      setError("");
    } catch (e) {
      setError(`${e}`);
      if (hasFieldValidationError2(e)) {
        console.log(axiosFieldValidationErrorToFormErrors2(e));
        form.setErrors(axiosFieldValidationErrorToFormErrors2(e));
      }
    } finally {
      setIsBusy(false);
    }
  };
  const [submittedValues, setSubmittedValues] = useState9(null);
  return /* @__PURE__ */ jsxs11(Fragment9, { children: [
    /* @__PURE__ */ jsx16(Title4, { order: 3, children: title }),
    description && /* @__PURE__ */ jsx16(Text11, { children: description }),
    /* @__PURE__ */ jsxs11("form", { onSubmit: form.onSubmit(handleFormSubmit), children: [
      renderFields({
        form,
        submittedValues,
        setParentLoading: setLoading,
        primaryEntityId,
        entityId: id,
        isEditing: true
      }),
      /* @__PURE__ */ jsx16(Button5, { type: "submit", loading: isBusy, disabled: isBusy, mt: "xs", children: "Update" })
    ] }),
    error && /* @__PURE__ */ jsx16(Text11, { c: "red", children: error })
  ] });
}

// src/components/Entity/EntityViewPage.tsx
import { useEffect as useEffect6, useState as useState10 } from "react";
import { useParams } from "react-router-dom";
import { Fragment as Fragment10, jsx as jsx17 } from "react/jsx-runtime";
var ViewPageMode = /* @__PURE__ */ ((ViewPageMode2) => {
  ViewPageMode2["View"] = "view";
  ViewPageMode2["Edit"] = "edit";
  ViewPageMode2["AltView"] = "altView";
  ViewPageMode2["AltView2"] = "altView2";
  ViewPageMode2["AltView3"] = "altView3";
  return ViewPageMode2;
})(ViewPageMode || {});
function GeneralizedViewPage({
  DetailComponent,
  getFunction,
  submitCb,
  deleteCb
}) {
  const { primary_entity_id, entity_id } = useParams();
  const [item, setItem] = useState10(void 0);
  useEffect6(() => {
    const getItem = async () => {
      if (!primary_entity_id || !entity_id) {
        return;
      }
      const res = await getFunction({
        primaryEntityId: primary_entity_id,
        entityId: entity_id
      });
      if (res) {
        setItem(res);
      }
    };
    getItem();
  }, [primary_entity_id, entity_id, getFunction]);
  const reload = async () => {
    if (!primary_entity_id || !entity_id) {
      return;
    }
    const res = await getFunction({
      primaryEntityId: primary_entity_id,
      entityId: entity_id
    });
    if (res) {
      setItem(res);
    }
  };
  return /* @__PURE__ */ jsx17(Fragment10, { children: item && /* @__PURE__ */ jsx17(
    DetailComponent,
    {
      item,
      submitCb: submitCb || (async () => {
        console.log("submitCb not implemented");
      }),
      deleteCb: deleteCb || (async () => {
        console.log("deleteCb not implemented");
      }),
      reload: reload || (async () => {
        console.log("reload not implemented");
      })
    }
  ) });
}

// src/components/index.ts
var News2 = withLibraryI18n(News);
var VerifiedEmailComponent2 = withLibraryI18n(VerifiedEmailComponent);

// src/pages/LoginPage.tsx
import {
  Box as Box3,
  Button as Button6,
  Card as Card2,
  Center as Center2,
  Group as Group3,
  Stack as Stack3,
  Text as Text12,
  Title as Title5,
  alpha,
  useComputedColorScheme
} from "@mantine/core";
import { LOGIN_METHOD as LOGIN_METHOD2 } from "@gofranz/common";
import { useState as useState11 } from "react";
import { useTranslation as useTranslation6 } from "react-i18next";
import { Link, useNavigate as useNavigate3 } from "react-router-dom";
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
function LoginPage(props) {
  const { t } = useTranslation6();
  const isDark = useComputedColorScheme("light") === "dark";
  const [hasNewAccountButton, setHasNewAccountButton] = useState11(props.showSignupButton !== false);
  const nav = useNavigate3();
  const { createLanguageURL } = useLanguageAwareRouting();
  const {
    login,
    loginChallenge,
    verify2FA,
    onLoginSuccess,
    signupRoute = "/signup",
    titleGradient = { from: "pink", to: "yellow" },
    titleClassName,
    loginMethods = [LOGIN_METHOD2.NOSTR, LOGIN_METHOD2.GITHUB, LOGIN_METHOD2.GOOGLE, LOGIN_METHOD2.EMAIL_MAGIC_LINK, LOGIN_METHOD2.MICROSOFT]
  } = props;
  const loginCb = async (loginRequest) => {
    setHasNewAccountButton(false);
    return login(loginRequest);
  };
  const loginDoneCb = () => {
    if (onLoginSuccess) {
      onLoginSuccess();
    } else {
      nav(createLanguageURL("/account"));
    }
  };
  return /* @__PURE__ */ jsx18(Center2, { h: "100vh", children: /* @__PURE__ */ jsxs12(Stack3, { align: "center", children: [
    /* @__PURE__ */ jsx18(Title5, { order: 1, className: titleClassName, ta: "center", children: /* @__PURE__ */ jsx18(
      Text12,
      {
        inherit: true,
        variant: "gradient",
        component: "span",
        gradient: titleGradient,
        children: t("auth.login")
      }
    ) }),
    /* @__PURE__ */ jsx18(
      Card2,
      {
        miw: 300,
        maw: 400,
        p: "md",
        bg: isDark ? alpha("var(--mantine-color-gray-8)", 0.6) : alpha("var(--mantine-color-gray-0)", 0.6),
        children: /* @__PURE__ */ jsx18(
          Login,
          {
            login: loginCb,
            loginChallenge,
            verify2FA,
            loginDoneCb,
            loginMethods
          }
        )
      }
    ),
    hasNewAccountButton && /* @__PURE__ */ jsx18(Box3, { p: "md", children: /* @__PURE__ */ jsxs12(Group3, { justify: "center", children: [
      /* @__PURE__ */ jsx18(Text12, { children: t("auth.newHere") }),
      /* @__PURE__ */ jsx18(
        Button6,
        {
          component: Link,
          to: signupRoute,
          variant: "light",
          size: "compact-md",
          color: "dark",
          children: t("auth.howToSignup")
        }
      )
    ] }) })
  ] }) });
}

// src/pages/LoginCallbackPage.tsx
import {
  Card as Card3,
  Center as Center3,
  Stack as Stack4,
  Text as Text13,
  Title as Title6,
  alpha as alpha2,
  useComputedColorScheme as useComputedColorScheme2
} from "@mantine/core";
import { useTranslation as useTranslation7 } from "react-i18next";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
function LoginCallbackPage(props) {
  const { t } = useTranslation7();
  const isDark = useComputedColorScheme2("light") === "dark";
  const nav = useNavigate4();
  const { createLanguageURL } = useLanguageAwareRouting();
  const {
    setSession,
    onLoginSuccess,
    titleGradient = { from: "pink", to: "yellow" },
    titleClassName
  } = props;
  const loginDoneCb = () => {
    if (onLoginSuccess) {
      onLoginSuccess();
    } else {
      nav(createLanguageURL("/account"));
    }
  };
  return /* @__PURE__ */ jsx19(Center3, { h: "100vh", children: /* @__PURE__ */ jsxs13(Stack4, { children: [
    /* @__PURE__ */ jsx19(Title6, { order: 1, className: titleClassName, ta: "center", children: /* @__PURE__ */ jsx19(
      Text13,
      {
        inherit: true,
        variant: "gradient",
        component: "span",
        gradient: titleGradient,
        children: t("login.loggingIn")
      }
    ) }),
    /* @__PURE__ */ jsx19(
      Card3,
      {
        maw: 400,
        p: "md",
        bg: isDark ? alpha2("var(--mantine-color-gray-8)", 0.6) : alpha2("var(--mantine-color-gray-0)", 0.6),
        children: /* @__PURE__ */ jsx19(
          LoginCallback,
          {
            setSession,
            loginDoneCb,
            apiBaseUrl: props.apiBaseUrl
          }
        )
      }
    )
  ] }) });
}

// src/pages/Login2FAPage.tsx
import { decodeSessionTokens as decodeSessionTokens2 } from "@gofranz/common";
import {
  Button as Button7,
  Card as Card4,
  Center as Center4,
  PinInput as PinInput2,
  Stack as Stack5,
  Text as Text14,
  Title as Title7,
  alpha as alpha3,
  useComputedColorScheme as useComputedColorScheme3
} from "@mantine/core";
import { IconShieldLock as IconShieldLock2 } from "@tabler/icons-react";
import { useEffect as useEffect7, useState as useState12 } from "react";
import { useTranslation as useTranslation8 } from "react-i18next";
import { useNavigate as useNavigate5 } from "react-router-dom";
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
function Login2FAPage(props) {
  const { t } = useTranslation8();
  const isDark = useComputedColorScheme3("light") === "dark";
  const nav = useNavigate5();
  const { createLanguageURL } = useLanguageAwareRouting();
  const {
    setSession,
    verify2FA,
    onLoginSuccess,
    titleGradient = { from: "pink", to: "yellow" },
    titleClassName
  } = props;
  const [pendingToken, setPendingToken] = useState12(null);
  const [loginMethod, setLoginMethod] = useState12(null);
  const [code, setCode] = useState12("");
  const [isBusy, setIsBusy] = useState12(false);
  const [hasError, setHasError] = useState12(null);
  useEffect7(() => {
    const url = new URL(window.location.href);
    const hashParams = new URLSearchParams(url.hash.split("?")[1]);
    const token = hashParams.get("pending_token");
    const method = hashParams.get("login_method");
    if (!token) {
      setHasError(t("login.invalid2FASession"));
      return;
    }
    setPendingToken(token);
    setLoginMethod(method);
  }, [t]);
  const handleVerify = async () => {
    if (!pendingToken || code.length < 6) return;
    setIsBusy(true);
    setHasError(null);
    try {
      const result = await verify2FA({
        pending_token: pendingToken,
        code
      });
      setSession({
        isLoggedIn: true,
        userId: result.user_id,
        accessToken: result.access_token,
        refreshToken: result.refresh_token,
        expiresAt: result.expires_at,
        ...decodeSessionTokens2({
          access_token: result.access_token,
          refresh_token: result.refresh_token
        }),
        method: loginMethod
      });
      if (onLoginSuccess) {
        onLoginSuccess();
      } else {
        nav(createLanguageURL("/account"));
      }
    } catch (e) {
      console.error(e);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.message) {
        setHasError(errorData.message);
      } else if (e?.response?.status === 401) {
        setHasError(t("login.invalid2FACode"));
      } else if (e?.response?.status === 429) {
        setHasError(t("login.tooMany2FAAttempts"));
        nav(createLanguageURL("/login"));
      } else {
        setHasError(`Error: ${e?.message || e}`);
      }
      setCode("");
    } finally {
      setIsBusy(false);
    }
  };
  const handleBack = () => {
    nav(createLanguageURL("/login"));
  };
  return /* @__PURE__ */ jsx20(Center4, { h: "100vh", children: /* @__PURE__ */ jsxs14(Stack5, { children: [
    /* @__PURE__ */ jsx20(Title7, { order: 1, className: titleClassName, ta: "center", children: /* @__PURE__ */ jsx20(
      Text14,
      {
        inherit: true,
        variant: "gradient",
        component: "span",
        gradient: titleGradient,
        children: t("login.twoFactorAuth")
      }
    ) }),
    /* @__PURE__ */ jsx20(
      Card4,
      {
        maw: 400,
        p: "xl",
        bg: isDark ? alpha3("var(--mantine-color-gray-8)", 0.6) : alpha3("var(--mantine-color-gray-0)", 0.6),
        children: pendingToken ? /* @__PURE__ */ jsxs14(Stack5, { gap: "md", align: "center", children: [
          /* @__PURE__ */ jsx20(IconShieldLock2, { size: 48, stroke: 1.5 }),
          /* @__PURE__ */ jsx20(Text14, { size: "lg", fw: 500, children: t("login.twoFactorRequired") }),
          /* @__PURE__ */ jsx20(Text14, { size: "sm", c: "dimmed", ta: "center", children: t("login.enterTwoFactorCode") }),
          /* @__PURE__ */ jsx20(
            PinInput2,
            {
              length: 6,
              type: "number",
              value: code,
              onChange: setCode,
              oneTimeCode: true,
              disabled: isBusy,
              size: "lg"
            }
          ),
          hasError && /* @__PURE__ */ jsx20(Text14, { c: "red", size: "sm", ta: "center", children: hasError }),
          /* @__PURE__ */ jsx20(
            Button7,
            {
              onClick: handleVerify,
              loading: isBusy,
              disabled: code.length < 6,
              fullWidth: true,
              children: t("login.verify")
            }
          ),
          /* @__PURE__ */ jsx20(Text14, { size: "sm", c: "dimmed", ta: "center", children: t("login.useRecoveryCode") }),
          /* @__PURE__ */ jsx20(
            Button7,
            {
              variant: "subtle",
              size: "xs",
              onClick: handleBack,
              children: t("login.back")
            }
          )
        ] }) : /* @__PURE__ */ jsxs14(Stack5, { gap: "md", align: "center", children: [
          hasError && /* @__PURE__ */ jsx20(Text14, { c: "red", size: "sm", ta: "center", children: hasError }),
          /* @__PURE__ */ jsx20(Button7, { onClick: handleBack, children: t("login.backToLogin") })
        ] })
      }
    )
  ] }) });
}

// src/pages/MagicLinkLoginPage.tsx
import {
  Card as Card5,
  Center as Center5,
  Stack as Stack6,
  Text as Text15,
  Title as Title8,
  alpha as alpha4,
  useComputedColorScheme as useComputedColorScheme4
} from "@mantine/core";
import { LOGIN_METHOD as LOGIN_METHOD3 } from "@gofranz/common";
import { useEffect as useEffect8, useState as useState13 } from "react";
import { useTranslation as useTranslation9 } from "react-i18next";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { jsx as jsx21, jsxs as jsxs15 } from "react/jsx-runtime";
function MagicLinkLoginPage(props) {
  const { t } = useTranslation9();
  const isDark = useComputedColorScheme4("light") === "dark";
  const [errors, setErrors] = useState13([]);
  const [isBusy, setIsBusy] = useState13(false);
  const nav = useNavigate6();
  const { createLanguageURL } = useLanguageAwareRouting();
  const {
    loginChallenge,
    onLoginSuccess,
    titleGradient = { from: "pink", to: "yellow" },
    titleClassName
  } = props;
  const submitChallenge = async (id, challenge) => {
    setIsBusy(true);
    try {
      await loginChallenge({
        type: LOGIN_METHOD3.EMAIL_MAGIC_LINK,
        content: {
          id,
          challenge
        }
      });
      setIsBusy(false);
      if (onLoginSuccess) {
        onLoginSuccess();
      } else {
        nav(createLanguageURL("/account"));
      }
    } catch (e) {
      console.error(e);
      setIsBusy(false);
      const errorData = e?.response?.data;
      if (errorData && typeof errorData === "object" && errorData.error && errorData.message) {
        switch (errorData.error) {
          case "invalid_auth_method":
            setErrors([t("login.errorDifferentAuthMethod"), errorData.message]);
            break;
          case "email_not_primary":
            setErrors([t("login.errorNotPrimaryEmail"), errorData.message]);
            break;
          case "invalid_challenge":
          case "challenge_mismatch":
            setErrors([t("login.invalidMagicLink"), errorData.message]);
            break;
          default:
            setErrors([t("login.somethingWrong"), errorData.message]);
        }
      } else {
        const errorMessage = e?.message || e?.toString() || "";
        setErrors([t("login.somethingWrong"), errorMessage]);
      }
    }
  };
  useEffect8(() => {
    const login = async () => {
      const url = new URL(window.location.href);
      const hashParams = new URLSearchParams(url.hash.split("?")[1]);
      const urlParamChallenge = hashParams.get("challenge");
      const urlParamId = hashParams.get("id");
      const loginErrors = [];
      if (urlParamId && urlParamChallenge) {
        await submitChallenge(urlParamId, urlParamChallenge);
      } else {
        if (!urlParamId) {
          loginErrors.push(t("login.noIdProvided"));
        }
        if (!urlParamChallenge) {
          loginErrors.push(t("login.noChallengeProvided"));
        }
        setErrors(loginErrors);
      }
    };
    login();
  }, []);
  return /* @__PURE__ */ jsx21(Center5, { h: "100vh", children: /* @__PURE__ */ jsxs15(Stack6, { children: [
    /* @__PURE__ */ jsx21(Title8, { order: 1, className: titleClassName, ta: "center", children: /* @__PURE__ */ jsx21(
      Text15,
      {
        inherit: true,
        variant: "gradient",
        component: "span",
        gradient: titleGradient,
        children: t("auth.login")
      }
    ) }),
    /* @__PURE__ */ jsx21(
      Card5,
      {
        maw: 400,
        p: "md",
        bg: isDark ? alpha4("var(--mantine-color-gray-8)", 0.6) : alpha4("var(--mantine-color-gray-0)", 0.6),
        children: isBusy ? /* @__PURE__ */ jsx21(Stack6, { gap: "md", children: /* @__PURE__ */ jsx21(Title8, { order: 3, children: t("login.processing") }) }) : errors.length > 0 ? /* @__PURE__ */ jsxs15(Stack6, { gap: "md", children: [
          /* @__PURE__ */ jsx21(Title8, { order: 4, children: t("login.somethingWrong") }),
          errors.map((error, index) => /* @__PURE__ */ jsx21(Text15, { c: index === 0 ? "red" : "dimmed", children: error }, index))
        ] }) : /* @__PURE__ */ jsx21(Text15, { children: t("login.somethingWrong") })
      }
    )
  ] }) });
}

// src/pages/SignupPage.tsx
import {
  Anchor as Anchor2,
  Button as Button8,
  Card as Card6,
  Center as Center6,
  Stack as Stack7,
  Text as Text16,
  Title as Title9,
  alpha as alpha5,
  useComputedColorScheme as useComputedColorScheme5
} from "@mantine/core";
import { IconBrandGoogle as IconBrandGoogle2, IconBrandGithub as IconBrandGithub2, IconBrowser as IconBrowser2, IconRecordMail as IconRecordMail2, IconBrandWindows as IconBrandWindows2 } from "@tabler/icons-react";
import { useTranslation as useTranslation10 } from "react-i18next";
import { Link as Link2 } from "react-router-dom";
import { LOGIN_METHOD as LOGIN_METHOD4 } from "@gofranz/common";
import { Fragment as Fragment11, jsx as jsx22, jsxs as jsxs16 } from "react/jsx-runtime";
function SignupPage(props) {
  const { t } = useTranslation10();
  const { createLanguageURL } = useLanguageAwareRouting();
  const isDark = useComputedColorScheme5("light") === "dark";
  const {
    titleGradient = { from: "pink", to: "yellow" },
    titleClassName,
    loginMethods = [LOGIN_METHOD4.NOSTR, LOGIN_METHOD4.GITHUB, LOGIN_METHOD4.GOOGLE, LOGIN_METHOD4.EMAIL_MAGIC_LINK, LOGIN_METHOD4.MICROSOFT]
  } = props;
  const hasGoogleLogin = loginMethods?.includes(LOGIN_METHOD4.GOOGLE);
  const hasGithubLogin = loginMethods?.includes(LOGIN_METHOD4.GITHUB);
  const hasMicrosoftLogin = loginMethods?.includes(LOGIN_METHOD4.MICROSOFT);
  const hasNostrLogin = loginMethods?.includes(LOGIN_METHOD4.NOSTR);
  const hasEmailMagicLinkLogin = loginMethods?.includes(LOGIN_METHOD4.EMAIL_MAGIC_LINK);
  return /* @__PURE__ */ jsx22(Center6, { h: "100vh", children: /* @__PURE__ */ jsxs16(Stack7, { align: "center", children: [
    /* @__PURE__ */ jsx22(Title9, { order: 1, className: titleClassName, ta: "center", children: /* @__PURE__ */ jsx22(Text16, { inherit: true, variant: "gradient", component: "span", gradient: titleGradient, children: t("auth.signup") }) }),
    /* @__PURE__ */ jsxs16(
      Card6,
      {
        maw: 400,
        p: "md",
        bg: isDark ? alpha5("var(--mantine-color-gray-8)", 0.6) : alpha5("var(--mantine-color-gray-0)", 0.6),
        children: [
          /* @__PURE__ */ jsx22(Text16, { children: t("auth.alreadyAccount") }),
          hasEmailMagicLinkLogin && /* @__PURE__ */ jsxs16(Fragment11, { children: [
            /* @__PURE__ */ jsxs16(Title9, { order: 3, mt: "md", children: [
              /* @__PURE__ */ jsx22(IconRecordMail2, { size: "1.1rem" }),
              " ",
              t("auth.emailSection")
            ] }),
            /* @__PURE__ */ jsx22(Text16, { mb: "xs", children: t("auth.signupDescription") }),
            /* @__PURE__ */ jsx22(
              Button8,
              {
                component: Link2,
                to: createLanguageURL("/login?kind=EMAIL_MAGIC_LINK"),
                variant: "light",
                children: t("auth.signupLoginEmail")
              }
            )
          ] }),
          hasGoogleLogin && /* @__PURE__ */ jsxs16(Fragment11, { children: [
            /* @__PURE__ */ jsxs16(Title9, { order: 3, mt: "md", children: [
              /* @__PURE__ */ jsx22(IconBrandGoogle2, { size: "1.1rem" }),
              " ",
              t("auth.googleSection")
            ] }),
            /* @__PURE__ */ jsx22(Text16, { mb: "xs", children: t("auth.googleDescription") }),
            /* @__PURE__ */ jsx22(
              Button8,
              {
                component: Link2,
                to: createLanguageURL("/login?kind=GOOGLE"),
                variant: "light",
                children: t("auth.signupLoginGoogle")
              }
            )
          ] }),
          hasGithubLogin && /* @__PURE__ */ jsxs16(Fragment11, { children: [
            /* @__PURE__ */ jsxs16(Title9, { order: 3, mt: "md", children: [
              /* @__PURE__ */ jsx22(IconBrandGithub2, { size: "1.1rem" }),
              " ",
              t("auth.githubSection")
            ] }),
            /* @__PURE__ */ jsx22(Text16, { mb: "xs", children: t("auth.githubDescription") }),
            /* @__PURE__ */ jsx22(
              Button8,
              {
                component: Link2,
                to: createLanguageURL("/login?kind=GITHUB"),
                variant: "light",
                children: t("auth.signupLoginGithub")
              }
            )
          ] }),
          hasMicrosoftLogin && /* @__PURE__ */ jsxs16(Fragment11, { children: [
            /* @__PURE__ */ jsxs16(Title9, { order: 3, mt: "md", children: [
              /* @__PURE__ */ jsx22(IconBrandWindows2, { size: "1.1rem" }),
              " ",
              t("auth.microsoftSection")
            ] }),
            /* @__PURE__ */ jsx22(Text16, { mb: "xs", children: t("auth.microsoftDescription") }),
            /* @__PURE__ */ jsx22(
              Button8,
              {
                component: Link2,
                to: createLanguageURL("/login?kind=MICROSOFT"),
                variant: "light",
                children: t("auth.signupLoginMicrosoft")
              }
            )
          ] }),
          hasNostrLogin && /* @__PURE__ */ jsxs16(Fragment11, { children: [
            /* @__PURE__ */ jsxs16(Title9, { order: 3, mt: "md", children: [
              /* @__PURE__ */ jsx22(IconBrowser2, { size: "1.1rem" }),
              " ",
              t("auth.nostrSection")
            ] }),
            /* @__PURE__ */ jsxs16(Text16, { mb: "xs", children: [
              t("auth.nostrDescription"),
              /* @__PURE__ */ jsx22(Anchor2, { href: "https://blog.formshive.com/posts/get-started/", children: t("auth.browserPlugin") }),
              "."
            ] }),
            /* @__PURE__ */ jsx22(
              Button8,
              {
                component: Link2,
                to: createLanguageURL("/login?kind=NOSTR"),
                variant: "light",
                children: t("auth.signupLoginNostr")
              }
            )
          ] })
        ]
      }
    )
  ] }) });
}

// src/pages/SupportPage.tsx
import {
  Alert,
  Button as Button9,
  Card as Card7,
  Group as Group4,
  Select,
  Stack as Stack8,
  Text as Text17,
  TextInput as TextInput3,
  Textarea,
  Title as Title10
} from "@mantine/core";
import { useForm as useForm5 } from "@mantine/form";
import { IconCheck } from "@tabler/icons-react";
import { useEffect as useEffect9, useState as useState14 } from "react";
import { useTranslation as useTranslation11 } from "react-i18next";
import { Fragment as Fragment12, jsx as jsx23, jsxs as jsxs17 } from "react/jsx-runtime";
var SUBJECT_OPTIONS = [];
function SupportPage({
  session,
  formSubmissionEndpoint = "https://api.formshive.com/v1/digest/2ce22659-397b-412c-abe8-a64ce53dc4a0",
  serviceName = "Formshive"
}) {
  const { t } = useTranslation11();
  const [isSubmitting, setIsSubmitting] = useState14(false);
  const [isSubmitted, setIsSubmitted] = useState14(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState14(false);
  SUBJECT_OPTIONS = [
    { value: "general", label: t("support.types.general") },
    { value: "technical", label: t("support.types.technical") },
    { value: "feature", label: t("support.types.feature") },
    { value: "bug", label: t("support.types.bug") }
  ];
  const loginMethod = session?.method;
  const publicKey = session?.publicKey;
  const isEmailLogin = loginMethod === "EMAIL_MAGIC_LINK";
  const userEmail = isEmailLogin ? session?.email || "" : "";
  const form = useForm5({
    initialValues: {
      name: "",
      email: userEmail,
      subject: "",
      message: ""
    },
    validate: {
      email: (value) => !isEmailLogin && !/^\S+@\S+$/.test(value) ? t("forms.invalidUrl") : null,
      subject: (value) => value.trim().length > 0 ? null : "Subject is required",
      message: (value) => value.trim().length > 0 ? null : "Message is required"
    }
  });
  useEffect9(() => {
    if (isEmailLogin && userEmail) {
      form.setFieldValue("email", userEmail);
    }
  }, [userEmail, isEmailLogin]);
  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", isEmailLogin ? userEmail : values.email);
      formData.append("subject", values.subject);
      formData.append("message", values.message);
      formData.append("login_method", loginMethod || "unknown");
      formData.append("user_identifier", publicKey || "unknown");
      const response = await fetch(
        formSubmissionEndpoint,
        {
          method: "POST",
          body: formData,
          redirect: "manual"
        }
      );
      if (response.ok) {
        form.reset();
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          setIsSubmitted(true);
        }, 3e3);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Failed to submit support request:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return /* @__PURE__ */ jsxs17(Fragment12, { children: [
      /* @__PURE__ */ jsx23(Title10, { order: 2, mb: "md", children: t("support.title") }),
      /* @__PURE__ */ jsx23(Stack8, { children: /* @__PURE__ */ jsx23(Card7, { shadow: "xs", padding: "lg", radius: "md", withBorder: true, children: /* @__PURE__ */ jsxs17(Stack8, { align: "center", gap: "md", children: [
        /* @__PURE__ */ jsx23(IconCheck, { size: 48, color: "green" }),
        /* @__PURE__ */ jsx23(Title10, { order: 2, ta: "center", children: t("support.thankYou") }),
        /* @__PURE__ */ jsx23(Text17, { ta: "center", size: "lg", children: t("support.successMessage") }),
        /* @__PURE__ */ jsx23(Button9, { onClick: () => setIsSubmitted(false), variant: "light", children: t("support.submitAnother") })
      ] }) }) })
    ] });
  }
  return /* @__PURE__ */ jsxs17(Fragment12, { children: [
    /* @__PURE__ */ jsx23(Title10, { order: 2, mb: "md", children: t("support.title") }),
    /* @__PURE__ */ jsx23(Stack8, { children: /* @__PURE__ */ jsxs17(Card7, { shadow: "xs", padding: "lg", radius: "md", withBorder: true, children: [
      /* @__PURE__ */ jsx23(Title10, { order: 2, mb: "md", children: t("support.getHelp", { serviceName }) }),
      /* @__PURE__ */ jsx23(Text17, { mb: "lg", c: "dimmed", children: t("support.description") }),
      showSuccessAlert && /* @__PURE__ */ jsxs17(Alert, { color: "green", variant: "light", icon: /* @__PURE__ */ jsx23(IconCheck, { size: 16 }), mb: "md", children: [
        /* @__PURE__ */ jsx23(Text17, { fw: 500, children: t("support.successAlert") }),
        /* @__PURE__ */ jsx23(Text17, { size: "sm", children: t("support.successAlertMessage") })
      ] }),
      /* @__PURE__ */ jsx23("form", { onSubmit: form.onSubmit(handleSubmit), children: /* @__PURE__ */ jsxs17(Stack8, { gap: "md", children: [
        /* @__PURE__ */ jsxs17(Group4, { grow: true, children: [
          /* @__PURE__ */ jsx23(
            TextInput3,
            {
              label: t("support.nameLabel"),
              placeholder: t("support.namePlaceholder"),
              ...form.getInputProps("name")
            }
          ),
          !isEmailLogin && /* @__PURE__ */ jsx23(
            TextInput3,
            {
              label: t("support.emailLabel"),
              placeholder: t("support.emailPlaceholder"),
              type: "email",
              required: true,
              ...form.getInputProps("email")
            }
          ),
          isEmailLogin && /* @__PURE__ */ jsx23(
            TextInput3,
            {
              label: t("support.emailLabel"),
              value: userEmail,
              readOnly: true,
              description: t("support.loggedInEmail")
            }
          )
        ] }),
        /* @__PURE__ */ jsx23(
          Select,
          {
            label: t("support.subjectLabel"),
            placeholder: t("support.subjectPlaceholder"),
            data: SUBJECT_OPTIONS,
            required: true,
            ...form.getInputProps("subject")
          }
        ),
        /* @__PURE__ */ jsx23(
          Textarea,
          {
            label: t("support.messageLabel"),
            placeholder: t("support.messagePlaceholder"),
            minRows: 4,
            required: true,
            ...form.getInputProps("message")
          }
        ),
        /* @__PURE__ */ jsx23(Alert, { color: "blue", variant: "light", children: /* @__PURE__ */ jsxs17(Text17, { size: "sm", children: [
          t("support.formInfo"),
          loginMethod || "unknown",
          t("support.formInfoEnd")
        ] }) }),
        /* @__PURE__ */ jsx23(Group4, { justify: "flex-end", children: /* @__PURE__ */ jsx23(Button9, { type: "submit", loading: isSubmitting, disabled: isSubmitting, children: isSubmitting ? t("support.submitting") : t("support.submitButton") }) })
      ] }) })
    ] }) })
  ] });
}

// src/pages/NewsPage.tsx
import { Container } from "@mantine/core";
import { Fragment as Fragment13, jsx as jsx24, jsxs as jsxs18 } from "react/jsx-runtime";
function NewsPage(props) {
  const { blogBaseUrl, maxItems, summaryLength, footer } = props;
  return /* @__PURE__ */ jsxs18(Fragment13, { children: [
    /* @__PURE__ */ jsx24(Container, { mt: "xl", mb: "xl", children: /* @__PURE__ */ jsx24(
      News,
      {
        blogBaseUrl,
        maxItems,
        summaryLength
      }
    ) }),
    footer
  ] });
}

// src/pages/PrivacyPage.tsx
import { Box as Box4, Center as Center7, Container as Container2, Stack as Stack9, Text as Text18 } from "@mantine/core";
import { useEffect as useEffect10, useState as useState15 } from "react";
import { useTranslation as useTranslation12 } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Fragment as Fragment14, jsx as jsx25, jsxs as jsxs19 } from "react/jsx-runtime";
function PrivacyPage(props) {
  const { i18n: i18n2 } = useTranslation12();
  const { supportEmail, footer } = props;
  const [content, setContent] = useState15("");
  useEffect10(() => {
    const loadContent = async () => {
      try {
        const response = await fetch(`/content/privacy/${i18n2.language}.md`);
        if (response.ok) {
          const text = await response.text();
          setContent(text);
        } else {
          throw new Error("Language-specific content not found");
        }
      } catch {
        try {
          const response = await fetch("/content/privacy/en.md");
          const text = await response.text();
          setContent(text);
        } catch (error) {
          console.error("Failed to load privacy content:", error);
          setContent("# Privacy Policy\n\nContent could not be loaded.");
        }
      }
    };
    loadContent();
  }, [i18n2.language]);
  const processedContent = content.replace("our support address", supportEmail);
  return /* @__PURE__ */ jsxs19(Fragment14, { children: [
    /* @__PURE__ */ jsx25(Container2, { mt: "xl", mb: "xl", children: /* @__PURE__ */ jsx25(Center7, { children: /* @__PURE__ */ jsx25(Stack9, { maw: 680, children: /* @__PURE__ */ jsx25(
      Box4,
      {
        style: {
          fontSize: "16px",
          lineHeight: "1.6"
        },
        children: /* @__PURE__ */ jsx25(
          ReactMarkdown,
          {
            components: {
              h1: ({ children }) => /* @__PURE__ */ jsx25(Text18, { size: "xl", fw: 700, mb: "md", mt: 0, children }),
              h2: ({ children }) => /* @__PURE__ */ jsx25(Text18, { size: "lg", fw: 600, mb: "sm", mt: "xl", children }),
              h3: ({ children }) => /* @__PURE__ */ jsx25(Text18, { size: "md", fw: 600, mb: "xs", mt: "lg", children }),
              p: ({ children }) => /* @__PURE__ */ jsx25(Text18, { mb: "md", mt: 0, children }),
              ul: ({ children }) => /* @__PURE__ */ jsx25(Box4, { component: "ul", mb: "md", mt: "xs", pl: "xl", children }),
              li: ({ children }) => /* @__PURE__ */ jsx25(Box4, { component: "li", mb: 4, children })
            },
            children: processedContent
          }
        )
      }
    ) }) }) }),
    footer
  ] });
}

// src/pages/TermsPage.tsx
import { Box as Box5, Center as Center8, Container as Container3, Stack as Stack10, Text as Text19 } from "@mantine/core";
import { useEffect as useEffect11, useState as useState16 } from "react";
import { useTranslation as useTranslation13 } from "react-i18next";
import ReactMarkdown2 from "react-markdown";
import { Fragment as Fragment15, jsx as jsx26, jsxs as jsxs20 } from "react/jsx-runtime";
function TermsPage(props) {
  const { i18n: i18n2 } = useTranslation13();
  const { supportEmail, footer } = props;
  const [content, setContent] = useState16("");
  useEffect11(() => {
    const loadContent = async () => {
      try {
        const response = await fetch(`/content/terms/${i18n2.language}.md`);
        if (response.ok) {
          const text = await response.text();
          setContent(text);
        } else {
          throw new Error("Language-specific content not found");
        }
      } catch {
        try {
          const response = await fetch("/content/terms/en.md");
          const text = await response.text();
          setContent(text);
        } catch (error) {
          console.error("Failed to load terms content:", error);
          setContent("# Terms of Service\n\nContent could not be loaded.");
        }
      }
    };
    loadContent();
  }, [i18n2.language]);
  const processedContent = content.replace("our support email", supportEmail);
  return /* @__PURE__ */ jsxs20(Fragment15, { children: [
    /* @__PURE__ */ jsx26(Container3, { mt: "xl", mb: "xl", children: /* @__PURE__ */ jsx26(Center8, { children: /* @__PURE__ */ jsx26(Stack10, { maw: 680, children: /* @__PURE__ */ jsx26(
      Box5,
      {
        style: {
          fontSize: "16px",
          lineHeight: "1.6"
        },
        children: /* @__PURE__ */ jsx26(
          ReactMarkdown2,
          {
            components: {
              h1: ({ children }) => /* @__PURE__ */ jsx26(Text19, { size: "xl", fw: 700, mb: "md", mt: 0, children }),
              h2: ({ children }) => /* @__PURE__ */ jsx26(Text19, { size: "lg", fw: 600, mb: "sm", mt: "xl", children }),
              h3: ({ children }) => /* @__PURE__ */ jsx26(Text19, { size: "md", fw: 600, mb: "xs", mt: "lg", children }),
              p: ({ children }) => /* @__PURE__ */ jsx26(Text19, { mb: "md", mt: 0, children }),
              ul: ({ children }) => /* @__PURE__ */ jsx26(Box5, { component: "ul", mb: "md", mt: "xs", pl: "xl", children }),
              li: ({ children }) => /* @__PURE__ */ jsx26(Box5, { component: "li", mb: 4, children })
            },
            children: processedContent
          }
        )
      }
    ) }) }) }),
    footer
  ] });
}

// src/pages/index.ts
var LoginPage2 = withLibraryI18n(LoginPage);
var LoginCallbackPage2 = withLibraryI18n(LoginCallbackPage);
var Login2FAPage2 = withLibraryI18n(Login2FAPage);
var MagicLinkLoginPage2 = withLibraryI18n(MagicLinkLoginPage);
var SignupPage2 = withLibraryI18n(SignupPage);
var SupportPage2 = withLibraryI18n(SupportPage);

// src/lib/languageDetection.ts
var SUPPORTED_LANGUAGES2 = ["en", "de", "fr", "es", "pt", "zh", "th", "ar"];
var LANGUAGE_STORAGE_KEY = "saved-language";
function getLanguageFromHash() {
  const hash = window.location.hash;
  const match = hash.match(/^#\/([a-z]{2})(?:\/|$)/);
  if (match && SUPPORTED_LANGUAGES2.includes(match[1])) {
    return match[1];
  }
  return null;
}
function getLanguageFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get("lang");
  if (langParam && SUPPORTED_LANGUAGES2.includes(langParam)) {
    return langParam;
  }
  return null;
}
function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES2.includes(stored)) {
      return stored;
    }
  } catch (error) {
    console.warn("Failed to read language from localStorage:", error);
  }
  return null;
}
function storeLanguage(language) {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    console.warn("Failed to store language in localStorage:", error);
  }
}
function getBrowserLanguage() {
  const browserLang = navigator.language.split("-")[0];
  return SUPPORTED_LANGUAGES2.includes(browserLang) ? browserLang : "en";
}
function redirectFromBaseURL() {
  const currentHash = window.location.hash;
  if (!currentHash || currentHash === "#" || currentHash === "#/") {
    const preferredLanguage = getStoredLanguage() || getBrowserLanguage();
    let newHash;
    if (preferredLanguage === "en") {
      newHash = "#/";
    } else {
      newHash = `#/${preferredLanguage}/`;
    }
    window.location.replace(window.location.origin + window.location.pathname + newHash);
    return;
  }
}
function detectAndSetLanguage(i18nInstance) {
  redirectFromBaseURL();
  const detectedLanguage = getLanguageFromHash() || getLanguageFromURL() || getStoredLanguage() || getBrowserLanguage();
  if (i18nInstance && i18nInstance.language !== detectedLanguage) {
    i18nInstance.changeLanguage(detectedLanguage);
  }
  storeLanguage(detectedLanguage);
}
function updateHashWithLanguage(language, currentPath) {
  if (!SUPPORTED_LANGUAGES2.includes(language)) {
    return;
  }
  let path = currentPath || window.location.hash.slice(1);
  const langMatch = path.match(/^\/([a-z]{2})(?:\/|$)/);
  if (langMatch && SUPPORTED_LANGUAGES2.includes(langMatch[1])) {
    path = path.replace(/^\/[a-z]{2}/, "");
  }
  if (!path.startsWith("/")) {
    path = "/" + path;
  }
  let newHash;
  if (language === "en") {
    newHash = "#" + path;
  } else {
    newHash = `#/${language}${path}`;
  }
  window.history.replaceState(null, "", newHash);
  storeLanguage(language);
}

// src/utils/notifications.ts
function parseApiError(error) {
  if (!error) {
    return {
      title: "Unknown Error",
      message: "An unknown error occurred. Please try again."
    };
  }
  if (typeof error === "string") {
    return {
      title: "Error",
      message: error
    };
  }
  if (error.response?.data) {
    if (error.response.data.error === "validation_error") {
      return parseApiFieldValidationError(error);
    }
    return parseApiErrorData(error.response.data);
  }
  if (error.error && error.message) {
    return parseApiErrorData(error);
  }
  if (error.message) {
    return {
      title: "Error",
      message: error.message
    };
  }
  return {
    title: "Error",
    message: "An unexpected error occurred. Please try again."
  };
}
function parseApiErrorData(data) {
  if (typeof data === "string") {
    return {
      title: "Error",
      message: data
    };
  }
  if (data.error && data.message) {
    return {
      title: getErrorTitle(data.error),
      message: data.message,
      error: data.error,
      action: data.action
    };
  }
  const message = data.message || data.error || data.detail || "An error occurred";
  return {
    title: "Error",
    message: typeof message === "string" ? message : "An error occurred"
  };
}
function parseApiFieldValidationError(error) {
  const responseData = error.response?.data;
  if (responseData.error !== "validation_error") {
    return {
      title: "Validation Error",
      message: "There was a validation error with your request."
    };
  }
  if (!responseData.errors || !Array.isArray(responseData.errors)) {
    return {
      title: "Validation Error",
      message: responseData.message || "There was a validation error with your request."
    };
  }
  const messages = responseData.errors.map((fieldError) => {
    return `${fieldError.field}: ${fieldError.message}`;
  }).join(", ");
  return {
    title: responseData.message,
    message: messages
  };
}
function getErrorTitle(errorCode) {
  const errorTitles = {
    "validation_error": "Validation Error",
    "authentication_error": "Authentication Error",
    "authorization_error": "Permission Denied",
    "subscription_error": "Subscription Error",
    "payment_error": "Payment Error",
    "rate_limit_error": "Rate Limit Exceeded",
    "server_error": "Server Error",
    "not_found": "Not Found",
    "conflict": "Conflict",
    "bad_request": "Bad Request",
    "expired_token": "Session Expired",
    "invalid_token": "Invalid Token",
    "invalid_session": "Invalid Session",
    "oauth_error": "Authentication Failed",
    "invalid_redirect_uri": "Invalid Redirect",
    "session_not_found": "Session Not Found",
    "email_not_found": "Email Not Found",
    "email_already_in_use": "Email In Use",
    "email_error": "Email Error",
    "invalid_email": "Invalid Email",
    "invalid_input": "Invalid Input",
    "database_error": "Server Error",
    "cache_error": "Server Error",
    // Session / auth errors
    "google_email_not_verified": "Email Not Verified",
    "invalid_auth_method_google": "Wrong Login Method",
    "invalid_auth_method_github": "Wrong Login Method",
    "invalid_auth_method_microsoft": "Wrong Login Method",
    "invalid_auth_method_nostr": "Wrong Login Method",
    "invalid_auth_method": "Wrong Login Method",
    "invalid_challenge": "Invalid Login Link",
    "challenge_mismatch": "Invalid Login Link",
    "invalid_nostr_signature": "Invalid Signature",
    "invalid_nostr_challenge": "Invalid Challenge",
    "nostr_key_mismatch": "Key Mismatch",
    "email_not_primary": "Not Primary Email",
    "too_many_attempts": "Too Many Attempts",
    "invalid_authorization_code": "Invalid Code",
    "expired_or_used_auth_code": "Code Expired",
    "invalid_2fa_code": "Invalid Code",
    // 2FA errors
    "2fa_not_enabled": "2FA Not Enabled",
    "2fa_already_enabled": "2FA Already Enabled",
    "invalid_code": "Invalid Code",
    "code_expired": "Code Expired",
    "no_recovery_codes": "No Recovery Codes",
    "invalid_method_type": "Invalid Method",
    "forbidden": "Permission Denied",
    // Token errors
    "token_not_valid_yet": "Token Not Valid Yet",
    // Session errors
    "invalid_challenge_type": "Invalid Challenge",
    "invalid_nostr_event": "Invalid Authentication",
    "invalid_request": "Invalid Request",
    // Email delivery errors
    "email_already_verified": "Already Verified",
    "email_not_verified": "Email Not Verified",
    "cannot_delete_account_email": "Cannot Delete Email",
    "inactive_recipient": "Email Undeliverable",
    "invalid_address": "Invalid Address",
    "spam_complaint": "Email Rejected",
    "hard_bounce": "Email Undeliverable",
    "service_unavailable": "Service Unavailable",
    "rate_limit_exceeded": "Rate Limit Exceeded",
    "temporary_failure": "Temporary Error",
    // Payment errors
    "payment_exists": "Payment Exists",
    "checkout_session_failed": "Checkout Failed",
    "invalid_currency": "Invalid Currency",
    "payment_gateway_not_found": "Gateway Not Found",
    "invalid_payment_gateway_owner": "Permission Denied",
    "order_not_found": "Order Not Found",
    "payment_not_found": "Payment Not Found",
    "customer_already_exists": "Customer Exists",
    "webhook_error": "Processing Error",
    // Checkoutbay validation
    "invalid_country_code": "Invalid Country",
    "invalid_region_code": "Invalid Region",
    "unexpected_region_code": "Unexpected Region",
    "expected_shop_address": "Invalid Address Type",
    "expected_customer_address": "Invalid Address Type",
    "warehouse_not_found": "Warehouse Not Found",
    "warehouse_address_not_found": "Address Not Found",
    "shipping_address_not_found": "Address Not Found",
    "billing_address_not_found": "Address Not Found",
    "product_not_found": "Product Not Found",
    "product_stock_not_found": "Out of Stock",
    "shop_owner_email_not_found": "Email Not Found",
    "shipping_rate_not_found": "Shipping Rate Not Found",
    "invalid_warehouse_owner": "Permission Denied",
    "invalid_product_owner": "Permission Denied",
    "invalid_billing_address_owner": "Permission Denied",
    "invalid_shipping_address_owner": "Permission Denied",
    "insufficient_stock": "Insufficient Stock",
    "products_not_in_same_warehouse": "Warehouse Mismatch",
    "invalid_address_kind": "Invalid Address",
    "voucher_usage_limit_exceeded": "Voucher Limit Exceeded",
    "has_associated_payments": "Has Active Payments",
    // Payment gateway
    "encryption_error": "Server Error",
    // GPT-Muse
    "rate_limited": "Rate Limited",
    "model_not_found": "Model Not Found",
    "free_tier_restriction": "Free Tier Limit",
    "unknown_model": "Unknown Model",
    "insufficient_balance": "Insufficient Balance",
    "content_moderation": "Content Blocked",
    "timeout": "Request Timeout",
    "request_timeout": "Request Timeout",
    "network_error": "Network Error",
    "service_overloaded": "Service Overloaded",
    "model_down": "Model Unavailable",
    "no_providers": "No Providers",
    "queue_full": "Service Busy",
    "no_providers_available": "No Providers",
    "no_providers_in_region": "No Regional Providers",
    "internal_error": "Server Error"
  };
  return errorTitles[errorCode] || "Error";
}
function showApiErrorNotification(error, notifications3, defaultTitle = "Error") {
  const parsed = parseApiError(error);
  let actionSuffix = "";
  if (parsed.action) {
    switch (parsed.action) {
      case "retry_later":
        actionSuffix = " Please try again later.";
        break;
      case "add_credits":
        actionSuffix = " Please add credits to your account.";
        break;
      case "contact_support":
        actionSuffix = " Please contact support for assistance.";
        break;
      case "cancel_payments_first":
        actionSuffix = " Cancel associated payments first.";
        break;
      case "request_new_code":
        actionSuffix = " Please request a new code.";
        break;
    }
  }
  const message = parsed.message;
  const finalMessage = actionSuffix && !message.toLowerCase().includes(actionSuffix.trim().toLowerCase().slice(0, 20)) ? `${message}${actionSuffix}` : message;
  notifications3.show({
    title: parsed.title || defaultTitle,
    message: finalMessage,
    color: "red",
    autoClose: 1e4
  });
}
function showSuccessNotification(title, message, notifications3) {
  notifications3.show({
    title,
    message,
    color: "green",
    autoClose: 5e3
  });
}
function showInfoNotification(title, message, notifications3) {
  notifications3.show({
    title,
    message,
    color: "blue",
    autoClose: 6e3
  });
}
function showWarningNotification(title, message, notifications3) {
  notifications3.show({
    title,
    message,
    color: "orange",
    autoClose: 7e3
  });
}

// src/utils/notification-handlers.ts
import { getErrorTitle as getErrorTitle2 } from "@gofranz/common";
function createErrorHandler(options) {
  const { notifications: notifications3, onError } = options;
  return (error) => {
    if (error.code === "ECONNABORTED" || error.message === "Network Error") {
      notifications3.show({
        title: "Connection Error",
        message: "Unable to reach the server. Please check your connection and try again.",
        color: "red",
        autoClose: 1e4
      });
      return;
    }
    if (onError) {
      onError(error);
    }
    const config = error.config;
    const customNotification = config?.notification;
    if (customNotification && "onError" in customNotification && customNotification.onError) {
      showApiErrorNotification(error, notifications3, customNotification.onError.title || getErrorTitle2(error));
    } else {
      const title = getErrorTitle2(error);
      showApiErrorNotification(error, notifications3, title);
    }
  };
}
function createSuccessHandler(options) {
  const { notifications: notifications3, onSuccess, ignoredPaths = [] } = options;
  return (response) => {
    const accepted = ["post", "put", "patch"];
    if (!accepted.includes(response.config.method || "")) {
      return;
    }
    if (ignoredPaths.some((path) => response.config.url?.includes(path))) {
      return;
    }
    if (onSuccess) {
      onSuccess(response);
    }
    const config = response.config;
    const customNotification = config?.notification;
    if (customNotification) {
      if ("onSuccess" in customNotification) {
        if (customNotification.onSuccess !== false && customNotification.onSuccess) {
          const successNotif = customNotification.onSuccess;
          showSuccessNotification(
            successNotif.title,
            successNotif.message,
            notifications3
          );
        }
      } else {
        const simpleNotif = customNotification;
        showSuccessNotification(
          simpleNotif.title,
          simpleNotif.message,
          notifications3
        );
      }
    } else {
      showSuccessNotification(
        `Request Successful`,
        `Your ${response.config.method?.toUpperCase()} request to ${response.config.url} was successful.`,
        notifications3
      );
    }
  };
}

// src/index.ts
var commonResources = {
  en: en_default,
  de: de_default,
  es: es_default,
  fr: fr_default,
  pt: pt_default,
  zh: zh_default,
  th: th_default,
  ar: ar_default
};
export {
  ColorSchemeToggle,
  CreateVerifiedEmail,
  Entity,
  EntityFormCreate,
  EntityFormEdit,
  GeneralizedCreatePage,
  GeneralizedViewPage,
  IsVerified,
  LargeTitle,
  LargeTitleWithText,
  LibraryI18nProvider,
  Login2 as Login,
  Login2FAPage2 as Login2FAPage,
  LoginCallback2 as LoginCallback,
  LoginCallbackPage2 as LoginCallbackPage,
  LoginPage2 as LoginPage,
  MagicLinkLoginPage2 as MagicLinkLoginPage,
  News2 as News,
  NewsPage,
  PrivacyPage,
  SignupPage2 as SignupPage,
  SupportPage2 as SupportPage,
  TermsPage,
  VerifiedEmailComponent2 as VerifiedEmailComponent,
  VerifiedEmailDetail,
  ViewPageMode,
  commonResources,
  createErrorHandler,
  createSuccessHandler,
  detectAndSetLanguage,
  i18n_default as libraryI18n,
  parseApiError,
  showApiErrorNotification,
  showInfoNotification,
  showSuccessNotification,
  showWarningNotification,
  storeLanguage,
  updateHashWithLanguage,
  useLanguageAwareRouting,
  usePagination,
  useSessionCheck
};
